/* eslint-disable max-lines */

export default {
  translation: {
    // Generic
    INIT_KEY: 'Starting',
    AUTO_PANEL_TITLE_KEY: 'Autosky Console',
    EXTERNAL_INFO_KEY:
      'Code external to the Autosky platform, used to identify a client',
    PANEL_KEY: 'Dashboard',
    CONFIG_KEY: 'Settings',
    COLORS_KEY: 'Colors',
    FONTS_KEY: 'Fonts',
    VISUALIZE_EDITION_KEY: 'View edit',
    ADMIN_PANEL_KEY: 'Admin panel',
    LOGIN_KEY: 'Log in',
    ADD_KEY: 'Add',
    PRODUCT_KEY: 'Product',
    FINALIZE_KEY: 'Finish',
    SUPPORT: 'Support',
    FAVORITES_KEY: 'My favorites',
    PREPARATION: 'Preparation',
    NEWS_KEY: 'News',
    ACTIVE_KEY: 'Active',
    PRIVACY_KEY: 'Privacy',
    NOT_FOUND_NOTIFICATION_KEY: 'No notifications found',
    PASSWORD_MUST_CONTAIN_KEY: 'Password must contain',
    REQUIRE_MIN_LENGTH_TEXT_KEY: 'At least {{min_length}} characters',
    REQUIRE_MAX_LENGTH_TEXT_KEY: 'At most {{max_length}} characters',
    REQUIRED_LETTER_UPPERCASE_KEY: 'At least one uppercase character',
    REQUIRED_LETTER_LOWERCASE_KEY: 'At least one lowercase character',
    REQUIRED_LETTER_TO_NUMBER_KEY: 'At least one number',
    REQUIRED_LETTER_SPECIAL_CHARACTER_KEY: 'At least one special character',
    REQUIRED_OPTION_KEY: 'Select at least one option',
    EXTEND_KEY: 'Extend',
    WORK_KEY: 'Task',
    STATE_KEY: 'State',
    OF_DAY_KEY: 'of',
    AT_HOUR_KEY: 'at',
    APPLY_KEY: 'Apply',
    REVERT_KEY: 'Revert',
    DO_NOT_APPLY_KEY: 'Do not apply',
    SEE_DETAILS_KEY: 'See details',
    ATTENTION_KEY: 'Attention',
    COPY_KEY: 'Copy',
    COPY_CLICK_HERE_KEY: 'Click here to copy',
    EDIT_KEY: 'Edit',
    DETAILS_KEY: 'Details',
    ZOHO_ID_KEY: 'ID Zoho',
    SUCCESS_KEY: 'Success',
    NOT_ENOUGH_DATA_KEY: 'Not enough data',
    CLONE_KEY: 'Clone',
    STOP_KEY: 'Stop',
    REMOVE_KEY: 'Delete',
    DELETE_KEY: 'Delete',
    BLOCK_KEY: 'Block',
    UNBLOCK_KEY: 'Unblock',
    CODE_KEY: 'Code',
    INCLUDE_APPLICATION_KEY: 'Include application',
    OPERATOR_NAME_KEY: "Operator's name",
    OPERATOR_ID_KEY: "Operator's ID",
    DISABLE_KEY: 'Disable',
    INACTIVATED_KEY: 'Disabled',
    ENABLE_KEY: 'Enable',
    TERMINATE_KEY: 'Terminate',
    SIMPLE_KEY: 'Simple',
    GO_OUT_KEY: 'Exit',
    ENTER_KEY: 'Enter',
    PLATFORM_KEY: 'Platform',
    SAVE_KEY: 'Save',
    REGISTER_KEY: 'Register',
    RECOVER_KEY: 'Recover',
    RESEND_KEY: 'Resend',
    CHANGE_KEY: 'Change',
    DUPLICATE_KEY: 'Duplicate',
    CANCEL_KEY: 'Cancel',
    CLEAR_FORM_KEY: 'Clear',
    CONFIRM_KEY: 'Confirm',
    CONNECT_KEY: 'Connect',
    DOWNLOAD_KEY: 'Download',
    EXPORT_KEY: 'Export',
    LOADING_KEY: 'Loading',
    SEARCH_KEY: 'Search',
    ACTION_KEY: 'Action',
    ACTIONS_KEY: 'Actions',
    ACTIVATE_KEY: 'Activate',
    INACTIVE_KEY: 'Inactive',
    MFA_ACTIVE_KEY: 'Active MFA',
    MFA_CONFIGURED_KEY: 'MFA in use',
    MFA_RESET_KEY: 'Reset MFA',
    ACTIVE_MFA_TO_ALL_KEY: 'Enable MFA for all users',
    STARTED_KEY: 'Started',
    REMOVING_KEY: 'Deleting',
    RECOVERING_KEY: 'Recovering',
    START_KEY: 'Start',
    REINITIALIZE_KEY: 'Restart',
    UNLINK_KEY: 'Unlink',
    BACK_KEY: 'Go back',
    STATUS_KEY: 'Status',
    OPERATION_MODE_KEY: 'Operation mode',
    OPERATION_MODE_MANUAL_KEY: 'Manual',
    OPERATION_MODE_PERIOD_KEY: 'Period',
    OPERATION_MODE_MICRO_KEY: 'Micro',
    OPERATION_MODE_SPOT_PERIOD_KEY: 'Period (Spot)',
    FLAVOR_KEY: 'Flavor',
    ID_ZOHO_KEY: 'Zoho ID',
    ZOHO_ID_ALREADY_EXISTS:
      'Zoho ID you entered is already associated with a company',
    OTHERS_KEY: 'Others',
    CLOSE_KEY: 'Close',
    CLOSED_KEY: 'Closed',
    PROFILE_KEY: 'Profile',
    INTERNAL_KEY: 'Internal',
    COMPANY_KEY: 'Company',
    COMPANIES_KEY: 'Companies',
    PARTNERS_KEY: 'Accounts',
    ENVIRONMENTS_KEY: 'Environments',
    ENVIRONMENT_KEY: 'Environment',
    PROVIDER_KEY: 'Provider',
    CLIENTS_KEY: 'Clients',
    CLIENT_KEY: 'Client',
    APPLICATIONS_KEY: 'Applications',
    REASON_KEY: 'Reason',
    APPLICATIONS_TOOLTIP_KEY:
      'In order for applications to be configured in Autosky, they need to be registered in the Autosky Platform',
    NO_ACTIONS_AVAILABLE_KEY: 'No actions available',
    NO_USERNAME_AVAILABLE_KEY: 'No username available',

    APPLICATIONS_REMOVED_KEY: 'Applications successfully removed!',
    APPLICATIONS_INACTIVE_KEY: 'Applications successfully deactivated!',
    APPLICATIONS_ACTIVE_KEY: 'Applications successfully activated!',

    WANT_ACTIVATE_APPLICATIONS_KEY: 'Activate applications',
    WANT_INACTIVATE_APPLICATIONS_KEY: 'Inactivate applications',
    WANT_REMOVE_APPLICATIONS_KEY: 'Remove applications',

    ACTIVATE_APPLICATIONS_SELECTED_DESCRIPTION_KEY:
      'Are you sure you want to activate the selected applications?',
    INACTIVATE_APPLICATIONS_SELECTED_DESCRIPTION_KEY:
      'Are you sure you want to inactivate the selected applications?',
    REMOVE_APPLICATIONS_SELECTED_DESCRIPTION_KEY:
      'Are you sure you want to remove the selected applications?',

    BUTTON_ACTIVATE_APPLICATIONS_KEY: 'Activate selected',
    BUTTON_INACTIVATE_APPLICATIONS_KEY: 'Inactivate selected',
    BUTTON_REMOVE_APPLICATIONS_KEY: 'Remove selected',

    APPLICATION_KEY: 'Add application',
    USERS_KEY: 'Users',
    USER_KEY: 'User',
    USER_AD_KEY: 'User AD code',
    OPERATORS_KEY: 'Operators',
    OPERATOR_KEY: 'Operator',
    GENERAL_KEY: 'General',
    ADMINISTRATION_KEY: 'Administration',
    DASHBOARD_KEY: 'Dashboard',
    INSTANCES_KEY: 'Instances',
    INSTANCE_KEY: 'Instance',
    SERVERS_KEY: 'Servers',
    SERVER_KEY: 'Server',
    MODELS_KEY: 'Models',
    MODEL_KEY: 'Primary model',
    SESSIONS_KEY: 'Sessions',
    IMAGE_KEY: 'Image',
    IMAGES_KEY: 'Images',
    JPEG_PNG_KEY: 'JPEG or PNG',
    ALL_KEY: 'All',
    PORT_KEY: 'Port',
    ZONE_KEY: 'Zone',
    PRIMARY_PORT_KEY: 'Primary port',
    SECONDARY_PORT_KEY: 'Secondary port',
    ROWS_PER_PAGE_KEY: 'Rows per page',
    DESCRIPTION_KEY: 'Description',
    FULL_NAME_KEY: 'Full name',
    NAME_KEY: 'Name',
    OPERATOR_VIEW_NAME_KEY: 'Client name',
    NOT_FOUND_KEY: 'Not found',
    LAST_NAME_KEY: 'Last name',
    CELLPHONE_KEY: 'Phone number',
    SUGGESTION_KEY: 'Suggestions',
    DESCRIBE_SUGGESTION_KEY: 'Enter your suggestion.',
    BUSINESS_PHONE_KEY: 'Business phone number',
    YES_KEY: 'Yes',
    SETTINGS_KEY: 'Settings',
    MAINTENANCE_KEY: 'Maintenance',
    MAINTENANCE_DISPLAY_WARNING_KEY: 'Environment with maintenance notice',
    MAINTENANCE_WARNING_KEY: 'Environment in maintenance',
    CLIENT_MAINTENANCE_WARNING_KEY: 'Client in maintenance',
    MAINTENANCE_SCHEDULED_KEY: 'Scheduled maintenance',
    MAINTENANCE_MANUAL_KEY: 'Manual maintenance',
    LOGS_KEY: 'Logs',
    LOGS_LISTING_KEY: 'Listing of environment logs',
    DOMAIN_KEY: 'Domain',
    SUBJECT_KEY: 'Subject',
    NO_KEY: 'No',
    GENERAL_ACTIONS_KEY: 'General actions',
    REMOVE_SELECT_KEY: 'Delete selected',
    RESET_PASSWORD_KEY: 'Reset password',
    MFA_ENABLE_KEY: 'Enable MFA',
    LANGUAGE_KEY: 'Language',
    EXTERNAL_KEY: 'External',
    MANAGED_KEY: 'Managed',
    CREATION_DATE_KEY: 'Creation date',
    EXPIRATION_DATE_KEY: 'Expiration date',
    START_DATE_KEY: 'Start date',
    END_DATE_KEY: 'End date',
    INITIAL_DATE_KEY: 'Initial date',
    FINAL_DATE_KEY: 'Final date',
    DATE_KEY: 'Date',
    TIME_KEY: 'Hour',
    MINUTE_KEY: 'Minute',
    MINUTES_KEY: 'Minutes',
    TYPE_KEY: 'Type',
    MESSAGE_KEY: 'Message',
    PERIOD_KEY: 'Period',
    PERIODS_KEY: 'Periods',
    PERIOD_1_KEY: 'Period 1',
    PERIOD_2_KEY: 'Period 2',
    RESTRICTION_RULE_1_KEY: 'Restriction rule 1',
    RESTRICTION_RULE_2_KEY: 'Restriction rule 2',
    TIME_ZONE_KEY: 'Time zone',
    GENERAL_INFORMATION_KEY: 'General information',
    MONITORING_KEY: 'Monitoring',
    MEMORY_KEY: 'Memory',
    CONNECTIONS_KEY: 'Connections',
    TEMPERATURE_KEY: 'Temperature',
    DAILY_VARIATION_KEY: 'Daily variation',
    LAST_HOUR_KEY: 'Last hour',
    LAST_HOUR_UNI_ONLY_KEY: 'Last',
    HOUR_KEY: 'Hour',
    LATTER_KEY: 'Latter',
    DAYS_KEY: 'Days',
    ACCESS_RATE_KEY: 'Access rate',
    VACANCIES_AVAILABLE_KEY: 'Available vacancies',
    TOTAL_KEY: 'Total',
    OCCUPIED_KEY: 'Occupied',
    BLOCKED_KEY: 'Blocked',
    UNAVAILABLE_KEY: 'Unavailable',
    MODIFIED_BY_KEY: 'Modified by',
    CREATE_DATE_KEY: 'Creation date',
    SHOW_ALERT_KEY: 'Show alert',
    ENV_DISPLAY_WARNING_ENABLED_KEY: 'Enabled in the environment',
    ENV_DISPLAY_WARNING_ENABLED_TOOLTIP_KEY: 'Environment has active warning',
    ENV_DISPLAY_WARNING_ENABLED_TOOLTIP_DATE_KEY: 'until {{date}}',
    GENERAL_SETTINGS_KEY: 'General settings',
    COUNTRY_KEY: 'Country',
    ENABLED_KEY: 'Enabled',
    DISABLED_KEY: 'Disabled',
    COPIED_KEY: 'Copied!',
    TEST_OPEN_KEY: 'Opening test',
    CONNECT_LIKE_KEY: 'Connect as',
    OBJECT_KEY: 'Object',
    START_TIME_KEY: 'Start time',
    END_TIME_KEY: 'End time',
    COMING_SOON_KEY: 'Coming soon',
    TEST_KEY: 'Test',
    MIN_LENGTH_KEY: 'At least {{value}} characters',
    MAX_LENGTH_KEY: 'At most {{value}} characters',
    NEXT_KEY: 'Next',
    PREVIOUS_KEY: 'Previous',
    GROUPS_KEY: 'Groups',
    CURRENT_KEY: 'Current',
    FIRST_PERIOD_KEY: 'First period',
    SECOND_PERIOD_KEY: 'Second period',
    LISTING_KEY: 'Listing',
    IGNORE_KEY: 'Ignore',
    MAX_VALUE_KEY: 'The maximum value for this field is {{value}}',
    MIN_VALUE_KEY: 'The minimum value of this field is {{value}}',
    ID_ZOHO_EXCEPTION: 'The Zoho ID cannot be started with 9',

    ADDITION_KEY: 'Addition',
    MODIFICATION_KEY: 'Modification',
    REMOVAL_KEY: 'Deletion',
    VISUALIZATION_KEY: 'Visualization',
    CLONING_REQUESTED_KEY: 'Cloning requested',
    CLONING_STARTED_KEY: 'Cloning started',
    CLONING_FINISHED_KEY: 'Cloning finished',
    CLONING_FAILED_KEY: 'Cloning failed',

    SHORT_WEEK_DAYS_KEY: 'S, M, T, W, T, F, S',

    // Errors
    UNEXPECTED_ERROR: 'An unexpected error has occurred',
    OPERATOR_IS_BLOCKED: 'Operator is blocked',
    OPERATOR_DOES_NOT_EXIST: 'Operator does not exist',
    MULTICLOUD_PROVIDER_NOT_SUPPORTED:
      'Environments with multicloud provider do not support servers',

    BOOT_VOLUME_KEY: 'Boot Volume',
    BOOT_VOLUME_BACKUP_KEY: 'Boot Volume Backup',
    CUSTOM_IMAGE_KEY: 'Custom Image',

    CHANGES_SAVED: 'Changes successfully saved!',
    LIST_USERS_EXPORT_FILENAME: 'List_of_Users',
    LIST_HISTORY_SESSION_EXPORT_FILENAME: 'Session_history_list',

    // Countries
    BRAZIL_KEY: 'Brazil',
    SPAIN_KEY: 'Spain',
    USA_KEY: 'United States',

    LANGUAGES: {
      PORTUGUESE_KEY: 'Brazilian portuguese',
      ENGLISH_KEY: 'English',
      SPANISH_KEY: 'Spanish',
    },
    ROLE_KEY: 'Role',
    ROLES: {
      SUPERADMIN_KEY: 'Skyone super admin',
      ADMIN_KEY: 'Skyone admin',
      OPERATOR_KEY: 'Skyone operator',
      CLIENT_OPERATOR_KEY: 'Client operator',
    },

    SESSION_EXPIRED:
      'Your session has expired or your token is invalid. Please, login again.',
    EXPIRED_SESSION_MODAL: {
      TITLE: 'Expired session!',
      HEADER: 'Your session has expired',
      MESSAGE: 'You will be redirected to the login page.',
      BUTTON_LABEL: 'Ok',
    },
    CODE_NOT_FOUND: 'Code not found',
    EXPIRED_CODE:
      "Expired code. Request a new password registration link by clicking on 'Forgot my password'",

    UPDATE_MODAL: {
      MODAL_VERSION_TITLE_KEY: 'Welcome to Autosky',
      MODAL_VERSION_CONTENT_KEY:
        'Welcome to the Autosky Dashboard. Click the button below to continue.',
      MODAL_BUTTON_KEY: 'Ok',
    },

    BACK_SELECTED_COMPANY_KEY: 'Change company',
    DO_NOT_SELECT_PARTNER_KEY: 'Do not select account',
    DO_NOT_SELECT_COMPANY_KEY: 'Do not select company',
    DO_NOT_HAVE_DASHBOARD_KEY: "You don't have any items in your favorites yet",
    TO_LIST_SELECT_COMPANY_AND_PARTNER_KEY:
      'To view this list, select a company and an account',
    DO_NOT_HAVE_PERMISSIONS_KEY:
      'You do not have permission to access this functionality. Please contact the administrator.',
    CREATE_ENVIRONMENT_COMPANY_AND_PARTNER_KEY:
      'To create an environment, select a company and an account',
    CREATE_CLIENT_COMPANY_AND_PARTNER_KEY:
      'To create a client, select a company and an account',
    TO_LIST_SELECT_COMPANY_KEY: 'To view this list, select a company',
    SELECT_COMPANY_KEY: 'Select a company',

    // TopBar
    NOTIFICATIONS_KEY: 'Notifications',
    ACTIVITY_LOG_KEY: 'Activity log',
    OPEN_TICKET_KEY: 'Open ticket',
    INCREASE_RESOURCES_KEY: 'Increase resources',
    DOCUMENTATION_KEY: 'Documentation',
    TUTORIAL_KEY: 'Autosky tutorial',
    REQUEST_SUPPORT_KEY: 'Request support',
    SEND_SUGGESTIONS_KEY: 'Send suggestions',
    CONTRACT_LICENSES_KEY: 'Purchase licenses',
    CHANGE_REGION_KEY: 'Region change',
    CHANGE_REGION_MSG_KEY: 'Login with password and MFA',
    MY_PROFILE_KEY: 'My profile',
    CHANGE_AVATAR_KEY: 'Change avatar',
    LOGOUT_KEY: 'Logout',
    LOGOUT_MSG_KEY: 'Your session will be terminated. Confirm to continue',

    // SideBar
    PARTNER_TYPE_KEY: 'Account type',
    SIDEBAR: {
      MANAGE_COMPANIES_KEY: 'Manage companies',
      COMPANIES_LIST_KEY: 'List companies',
      ADD_COMPANY_KEY: 'Add company',

      MANAGE_PARTNERS_KEY: 'Manage accounts',
      PARTNERS_LIST_KEY: 'List accounts',
      ADD_PARTNER_KEY: 'Add account',

      MANAGE_ENVIRONMENTS_KEY: 'Manage environments',
      ENVIRONMENTS_LIST_KEY: 'List environments',
      ADD_ENVIRONMENT_KEY: 'Add environment',

      MANAGE_CLIENTS_KEY: 'Manage clients',
      CLIENTS_LIST_KEY: 'List clients',
      ADD_CLIENT_KEY: 'Add client',

      MANAGE_OPERATORS_KEY: 'Manage operators',
      OPERATORS_LIST_KEY: 'List operators',
      ADD_OPERATOR_KEY: 'Add operator',

      MANAGE_ADVISORS_KEY: 'Manage advisors',
      ADVISORS_LIST_KEY: 'List advisors',

      MANAGE_GROUPS_KEY: 'Manage groups',
      GROUPS_LIST_KEY: 'List groups',
      ADD_GROUP_KEY: 'Add groups',
      OPTIMIZATION_DASHBOARD_KEY: 'Optimization dashboard',
      MANAGEMENT_KEY: 'Management',
      OPERATORS_AND_PERMISSIONS_KEY: 'Operators and permissions',
    },

    // Dialogs
    LAST_ACCESS_KEY: 'Last access',
    LAST_ACCESS_SINGULAR_KEY: 'Last access',
    LIST_GENERAL_KEY: 'Overview',
    SINGLE_CORPORATE_NAME_KEY: 'Corporate name',

    CHOOSE_COMPANY_KEY: 'Choose a company',
    NEW_COMPANY_KEY: 'New company',
    SEARCH_COMPANY_KEY: 'Search company',

    CHOOSE_PARTNER_KEY: 'Choose an account',
    NEW_PARTNER_KEY: 'New account',
    SEARCH_PARTNER_KEY: 'Search account',

    CHOOSE_CLIENT_KEY: 'Choose a client',

    CHOOSE_ENVIRONMENT_KEY: 'Choose an environment',

    // Cloud providers
    AMAZON_WEB_SERVICES_KEY: 'Amazon Web Services',
    AMAZON_WEB_SERVICES_CONFIRM_KEY:
      'Amazon Web Services settings were successfully defined!',
    GOOGLE_CLOUD_PLATFORM_KEY: 'Google Cloud Platform',
    GOOGLE_CLOUD_PLATFORM_CONFIRM_KEY:
      'Google Cloud Platform settings were successfully defined!',
    ORACLE_CLOUD_KEY: 'Oracle Cloud Infrastructure',
    ORACLE_CLOUD_CONFIRM_KEY:
      'Oracle Cloud Infrastructure settings were successfully defined!',

    // Fields
    MUST_BE_A_NUMBER_KEY: 'This field must be a number',
    LAST_LOGIN_DATE_KEY: 'Last login',
    STATUS_MFA_CONFIGURED_KEY: 'MFA',
    STATUS_MFA_CONFIGURED_ACTIVE_KEY: 'Active',
    STATUS_MFA_CONFIGURED_INACTIVE_KEY: 'Inactive',
    STATUS_MFA_CONFIGURED_PENDING_KEY: 'Pending',
    STATUS_OPERATOR_ACTIVE_KEY: 'Active',
    STATUS_OPERATOR_BLOCKED_KEY: 'Blocked',
    LOGIN_DATE_KEY: 'Login date',
    LOGOUT_DATE_KEY: 'Logout date',
    IP_ORIGIN_KEY: 'Source IP',
    IP_DESTINY_KEY: 'Destination IP',
    IPS_VALID_KEY: 'Validated IP',
    TERMINATE_RATE_KEY: 'Termination reason',
    EMAIL_KEY: 'E-mail',
    PASSWORD_KEY: 'Password',
    YOUR_PASSWORD_KEY: 'Your password',
    CURRENT_PASSWORD_KEY: 'Current password',
    NEW_PASSWORD_KEY: 'New password',
    CONFIRM_NEW_PASSWORD_KEY: 'Confirm your new password',
    PASSWORD_NOT_MATCH_KEY: 'Password does not match',
    FORGOT_PASSWORD_KEY: 'Forgot my password',
    EMAIL_INVALID_KEY: 'Invalid e-mail',
    NUMBER_INVALID_KEY: 'Invalid number',
    REQUIRED_FIELD_KEY: 'This field is required!',
    NOT_HEX_FIELD_KEY: 'This value is not valid, enter a hexadecimal value',
    PASSWORD_MIN_LENGTH_OPERATOR_KEY: 'Enter at least 8 characters',
    PASSWORD_MAX_LENGTH_OPERATOR_KEY: 'Enter at most 32 characters',
    LAST_ONE_CAPITAL_LETTER_KEY:
      'The password must have at least one capital letter',
    MUST_CONTAIN_AT_LEST_ONE_NUMBER_KEY:
      'The password must contain at least one number',
    MUST_CONTAIN_AT_LEST_ONE_SPECIAL_KEY:
      'The password must contain at least one special character',
    PASSWORD_MIN_LENGTH_KEY: 'Enter at least 6 characters',
    PASSWORD_MAX_LENGTH_KEY: 'Enter at most 20 characters',
    ONLY_NUMBERS_KEY: 'This field only accepts numbers',
    ONLY_LETTERS_KEY: 'This field only accepts letters',
    EMAIL_NOTIFICATION_KEY:
      'Do you wish to receive notifications at this e-mail?',
    MIN_NUMBER_CANNOT_BE_LESS_THAN_ONE_KEY:
      'Minimal number of  digits cannot be lesser than 1',
    EMAIL_FICTITIOUS_KEY: 'Dummy e-mail?',
    IS_INTEGRATION_USER_KEY: 'Integration user?',
    DATE_GREATER_THAN_START_DATE_KEY:
      'The date must be greater than the start date',
    ENTER_YOUR_PASSWORD_BELOW_KEY: 'Enter your password below',

    // Links
    PRIVACY_POLICY_KEY: 'Privacy',
    CODE_OF_ETHICS_KEY: 'Ethics and Conduct',

    // 404
    NOT_FOUND_PAGE: {
      TITLE_KEY: 'Page not found',
      BUTTON_KEY: 'Back to home',
    },

    // Login
    LOGIN_PAGE: {
      SUBTITLE_KEY: 'Enter your e-mail and password',
      DESCRIPTION_KEY: 'Your cloud journey.',
    },
    INVALID_CREDENTIALS: 'Operator e-mail or password does not match!',
    CONFIGURE_MFA_KEY: 'Set up your MFA authentication code',
    INSERT_MFA_CODE_KEY: 'Enter your MFA authentication code',
    AUTHENTICATION_CODE_KEY: 'Authentication code',
    INVALID_MFA_CODE: 'Invalid authentication code',

    // Reset password
    RESET_PASSWORD_PAGE: {
      TITLE_KEY: 'Forgot your password?',
      SUBTITLE_KEY: 'Enter your e-mail to start the recovery process.',
      DESCRIPTION_KEY:
        'Enter your e-mail and click Recover to receive a password reset e-mail.',
    },

    // Register password
    REGISTER_PASSWORD_PAGE: {
      TITLE_KEY: 'Enter your new password',
      SUBTITLE_KEY:
        'Passwords of at least 10 characters, with numbers and special characters.',
      DESCRIPTION_KEY:
        'Enter your new password. Use letters, numbers and special characters to increase security.',
    },

    // Accounts
    ADD_PARTNER_KEY: 'Add account',
    PARTNER_NAME_KEY: 'Account name',
    OPERATOR_VIEW_PARTNER_NAME_KEY: 'Account',
    PARTNER_LANGUAGE_KEY: 'Account language',
    ALIAS_KEY: 'Alias',
    LDAP_EXTERNAL_KEY: 'External LDAP',
    LDAP_TOOLTIP_KEY: 'Here should be included the settings to access AD',
    NOT_USE_AT_SIGN_KEY: "It's not necessary to add '@' in this field",
    CLOUD_KEY: 'Cloud',
    USE_FRONT_KEY: 'Use new front-end',
    PARTNER_BLOCKED_SUCCESSFULLY_KEY: 'Account successfully blocked!',
    PARTNER_UNBLOCKED_SUCCESSFULLY_KEY: 'Account successfully unblocked!',
    SUCCESS_PARTNER_EDIT_KEY: 'Account successfully edited!',
    NO_PARTNER_KEY: 'No accounts found!',

    PARTNER_PAGE: {
      NOT_EQUAL_COLOR_MAIN_KEY:
        'This color cannot be the same as the primary color',
      PUBLIC_CUSTOM_KEY: 'Publish customizations',
      PUBLIC_CUSTOM_MSG_KEY: 'Do you want to publish the customization?',
      CUSTOM_STATUS_NOT_DEFINE_KEY: 'Not defined',
      CUSTOM_STATUS_PUBLICATION_KEY: 'Custom publication status',
      HAS_DRAFT_KEY: 'You have a saved draft',
      SAVE_DRAFT_TITLE_KEY: 'Save draft',
      SAVE_DRAFT_DESCRIPTION_KEY:
        'Draft lets you save your edit, so you can come back later',
      MANUAL_COLORS_KEY: 'Color editing manual',
      FIRST_COLOR_TITLE_KEY: '1. Main text color: ',
      SECOND_COLOR_TITLE_KEY: '2. Primary color: ',
      THIRD_COLOR_TITLE_KEY: '3. Login buttons color: ',
      FOUR_COLOR_TITLE_KEY: '4. Login banner colors: ',
      FIVE_COLOR_TITLE_KEY: '5. Message text colors: ',
      SIX_COLOR_TITLE_KEY: '6. Text colors on hover: ',
      FIRST_COLOR_KEY:
        'Changes the color of the titles of the cards in the environments listing on the dashboard.',
      SECOND_COLOR_KEY:
        'Is primarily responsible for the visual identity. Changes the colors of titles, image backgrounds, and others.',
      THIRD_COLOR_KEY:
        'Changes the login, MFA and password recovery buttons background color.',
      FOUR_COLOR_KEY:
        'Changes the background color of the banners in the login, MFA and password recovery screens.',
      FIVE_COLOR_KEY: 'Changes system warning messages text colors.',
      SIX_COLOR_KEY:
        'Changes the title text color of cards in the environments listing on hover.',
      CUSTOM_FRONT_PARTNER: "Customize account's frontend",
      CUSTOM_FRONT_PARTNER_NAME: "Customize account's frontend - {{name}}",
      LOGO_PARTNER_KEY: "Account's logo (L: 150 x A: 101)",
      IMAGE_LOGIN_BANNER_KEY: 'Login page banner (L: 630 x A: 960)',
      COLORS_BANNER_IMAGE_HELP_TEXT_KEY: 'Login image overlay color',
      BACKGROUND_IMAGE_HELP_TEXT_KEY: 'Login screen background image',
      MESSAGES_IMAGE_HELP_TEXT_KEY:
        'Background image for notification and message screens',
      TEXT_HOVER_COLOR_HELP_TEXT_KEY:
        'Text color when hovering over environments',
      USE_EXAMPLE_KEY: 'Example of use',
      RESET_IMAGES_KEY: 'Reset images',
      TEXT_PRINCIPAL_COLOR: 'Main text color',
      PRIMARY_COLOR_KEY: 'Primary color',
      PARTNER_DELETED_KEY: 'Account successfully deleted!',
      LOGIN_BUTTONS_COLORS_KEY: 'Login buttons color',
      COLORS_BANNER_IMAGE: 'Login banner colors',
      MSG_COLORS_KEY: 'Message text colors',
      COLOR_HOVER_TEXT_KEY: 'Text colors on hover',
      TITLE_KEY: 'Title',
      LOGIN_FONT_SIZE_KEY: 'Login page font size',
      DESCRIPTION_FONT_SIZE_KEY: 'Description font size',
      CONNECT_TEXT_TITLE_KEY: 'Connection test: Active Directory',
      CONNECT_TEXT_MSG_KEY: 'Successfully connected!',
      EDIT_COMPANY_WARNING: 'Company edition',
      CHANGE_COMPANY_KEY: 'The changes will be applied in the company {{name}}',
      ADD_NEW_PARTNER_KEY: 'Add account',
      LDAP_SUCCESS_KEY: 'LDAP successfully saved!',
      SEARCH_PARTNER_KEY: "Enter the account's name",
      INIT_INCLUSION_PARTNER_KEY: 'Enter the data to include the account',
      LIST_PARTNER_KEY: 'Account list',
      LIST_PARTNER_AVAILABLE_KEY: 'List of accounts available to query',
      EDIT_PARTNER_KEY: 'Edit account',
      EDIT_BLOCK_KEY: 'Block account',
      EDIT_UNBLOCK_KEY: 'Unblock account',
      REMOVE_PARTNER_KEY: 'Delete account',
      REMOVE_PARTNER_DESCRIPTION_KEY: 'Account {{name}} will be deleted.',
      NONE_PARTNER_KEY: 'No accounts found.',
      REMOVE_PARTNER_QUESTION_KEY:
        'Do you wish to delete the account {{name}}?',
      CLOUD_PROVIDER_PARTNER_KEY: "Select account's cloud provider",
      SELECT_LDAP_PARTNER_KEY: "Select account's LDAP type",
      SELECT_INTERFACE_USE_PARTNER_KEY: 'Select user interface',
      USER_NEW_FRONT_KEY: 'Use new interface?',
      CUSTOMER_EMAIL_KEY: 'Use custom e-mail?',
      CUSTOMER_PLUGIN_KEY: 'Use custom plugin?',
      TEMPLATE_EMAIL_PARTNER_KEY: 'E-mail template',
      TEMPLATE_AVAILABLE_PARTNER_KEY: 'Do you wish to enable this template?',
      SELECT_TEMPLATE_PARTNER_KEY: 'Select template',
      SUBJECT_EMAIL_PARTNER_KEY: 'E-mail subject',
      ADD_NEW_PARTNER_QUESTION_KEY:
        'Do you wish to create account {{name}} in company {{company}}?',
      EDIT_PARTNER_QUESTION_KEY:
        'Do you wish to edit account {{name}} in company {{company}}?',
      EDIT_PARTNER_DATA_KEY: 'Fill the data to edit this account',
      USE_NEW_FRONT_KEY: 'Use new Front-End',
      NEW_FRONT_CONFIGURATION_KEY: 'Portal 2.0 configuration',
      ENABLE_NEW_FRONT_KEY: 'Enable Portal 2.0',
      ENABLE_NEW_FRONT_MIGRATION_KEY: 'Enable migration to Portal 2.0',
      ENABLE_NEW_FRONT_MIGRATION_CONFIRMATION_KEY:
        'By enabling migration to Portal 2.0, the migration will automatically be considered complete if all users access the new portal before the migration date. Do you wish to continue?',
      NEW_FRONT_MIGRATION_DEADLINE_KEY: 'Migration deadline',
      ENABLE_NEW_FRONT_EXPLANATION_KEY:
        'By enabling this option, the users of this account will be redirected exclusively to Portal 2.0.',
      ENABLE_NEW_FRONT_MIGRATION_EXPLANATION_KEY:
        'Schedule the activation of Portal 2.0 for this account, notifying users about the migration and providing access to the new platform. If all users access Portal 2.0 before the final date, the migration will be considered complete.',
      NEW_FRONT_MIGRATION_DEADLINE_EXPLANATION_KEY:
        'Final migration date, after this date, the migration will be considered complete.',
      OPERATOR_VIEW_NEW_FRONT_KEY: 'New Front-End',

      BLOCK_PARTNER_TITLE_KEY: 'Do you wish to block the account?',
      BLOCK_PARTNER_DESCRIPTION_KEY: 'Account {{name}} will be blocked.',
      UNBLOCK_PARTNER_TITLE_KEY: 'Do you wish to unblock the account?',
      UNBLOCK_PARTNER_DESCRIPTION_KEY: 'Account {{name}} will be unblocked.',

      MAINTENANCE_MESSAGES_KEY: 'Maintenance warning (L: 1382 x A: 596)',
      MESSAGE_IMAGES_KEY: 'Messages (L: 1382 x A: 596)',
      FAVICON_KEY: 'Favicon (64 x 64)',
      DRAG_AND_DROP_KEY: 'Drag and drop an image here or click to select',
      HIGHLIGHT_COLOR_KEY: 'Primary highlight color',
      ENVIRONMENT_TITLE_COLOR_KEY: "Environment's title color",
      MESSAGES_BUTTON_COLOR_KEY: 'Message screen color button',
      MESSAGES_BUTTON_COLOR_HOVER_KEY: 'Message screen color button on hover',
      SUCCESS_SAVE_KEY: 'Save successfully',
      SUCCESS_PUBLISH_KEY: 'Publish successfully',

      SSO_DEACTIVATED_TOGGLE: 'Allows SSO configuration',
      DUO_DEACTIVATED_TOGGLE: 'Allows DUO configuration',
      SSO_KEY: 'SSO',
      DUO_KEY: 'DUO',
      SUCCESS_CREATE_ACCOUNT: 'Account registered successfully!',
      SUBDOMAIN_KEY: 'Subdomain',
      USE_CUSTOM_THEME_KEY:
        'To use this feature its necessary to have an unique alias registered',
      DELETE_CUSTOM_BUTTON_KEY: 'Delete customization',
      DELETE_CUSTOM_SUBTEXT_KEY:
        'When confirming the deletion, all customization data will be deleted: customized page address, domain, title, colors, images and font sizes.',
      DELETE_CUSTOM_TEXT_KEY:
        'To confirm the deletion, enter your operator password in the field below:',
      DELETE_CUSTOM_MODAL_TITLE_KEY: 'Delete customization of {{name}}',
      DELETE_CUSTOM_SUCCESS_KEY: 'Customization deleted successfully!',
      LOGO_BACKGROUND_COLOR_KEY: 'Logo background color',
      NO_TEXT_KEY: 'No text',
      CLONE_PARTNER_KEY: 'Clone account',
      CLONE_PARTNER_NAME_KEY: 'New account name',
      CLONE_PARTNER_OBSERVATION_KEY:
        'When cloning an account, only the settings are copied. Environments, clients, users, front-end customizations, and alias configuration are not replicated in the cloned account.',
      CHANGE_AD_PASSWORD_KEY: 'Change AD user password',
      CHANGE_DUO_CLIENT_SECRET_KEY: 'Change Client Secret',
      CHANGE_AD_PASSWORD_CONFIRMATION_KEY:
        'To confirm the password change, enter the reason for the action and your password in the fields below',
      NEW_AD_PASSWORD_LABEL_FIELD_KEY: 'Enter the new AD user password',
      ADMIN_BIND_PASS_KEY: 'AD user password',
      ADMIN_DN_KEY: 'AD user',
      AD_DOMAIN_KEY: 'AD user domain',
      DOMAIN_TYPE_KEY: 'Domain type',
      SUBDOMAIN_OPTION_KEY: 'Subdomain',
      FULL_DOMAIN_OPTION_KEY: 'Full domain',
      FULL_DOMAIN_KEY: 'Full domain',
    },

    // Environments
    ENVIRONMENT_NAME_KEY: 'Environment name',
    OPERATOR_VIEW_ENVIRONMENT_NAME_KEY: 'Environment',
    ENVIRONMENT_ID_KEY: 'Environment ID',
    PROJECT_ID_SKY_KEY: 'Easy.Sky project ID',
    REGION_KEY: 'Region',
    COMPARTMENT_ID_KEY: 'Compartment ID',
    MODE_KEY: 'Mode',
    LICENSES_KEY: 'Licenses',
    ACTIVE_BEHAVIOR_KEY: 'Active',
    STOPPED_BEHAVIOR_KEY: 'Stopped',
    ON_DEMAND_BEHAVIOR_KEY: 'On demand',
    PARTNER_KEY: 'Account',
    MARGIN_KEY: 'Margin',
    MARGIN_PERCENT_KEY: 'Margin (percent)',
    PROVIDER_CLOUD_KEY: 'Cloud provider',
    MODEL_TOOLTIP_KEY: 'Main configuration used by instances.',
    MODEL_TOOLTIP_BACKUP_KEY:
      'Alternative configuration used when there are issues with allocating machines from the Primary model.',
    MODEL_TOOLTIP_SPOT_KEY:
      'Configuration used by Amazon Web Services Spot instances.',
    PROVIDER_CLOUD_TOOLTIP_KEY:
      'These options define which settings will be applied to instances activated through auto-scaling, such as flavors, availability zones, AMIs, among others',
    CONNECTION_TYPE_TOOLTIP: 'Provider connection type public / private',
    ZONE_DEFAULT_TOOLTIP: 'Default server zone',
    PUBLICATIONS_KEY: 'Publications',
    PUBLICATION_ALREADY_IN_PROGRESS:
      'There is already an image publication in progress',
    TOGGLE_BLOCK_UNBLOCK_INSTANCE_KEY: 'Block / unblock instances',
    TOGGLE_BLOCK_UNBLOCK_INSTANCE_MSG_KEY:
      'The selected instances will be blocked / unblocked',
    SCHEDULE_PUBLICATIONS_KEY:
      'Scheduling blocking of instances with old model versions',
    SCHEDULE_PUBLICATIONS_TOOLTIP_KEY:
      'The scheduling will only affect instances with old model versions, not impacting instances with current model versions.',
    PERCENTAGE_SPOT_KEY: 'SPOT percentage',
    TOTAL_LICENSES_KEY: 'Total licenses',
    FAST_DETAILS_KEY: 'Quick details',
    REMOVE_ENVIRONMENT_KEY: 'Delete environment',
    ADD_MODEL_KEY: 'Add model',
    REMOVE_MODELS_SELECTED_KEY: 'Delete selected models',
    BASE_NAME_KEY: 'Base name',
    BACKUP_SECONDARY_KEY: 'Secondary',
    MODEL_PRIMARY_KEY: 'Primary',
    VERSION_KEY: 'Version',
    ACTIVE_INSTANCES_KEY: 'Active instances',
    CONNECTED_USERS_KEY: 'Connected users',
    CREATE_MODEL_KEY: 'Create model',
    EDIT_MODEL_KEY: 'Edit model',
    SECURITY_TAGS_KEY: 'Security tags',
    TEMPERATURE_REFERENCE_KEY: 'Reference temperature',
    KEY_PAIR_KEY: 'Key pair',
    SECURITY_GROUP_KEY: 'Security group',
    CREDIT_SPECIFICATIONS_KEY: 'Credit specifications',
    MEMORY_MAX_KEY: 'Memory maximum',
    CPU_MAX_KEY: 'CPU maximum',
    CONNECTION_MAX_KEY: 'Connections maximum',
    EMPTY_KEY: 'Empty',
    TURNED_OFF_KEY: 'Turned off',
    OFF_KEY: 'Off',
    OPERATIONAL_KEY: 'Operational',
    TOP_KEY: 'Top',
    BOOT_TIME_KEY: 'Boot time',
    ACTIVE_INSTANCE_KEY: 'Activate instance',
    REGISTER_INSTANCE_KEY: 'Register instance',
    TERMINATE_INSTANCE_KEY: 'Terminate instance',
    REMOVE_INSTANCE_KEY: 'Delete instance',
    BLOCK_INSTANCE_KEY: 'Block instance',
    UNBLOCK_INSTANCE_KEY: 'Unblock instance',
    PUBLIC_IP_KEY: 'Public IP',
    PRIVATE_IP_KEY: 'Private IP',
    MONITOR_KEY: 'Monitor',
    ALARMS_LOGS_KEY: 'Alarms / logs',
    ALARMS_KEY: 'Alarms',
    SEARCH_INSTANCE_KEY: 'Search instance',
    REMOVE_SESSION_KEY: 'Close session',

    MANUAL_KEY: 'Manual',
    FINISH_SESSION_KEY: 'Finish session',
    TYPE_MANUAL_KEY: 'Manual - Deprecated',
    TYPE_ROBOT_PERIOD_KEY: 'Robot - Periods - Deprecated',
    TYPE_ROBOT_PERIOD_SPOT_KEY: 'Robot - Periods (Spot) - Deprecated',
    TYPE_ROBOT_MICRO_KEY: 'Robot - Micro - Deprecated',
    TYPE_DEDICATED_KEY: 'Dedicated',
    TYPE_SHARED_KEY: 'Shared',
    TYPE_HAAS_KEY: 'HaaS - Deprecated',
    TYPE_CCC_KEY: 'CCC - Deprecated',
    MICRO_KEY: 'Micro',
    SPOT_KEY: 'Spot',
    MODEL_BACKUP_KEY: 'Secondary model',
    MODEL_SPORT_KEY: 'Model spot',
    PRIMARY_ZONE_KEY: 'Primary zone',
    SECONDARY_ZONE_KEY: 'Secondary zone',
    ZONE_DEFAULT_KEY: 'Default zone',
    CONNECTION_TYPE_KEY: 'Connection type',
    REGION_DEFAULT_KEY: 'Default region',
    FILE_KEY: 'File',
    QUALITY_KEY: 'Quality',
    HIGH_KEY: 'High',
    DEFAULT_KEY: 'Default',
    LOW_KEY: 'Low',
    ACCESS_PUBLIC_KEY: 'Public access (via public IP over the internet)',
    PRIVATE_PUBLIC_KEY:
      'Private access (via private IP through a VPN or private connection)',

    USERS_ADMIN_KEY: 'Administrative users',
    STATE_OPERATIONAL_KEY: 'Operational state',
    AVERAGE_MEMORY_USAGE_KEY: 'Average memory usage',
    AVERAGE_CPU_USAGE_KEY: 'Average CPU usage',
    AVERAGE_DISK_USAGE_KEY: 'Average disk usage',
    TOTAL_INSTANCES_KEY: 'Total instances',
    TOTAL_LICENSES_USAGE_KEY: 'Licenses in use',
    TOTAL_SESSIONS_KEY: 'Total sessions',
    TOTAL_LICENSES_CONTRACT_KEY: 'Licenses acquired',
    LICENSES_AVAILABLE_KEY: 'Available licenses',
    IMAGE_PUBLICATION_TYPE_KEY: 'Image publication type',
    MAX_PUBLICATIONS_KEY: 'Monthly publication limit',
    MAX_DAILY_PUBLICATIONS_KEY: 'Daily publication limit',
    TOTAL_PUBLICATIONS_KEY: 'Number of monthly publications already made',
    TOTAL_DAILY_PUBLICATIONS_KEY: 'Number of daily publications already made',
    PUBLICATIONS_OLD_INSTANCES_KEY: 'Block instances with old model versions?',
    BLOCK_TIME_KEY: 'Block time',
    REGISTER_THROUGH_KEY: 'Register through',
    REGISTER_MODE_KEY: 'Register mode',
    BEHAVIOR_KEY: 'Behavior',
    PRODUCT_TYPE_KEY: 'Environment type',
    ADVANCED_KEY: 'Advanced',
    SECURITY_KEY: 'Security',
    SCHEDULER_KEY: 'Scheduler',
    GOVERNANCE_KEY: 'Governance',

    ADD_SERVER_PREPARATION_KEY: 'Add preparation server',
    ADD_SERVER_PREPARATION_SUBTITLE_KEY:
      'Enter instance data to add it as a preparation server of the environment {{environment}}.',
    ADD_SERVER_SUPPORT_KEY: 'Add support server',
    ADD_SERVER_SUPPORT_SUBTITLE_KEY:
      'Enter instance data to add it as a support server of the environment {{environment}}.',
    REMOVE_SERVER_SELECTED_KEY: 'Unlink selected servers',
    START_INSTANCE_KEY: 'Start instance',
    INSTANCE_NAME_KEY: 'Instance name',
    INSTANCE_ID_KEY: 'Instance ID',
    SCHEDULED_STOP_KEY: 'Scheduled stop',
    SCHEDULED_STOP_DATETIME_KEY: 'Stop datetime',
    CANCEL_SCHEDULED_STOP_KEY: 'Cancel scheduled stop',
    DISABLE_SCHEDULED_STOP_KEY: 'Disable scheduled stop',
    EXTEND_EXECUTION_KEY: 'Extend execution',
    INTERVAL_TIME_KEY: 'Time interval',
    GENERATE_IMAGES_STOP_KEY: 'Generate images without stopping this instance?',
    NEW_SCHEDULED_STOP_DATETIME_KEY: 'New stop date and time',
    NEW_SCHEDULED_STOP_KEY: 'Scheduled stop new time',
    NEW_SCHEDULED_STOP_SUBTITLE_KEY: 'Add a new scheduled stop',
    SCHEDULED_BLOCK_INSTANCES_KEY: 'Schedule instance blocking',

    DATA_REFERENCE_LAST_TIME_KEY: 'Data referent to last hour',
    TOTAL_SESSIONS_ACTIVE_KEY: 'Active sessions',
    NUMBER_NEW_ACCESSES_KEY: 'New accesses numbers',
    TOTAL_VACANCIES_KEY: 'Total vacancies',

    WANT_START_SERVER_KEY: 'Do you wish to start the server?',
    WANT_STOP_SERVER_KEY: 'Do you wish to stop the server?',

    WANT_TERMINATE_INSTANCE_KEY: 'Do you wish to terminate the instance?',
    WANT_REMOVE_INSTANCE_KEY: 'Do you wish to delete the instance?',
    WANT_TERMINATE_INSTANCE_DESCRIPTION_KEY:
      'Instance {{name}} will be terminated, this may take a few minutes',

    WANT_START_INSTANCE_KEY: 'Do you wish to start this instance?',
    WANT_START_INSTANCE_DESCRIPTION_KEY:
      'Instance I-0000 will be started, this may take a few minutes',
    WANT_REBOOT_INSTANCE_KEY: 'Do you wish to restart this instance?',
    WANT_REBOOT_SERVER_KEY: 'Do you wish to restart this server?',
    WANT_STOP_INSTANCE_KEY: 'Do you wish to stop the instance?',
    WANT_REBOOT_INSTANCE_DESCRIPTION_KEY:
      'Instance {{name}} will restart, this may take a few minutes',

    WANT_DELETE_MODEL_KEY: 'Do you wish to delete this model?',
    WANT_DUPLICATE_MODEL_KEY: 'Do you wish to duplicate the model?',
    WANT_DELETE_MODEL_DESCRIPTION_KEY: 'Model {{name}} will be deleted',
    WANT_LOGOUT_SESSION_KEY: 'Do you wish to end this session?',
    MODEL_SUCCESSFULLY_REMOVED_KEY: 'Model successfully deleted!',
    MODEL_SUCCESSFULLY_REGISTERED_KEY: 'Model successfully added!',
    MODEL_SUCCESSFULLY_EDITED_KEY: 'Model successfully edited!',

    ADD_MESSAGE_MAINTENANCE_KEY: 'Add maintenance message',
    ADD_MESSAGE_REMOVE_SESSION_KEY: 'Add drain message',
    START_ALERT_KEY: 'Start maintenance',
    END_ALERT_KEY: 'End maintenance',
    MANUAL_MAINTENANCE_KEY: 'Manual maintenance',
    TERMINATE_INSTANCES_KEY: 'Terminate instances',
    TERMINATE_SESSIONS_KEY: 'Terminate sessions',
    START_ENVIRONMENT_AT_KEY: 'Start environment at',
    SCALING_KEY: 'Scaling',
    SERVER_SUP_KEY: 'SUP server',
    PERCENTAGE_KEY: 'Percentage',
    TURNED_ON_KEY: 'Turned on',
    SUPPORT_SERVER_KEY: 'Support server',
    STATUS_ENVIRONMENT_KEY: 'Environment status',
    DISPLAY_TO_LOGGED_USERS_KEY: 'Display to logged users',

    GOVERNANCE_INFORMATION_KEY: 'Data governance',
    PROJECT_CODE_KEY: 'Project code (Zoho Projects)',
    PROJECT_TYPE_KEY: 'Project type',
    PRODUCTION_KEY: 'Production',
    DEVELOPMENT_KEY: 'Development',
    DEPARTMENT_KEY: 'Department',
    IMPLEMENTATION_KEY: 'Implementation',
    OPERATION_KEY: 'Operation',
    RESPONSIBLE_TECHNICAL_KEY: 'Responsible technician',
    TECHNICAL_PHONE_KEY: 'Technician phone number',
    TECHNICAL_EMAIL_KEY: 'Technician e-mail',
    TECHNICAL_EMAIL_PLACEHOLDER_KEY: 'example@email.com',
    RESPONSIBLE_IMPLEMENTATION_KEY: 'Responsible for the implementation',
    CREATION_DATE_ENVIRONMENT_KEY: 'Environment created at',
    DELIVERY_DATE_ENVIRONMENT_KEY: 'Environment delivered at',
    COMMENTS_KEY: 'Comments',

    LICENSE_LIMIT_KEY: 'Licenses limit',
    INTERFACE_KEY: 'Interface',
    SET_INTERFACE_KEY: 'Set interface',
    USE_NEW_FRONT_KEY: 'Use new interface',
    USE_OLD_FRONT_KEY: 'Use old interface',
    USE_PARTNER_TENANCY_KEY: 'Use account tenancy',
    USE_IOS_BY_DEFAULT_EXPLANATION_KEY:
      'Enable the use of iOS devices only for new clients',
    BLOCK_MULTIPLE_SESSIONS_EXPLANATION_KEY:
      'With this functionality enabled in the environment, login attempts with the same user will be blocked',
    UNIQUE_USER_SESSION_VALIDATION_EXPLANATION_KEY:
      'With this feature enabled in the environment, attempts to access using the same user session will be blocked',
    USE_REMOTE_DNS_EXPLANATION_KEY:
      'With this feature enabled, the public IP of the AutoSky instances will be masked, using DNS',
    LICENSE_LIMIT_PER_CLIENT_EXPLANATION_KEY:
      'With this feature enabled, it will be possible to restrict the maximum number of licenses that each client can use',
    AUTO_INCREASE_LICENSES_EXPLANATION_KEY:
      'With this option enabled, the total amount of licenses will automatically be temporarily incremented with the value below upon reaching the usage limit (30 days).',
    AUTO_INCREASE_LICENSES_KEY:
      'Automatically temporarily increase licenses before reaching the limit',
    ALWAYS_ACTIVE_RESOURCE_KEY: 'Always keep this feature enabled',
    ALWAYS_ACTIVE_RESOURCE_TOOLTIP_KEY:
      'With this option selected, the resource will always remain active',
    INCREASE_LICENSES_BY_KEY: 'Increase license limit by:',
    LICENSE_LIMIT_PER_CLIENT_KEY: 'Limit licenses per client',
    USE_REMOTE_DNS_KEY: 'Use DNS for remote connection?',
    USE_ALLOW_CLIENT_CONNECTION_TYPE_KEY: 'Allow connection type per client?',
    USE_ALLOW_CLIENT_CONNECTION_TYPE_TOOLTIP_KEY:
      'Enables clients to choose their own type of connection to the provider (public or private)',
    BLOCK_MULTIPLE_SESSIONS_KEY: 'Block multiple sessions for the same user?',
    UNIQUE_USER_SESSION_VALIDATION_KEY: 'User session validation',
    USE_IOS_BY_DEFAULT_KEY: 'Enable the use of iOS devices for new clients.',
    USE_IOS_DEVICES_KEY: 'Use iOS devices?',
    LICENSE_LIMIT_MAX_KEY:
      'This limit must be lower than the limit of available licenses',

    DEFINE_PERIODS_TITLE_KEY: 'Choose the periods you wish to configure',
    DEFINE_PERIODS_SUBTITLE_KEY: 'You must choose one of the options below',
    DEFINE_PERIODS_SUBTITLE_ONE_KEY: 'Define at least one of the periods',
    IN_THE_WEEK_KEY: 'Throughout the week',
    ON_THE_SATURDAY_KEY: 'On saturdays',
    ON_THE_SUNDAY_KEY: 'On sundays',
    ADD_COMMENT_TITLE_KEY: 'Add comment',
    ADD_COMMENT_SUBTITLE_KEY: 'Comments about environment settings',
    ADD_COMMENT_KEY: 'Add comment',

    USE_SPECIFIC_PASSWORD_KEY: 'Use specific password settings?',
    MINIMUM_PASSWORD_LENGTH_KEY: 'Minimum number of characters in the password',
    REQUIRE_UPPERCASE_KEY: '● Required at least one capital letter',
    REQUIRE_LOWERCASE_KEY: '● Required at least one lowercase letter',
    REQUIRE_NUMBER_KEY: '● Required at least one numeric letter',
    REQUIRE_SPECIAL_CHARACTER_KEY:
      '● Required at least one non-alphanumeric character',
    EXPIRATION_PASSWORD_KEY: 'Enable password expiration?',
    EXPIRATION_PASSWORD_DAYS_KEY: 'Expire password every (days):',
    NUMBER_MAX_LOGIN_TRIES_KEY: 'Login attempts limit',
    BEHAVIOR_MESSAGE_KEY: 'Behavior settings saved successfully!',

    FILL_THE_REQUIRED_FIELDS_KEY: 'Fill in the required fields!',
    FILL_THE_CORRECTLY_FIELDS_KEY: 'Fill in the fields correctly!',

    ENVIRONMENTS_SUCCESS_KEY: 'Environment successfully deleted!',
    ENVIRONMENT_SUCCESSFULLY_EDITED_KEY: 'Environment successfully edited!',
    ADD_ENVIRONMENT_KEY: 'Add environment',
    NO_ENVIRONMENT_KEY: 'No environments found!',

    ENVIRONMENTS_PAGE: {
      LIMIT_MSG_IMAGE_PUBLICATION_KEY:
        'Monthly limit reached: This environment has reached the monthly image publication limit with instance locking (keeping users logged in). Standard publishing is still available.',
      LIMIT_DAILY_MSG_IMAGE_PUBLICATION_KEY:
        'Daily limit reached: This environment has reached the daily image publication limit with instance locking (keeping users logged in). Standard publishing is still available.',
      BOTH_LIMIT_MSG_IMAGE_PUBLICATION_KEY:
        'Daily and monthly limits have been reached: This environment has reached the daily and monthly image publication limit with instance locking (keeping users logged in). Standard publishing is still available.',
      EXECUTED_MONTHLY_PUBLICATION_KEY: 'Remaining publications (monthly)',
      EXECUTED_DAILY_PUBLICATION_KEY: 'Remaining publications (daily)',
      ERROR_CONFIG_SERVER_KEY:
        'Configuration error: Your environment does not have an instance configured as an application server, this will make it impossible for the environment to work',
      LOGS_PUBLICATION_KEY: 'Publication logs',
      REMOVE_INSTANCES_WARNING_KEY: 'The selected instances will be deleted',
      REMOVE_NOT_INSTANCES_WARNING_KEY:
        'You did not select instances to be terminated',
      TERMINATE_MULTIPLE_INSTANCES_MSG_KEY:
        'The selected instances will be terminated',
      BLOCK_MULTIPLE_INSTANCES_MSG_KEY:
        'The selected instances will be blocked',
      UNBLOCK_MULTIPLE_INSTANCES_MSG_KEY:
        'The selected instances will be unblocked',
      REMOVE_MULTIPLE_MODELS_KEY: 'Selected models will be deleted',
      REMOVE_MULTIPLE_MODELS_WARNING_KEY:
        'You have selected a primary template. This item will be kept, the others will be removed.',
      LOADING_OPTION_KEY: 'Loading {{optionName}}...',
      NOT_HAVE_OPTION_KEY: 'There are no {{optionName}} available',
      TURN_INTO_APPLICATION_SERVER_KEY: 'Turn into application server',
      TURN_INTO_APPLICATION_SERVER_MSG_KEY:
        'Support server {{instanceId}} will be turned into application server',
      ALARMS_INSTANCE_NOT_FOUND: 'No alarms found for this instance',
      STOPPED_INSTANCE_KEY: 'Stopped',
      ON_INSTANCE_KEY: 'On',
      OPERATIONAL_INSTANCE_KEY: 'Operational',
      BLOCKED_INSTANCE_KEY: 'Blocked',
      INACCESSIBLE_INSTANCE_KEY: 'Inaccessible',
      STOPPING_INSTANCE_KEY: 'Stopping',
      ENDING_INSTANCE_KEY: 'Ending',
      INITIALIZING_INSTANCE_KEY: 'Starting',
      ACTIVATING_INSTANCE_KEY: 'Activating',
      INCLUDE_INSTANCE_LIKE_SERVER_APPLICATION:
        'Include instance as application server?',
      SEARCH_FOR_LOGS: 'Search logs',
      NOT_STOP_TIME_KEY: 'Server does not have a scheduled stop set',
      MODEL_SUCCESSFULLY_DUPLICATE_KEY: 'Model was successfully duplicated!',
      PUBLICATION_IDENTIFICATION: 'Publication identification',
      PUBLICATION_IMAGE_INIT_KEY: 'Image publishing started',
      TYPE_PUBLICATION_KEY: 'Publication type',
      WANT_EXTEND_SERVER_KEY: 'Do you wish to extend server execution?',
      WANT_EXTEND_SERVER_MSG_KEY:
        'Your server will be extended for an additional 2 hours from the scheduled time, or, if no schedule is set, from the current time.',
      CREATE_BOOT_VOLUME: ' Creating boot volume',
      CHECK_BOOT_VOLUME: 'Verifying boot volume',
      CREATE_AMI: 'Creating image',
      CHECK_AMI: 'Verifying image',
      REPLACE_INSTANCES: 'Calculating demands',
      BLOCK_OLD_INSTANCES: 'Blocking instances',
      SEND_MAIL_TASK: 'Sending e-mail',
      WARN_USERS_AND_BLOCK_INSTANCES: 'Warning users and blocking instances',
      CHECK_FIRST_OPERATIONAL_INSTANCE: 'Checking instance operationalization',
      CHECK_IF_TEMPLATE_SERVER_IS_STOPPED:
        'Verifying if template instance is stopped',
      START_MULTIPLE_NEW_INSTANCES: 'Starting new instances',
      CHECK_MULTIPLE_INSTANCES_RESULT: 'Verifying the start of new instances',
      KEEPUSERSCONNECTED: 'Keep users connected',
      REQUESTING_USER_RECONNECTION_KEY: 'Requesting user reconnection',
      STANDARD_KEY: 'Standard',
      WANT_CREATE_ENVIRONMENTS_KEY: 'Do you wish to create this environment?',
      LOGS_IMAGE_BACK_KEY: 'Go back to images listing',
      TIME_DISCONNECT_KEY: 'Users disconnection time in minutes',
      USER_MSG_IMAGE_KEY: 'Message to user',
      EMAIL_NOTIFICATION_IMAGE_KEY: 'Notification warning e-mail',
      YOUR_NAME_KEY: 'Your name',
      PUBLICATIONS_NEW_VERSION_KEY: 'Publish new version',
      PUBLICATIONS_KEY: 'Publish',
      IMAGE_NOT_FOUND: 'No image found',
      NEW_PUBLICATION: 'New publication successfully registered!',
      DO_NOT_EXIST_SERVER_PREPARATION_KEY: 'Preparation servers does not exist',
      START_KEY_SUPPORT_INSTANCE: 'Start instance',
      KEEP_USERS_CONNECTED_KEY: 'Keep users connected',
      REQUEST_USER_FEATURE_KEY: 'Request reconnection resources',
      SCHEDULE_PUBLISH_KEY: 'Schedule publication',
      PUBLICATION_SERVER_IMAGE_KEY: 'Select a server to publish a new image',
      CONFIRM_PUBLICATION_NEW_VERSION_KEY:
        'Click confirm to publish a new version',
      KEEP_USER_LOG_MSG_KEY:
        "This procedure will publish a new version of Client layer (user access) in the platform's AutoScaling feature",
      REQUEST_USER_FEATURE_MSG: {
        TITLE_REQUEST_KEY:
          "This procedure will publish a new version of the application layer (user access) in the platform's AutoScaling feature  and when the access of this new version is available, Autosky platform will require every connected user to close their remote sessions and access the new published version.",
        SUBTITLE_REQUEST_KEY:
          'We recommend this procedure to only be performed in cases of critical system updates, in which all users must access the new published version. You may only perform this procedure a few times a month within the limits of your environment.',
      },
      START_SERVER_KEY: 'Start server',
      STOP_SERVER_KEY: 'Stop server',
      CREATE_ENVIRONMENT_KEY: 'Create environment',
      CREATE_ENVIRONMENT_SUBTITLE_KEY: {
        COMPANY_NAME_SUBTITLE_KEY: 'Creating for',
      },
      DETACH_SERVER_KEY: 'Do you wish to unlink the server?',
      DETACH_SERVER_MSG_KEY:
        'Server {{environment}} will be unlinked, are you sure?',
      START_SERVER_MSG_KEY:
        'Instance {{environment}} will be started, this may take a few minutes',
      STOP_SERVER_MSG_KEY:
        'Instance {{environment}} will be stopped, this may take a few minutes',
      RESTART_SERVER_MSG_KEY:
        'Server {{environment}} will be restarted, this may take a few minutes',
      LIST_ENVIRONMENTS_TITLE_KEY: 'Environments list',
      LIST_ENVIRONMENTS_SUBTITLE_KEY: 'List of available environments',
      NO_ENVIRONMENT_KEY: 'No environments found.',

      LIST_INSTANCES_TITLE_KEY: 'Instances list',
      LIST_INSTANCES_SUBTITLE_KEY: 'Visualize data and perform operations',
      LIST_SESSIONS_TITLE_KEY: 'Sessions list',
      LIST_SESSIONS_SUBTITLE_KEY: 'Visualize data and perform operations',
      NO_INSTANCE_KEY: 'No instances found.',
      WISH_UNLINK_INSTANCE_KEY: 'Do you wish to unlink this instance?',

      WANT_BLOCK_INSTANCE_KEY: 'Do you wish to block this instance?',
      WANT_UNBLOCK_INSTANCE_KEY: 'Do you wish to unblock this instance?',

      LIST_SERVERS_TITLE_KEY: 'Servers',
      LIST_SERVERS_SUBTITLE_KEY: 'Select a server to view its details:',
      UNLINK_WARNING_KEY: 'Instance {{instance}} will be unlinked.',
      BLOCK_INSTANCE_WARNING_KEY: 'The {{instance}} instance will be blocked',
      UNBLOCK_INSTANCE_WARNING_KEY:
        'The instance {{instance}} will be unblocked',
      LIST_MODELS_TITLE_KEY: 'Models',
      DUPLICATE_NAME_KEY: 'Model name',
      LIST_MODELS_SUBTITLE_KEY:
        'Define the models to be used in the environment',
      NO_MODEL_KEY: 'No models found.',

      LIST_LOGS_TITLE_KEY: 'Logs',
      LIST_LOGS_SUBTITLE_KEY:
        "View the environment's data from the filters below",
      NO_LOG_KEY: 'No logs found.',
      NO_LOG_INSTANCE_KEY: 'No logs were found for this instance.',

      GENERAL_VISION_TITLE_KEY: 'Overview',
      GENERAL_VISION_SUBTITLE_KEY: 'Environments data overview',

      DASHBOARD_TITLE_KEY: 'Dashboard',

      MAINTENANCE_TITLE_KEY: 'Maintenance settings',
      MAINTENANCE_SUBTITLE_KEY: "Define the environment's maintenance settings",

      WANT_REMOVE_SHUTDOWN_TITLE_KEY:
        'Do you wish to delete the scheduled stop?',
      WANT_REMOVE_SHUTDOWN_MSG_KEY:
        'The instance is scheduled to be shut down at',
      WANT_SCHEDULE_NEW_STOP_TIME_MSG_KEY:
        'The instance will be scheduled to shut down at {{time}}',

      CONFIGURATION_TITLE_KEY: 'Settings',
      CONFIGURATION_SUBTITLE_KEY: '> Edit settings',

      BEHAVIOR_TITLE_KEY: 'Environment behavior mode',
      BEHAVIOR_SUBTITLE_KEY: 'Define environment behavior mode',

      SECURITY_DEFAULTS_SUCCESS_KEY: 'Security standards successfully edited!',

      ZERO_TRUST_NEW_FRONTEND_KEY:
        'Zero Trust cannot be enabled unless account uses the new login frontend',
      INVALID_IP_KEY: 'Invalid address or network in Allow List',

      NEW_GOVERNANCE_SUCCESS_KEY:
        'Governance data was successfully registered!',

      GOVERNANCE_DEFAULTS_SUCCESS_KEY: 'Governance data successfully edited!',

      REMOVE_DESCRIPTION_KEY: 'Environment data will be lost.',

      MODAL_CONNECT_LIKE_TITLE_KEY:
        'For security reasons, please provide your access password to the Autosky Administration Portal.',
      MODAL_CONNECT_LIKE_RDP_KEY:
        'The Autosky connection plugin will be used. If not installed, click the button below to install.',
      OPEN_DETAILS_KEY: 'Open',
      CHECK_BOOT_VOLUME_BACKUP: 'Verifying boot volume backup',
      CREATE_BOOT_VOLUME_BACKUP: 'Creating boot volume backup',
      SYNC_WITH_PROVIDER: 'Force update with provider',
      PREPARATION_SERVER_KEY: 'Preparation server',
      NO_PREPARATION_SERVER_KEY: 'No preparation server found.',
      NO_SUPPORT_SERVER_KEY: 'No support server found.',
      SERVER_STATUS_KEY: 'Server status',
      IMAGE_STATUS_KEY: 'Image status',
      APPLICATION_KEY: 'Application',

      STATUS: {
        PENDING_KEY: 'Pending',
        RUNNING_KEY: 'Operational',
        STOPPING_KEY: 'Stopping',
        STOPPED_KEY: 'Stopped',
        GENERATING_KEY: 'Generating',
        PUBLISHING_KEY: 'Publishing',
        REPLACING_KEY: 'Replacing',
        BLOCKING_KEY: 'Blocking',
        DISCONNECTING_KEY: 'Disconnecting',
        ERROR_KEY: 'Error',
        FINISHED_KEY: 'Finished',
        INITIALIZING_KEY: 'Initializing',
        NOT_FOUND: 'Not found',
        COMPLETED_KEY: 'Completed',
        EXECUTING_KEY: 'Executing',
        CANCELLED_KEY: 'Cancelled',
        RETRYING_KEY: 'Retrying',
        EXPIRED_KEY: 'Expired',
      },
    },

    STOPPED_KEY: 'Stopped',
    ENVIRONMENT_STATUS_NOTIFICATION_KEY:
      'Environment does not have defined status',
    ENVIRONMENT_STATUS_NOTIFICATION_ACTION_KEY: 'Set status',
    ENVIRONMENT_STATUS: {
      DEMONSTRATION_KEY: 'Demonstration',
      DEPLOYMENT_KEY: 'Deployment',
      DEVELOPMENT_KEY: 'Development',
      HOMOLOGATION_KEY: 'Homologation',
      MIGRATION_KEY: 'Migration',
      PENDING_KEY: 'Pending',
      PRODUCTION_KEY: 'Production',

      DEMONSTRATION_DESCRIPTION_KEY: 'Environment in demonstration phase',
      DEPLOYMENT_DESCRIPTION_KEY: 'Environment in deployment phase',
      DEVELOPMENT_DESCRIPTION_KEY: 'Environment used for development',
      HOMOLOGATION_DESCRIPTION_KEY: 'Environment in homologation phase',
      MIGRATION_DESCRIPTION_KEY: 'Environment in migration phase',
      PENDING_DESCRIPTION_KEY: 'Environment with undefined status',
      PRODUCTION_DESCRIPTION_KEY: 'Productive environment',
    },

    // Applications
    APPLICATIONS_PAGE: {
      CONNECTED_KEY_SIMULATE_KEY:
        'If the pop-up appears, click Open AutoSky Plugin',
      EXECUTE_KEY: 'execute here',
      FIRST_ACCESS_KEY: 'If this is your first access to the portal',
      EXECUTE_PLUGIN_KEY: 'download and run the plugin',
      DOWNLOAD_FILE_RDP_KEY:
        'Download the connection file, run it and enter your access password again',
      WAIT_EXECUTE_APP_KEY:
        'If your application has not yet been opened, wait a few more minutes',
      DOWNLOAD_FILE_CONNECTION_KEY: 'Download connection file',
      CONNECTION_FILE_KEY: 'Download the connection RDP file',
      RDP_HELP_KEY: 'Need help? Click here for more info.',
      ACCESS_TRAINING_APP_KEY:
        'Access to your training environment is now ready!',
      CONNECTED_KEY_SIMULATE_CONTENT_HELP_KEY:
        'If AutoSky Plugin is installed and did not display any popup',
      TEST_REMOTE_APP_LOADING_KEY: 'Loading your application. Stand by...',
      TEST_REMOTE_APP_FINISH_KEY: 'Connection established!',
      TEST_REMOTE_APP_MSG_KEY: ' If your application has not been opened yet',
      TEST_REMOTE_APP_CLICK_HERE_KEY: 'click here',
      TEST_REMOTE_APP_INSTALL_PLUGIN_TITLE_KEY:
        'Installation of Autosky connection plugin',
      TEST_REMOTE_APP_INSTALL_PLUGIN_STEP1_KEY:
        '1. Click the download plugin button.',
      TEST_REMOTE_APP_INSTALL_PLUGIN_KEY: 'Download plugin',
      TEST_REMOTE_APP_INSTALL_PLUGIN_STEP2_KEY:
        '2. Proceed with the plugin installation process.',
      TEST_REMOTE_APP_INSTALL_PLUGIN_STEPS_TITLE_KEY:
        'Follow the installation step by step below:',
      TEST_REMOTE_APP_INSTALL_DOWNLOAD_NOT_INIT_KEY: 'If the download fails',
      TEST_REMOTE_APP_INSTALL_MANUAL_KEY: 'to install manually',
      TEST_REMOTE_APP_KEEP_GOING_KEY: 'Continue >>',
      TEST_REMOTE_APP_CONFIRM_KEY: 'to confirm the plugin installation.',
      CLIENT_APPLICATIONS_CODE: 'Code',
      APPLICATION_NAME_KEY: 'Application name',
      SEARCH_APPLICATION_KEY: 'Search application',
      APPLICATION_ADDRESS_KEY: 'Application address',
      YOUR_APPLICATIONS_KEY: 'Your applications',
      STARTUP_PARAMETER_KEY: 'Startup parameter',
      OPEN_APPLICATIONS_TEST_KEY: 'Test application opening',
      CREDENTIALS_USER_KEY: 'User connection simulation credentials',
      SELECT_CLIENT_TO_SIMULATE_APP_KEY:
        'Select the client you want to perform the application opening test on:',
      SIMULATE_APP_EXPLANATION_KEY:
        'This feature allows you to test client settings before publishing to users.',
      ADD_APPLICATIONS_KEY: 'Add applications',
      ADD_APPLICATION_KEY: 'Add application',
      APPLICATION_ADDED_SUCCESS_KEY: 'Application successfully added!',
      APPLICATION_EDITED_SUCCESS_KEY: 'Application successfully edited!',
      REMOVED_APPLICATION_KEY: 'Application successfully deleted!',
      SELECT_APPLICATION_KEY: 'Select the applications you wish to include',
      DISABLE_SELECT_KEY: 'Disable selected',
      DISABLE_APLICATIONS_KEY: 'Disable applications',
      EDIT_APLICATIONS_KEY: 'Edit applications',
      APPLICATIONS_WILL_BE_DISABLE_KEY:
        'Applications will be disabled, this may take a few minutes',
      REMOVE_APPLICATIONS_KEY: 'Do you wish to delete these applications?',
      IRREVERSIBLE_ACTION_APPLICATION_KEY:
        'This action is irreversible, the informations will not be recoverable',
      DISABLE_APPLICATIONS_KEY: 'Do you wish to disable these applications?',
      DISABLE_APPLICATIONS_MINUTES_KEY: 'The application will be disabled',
      ENABLE_APPLICATIONS_KEY: 'Do you wish to enable these applications?',
      ENABLE_APPLICATIONS_MINUTES_KEY: 'The applications will be enabled',
      NO_APPLICATIONS_FOUND_KEY: 'No applications found.',
      DISPLAY_APPLICATION_NAME_KEY: 'Application display name',
      DISABLE_PLUGIN_KEY: 'Disable plugin connection status?',
      KEEP_ALIVE_PARAMETER_KEY: 'Activate KeepAlive parameter?',
      OPEN_APPLICATION_KEY: 'Open application',
      OPEN_APPLICATION_WITH_REMOTE_APP_KEY: 'Open application with Remote App',
      USE_EXISTING_USER_KEY: 'Use existing user',
      USE_TEMPORARY_USER_KEY: 'Use temporary user',
      DISABLE_APPLICATION_KEY: 'Do you want to disable this application?',
      ENABLE_APPLICATION_KEY: 'Do you want to enable this application?',
      REMOVE_APPLICATION_KEY: 'Do you want to delete this application?',
      EDIT_APPLICATION_KEY: 'Edit application',
      WEB_CLIENT_APP_KEY: 'Web applications',
      DEFAULT_APP_KEY: 'Standard applications',
    },

    // Users
    USER_NAME_KEY: 'User name',

    // Company
    COMPANY_NAME_KEY: 'Company name',
    OPERATOR_VIEW_COMPANY_NAME_KEY: 'Company',
    CORPORATE_NAME_KEY: 'Corporate name',
    ADD_COMPANY_KEY: 'Add company',
    EDIT_COMPANY_KEY: 'Edit company',
    REMOVE_COMPANY_KEY: 'Delete company',
    BLOCK_COMPANY_KEY: 'Block company',
    UNBLOCK_COMPANY_KEY: 'Unblock company',
    NO_COMPANY_KEY: 'No companies found.',
    COMPANY_UPDATED_SUCCESSFULLY_KEY: 'Company successfully updated!',
    COMPANY_BLOCKED_SUCCESSFULLY_KEY: 'Company successfully blocked!',
    COMPANY_UNBLOCKED_SUCCESSFULLY_KEY: 'Company successfully unblocked!',

    RESPONSIBLE_KEY: 'Responsible',
    RESPONSIBLE_NAME_KEY: 'Responsible name',
    RESPONSIBLE_EMAIL_KEY: 'Responsible e-mail',
    RESPONSIBLE_PHONE_KEY: 'Responsible phone number',

    COMPANIES_PAGE: {
      LIST_COMPANIES_TITLE_KEY: 'List of companies',
      LIST_COMPANIES_SUBTITLE_KEY: 'List of companies available',
      ADD_COMPANY_TITLE_KEY: 'Add company',
      ADD_COMPANY_SUBTITLE_KEY: 'Fill in the data to start company inclusion',
      DETAILS_COMPANY_TITLE_KEY: 'Company details',
      DETAILS_COMPANY_SUBTITLE_KEY: 'General company information',
      CONSULT_COMPANY_TITLE_KEY: 'Company resources',
      CONSULT_COMPANY_SUBTITLE_KEY: 'Consult data of {{name}}',

      REMOVE_COMPANY_DESCRIPTION_KEY: "This company's data will be lost.",

      BLOCK_COMPANY_TITLE_KEY: 'Do you wish to block the company?',
      BLOCK_COMPANY_DESCRIPTION_KEY: 'Company {{name}} will be blocked.',
      UNBLOCK_COMPANY_TITLE_KEY: 'Do you wish to unblock the company?',
      UNBLOCK_COMPANY_DESCRIPTION_KEY: 'Company {{name}} will be unblocked.',
      PORTAL_DELETED_TEXT_KEY:
        'The company is no longer active on the portal. Contact the administrator',
    },

    // panel
    PANEL_PAGE: {
      TOTAL_ENVIRONMENT_KEY: 'Environments',
      TOTAL_ENVIRONMENT_INSTANCE_KEY: 'Env. with instances',
      PERCENT_ACTIVE_INSTANCE_KEY: 'Active environments',
      TOTAL_PARTNER_KEY: 'Accounts',
      TOTAL_CLIENTS_KEY: 'Clients',
      TOTAL_USERS_KEY: 'Users',
      TOTAL_SESSIONS_KEY: 'Sessions',
      PANEL_AUTO_KEY: 'Autosky dashboard',
      ADD_OR_EDIT_KEY: 'Add or edit',
      LIST_CLIENTS_ACESS_KEY: 'Access the list of clients',
      LIST_PARTNER_ACESS_KEY: 'Access the list of accounts',
      LIST_ENVIRONMENTS_ACESS_KEY: 'Access the list of environments',
      CLIENTS_AUTO_SKY_KEY: 'Autosky clients',
      ENVIRONMENTS_AUTO_SKY_KEY: 'Autosky environments',
      ADMINISTRATION_AUTO_SKY_KEY: 'Autosky administration',
      PIN_VIEW_DEFAULT: 'Favorite a card to add to your dashboard',
      FAVORITES_CARDS_KEY: 'Your favorite cards are displayed below',
      QUALITY_ENVIRONMENTS_KEY: 'Environments',
      ACTIVE_ENVIRONMENTS_KEY: 'Environments currently active',
      ENVIRONMENTS_PARTNER_KEY: 'Environments in use by accounts',
      ACTIVE_USERS_KEY: 'Active users',
      QUICK_MENU: 'Quick menu',
      AMOUNT_PARTNER_KEY: 'Number of accounts',
      COUNT_CLIENTS_KEY: 'Number of clients',
      ACTIVE_CLIENTS_KEY: 'Number of active clients',
      AVERAGE_CLIENTS_KEY: 'Average usage by clients',
      PUSH_PIN_BUTTON_KEY: 'Pin to default view',
      AUTO_KEY_DOCUMENTATION: 'Access Autosky documentation',
      ACCESS_LIST_PARTNER_KEY: 'Access account listing',
      MY_PROFILE_AUTO_SKY_KRY: 'Access my Autosky profile',
      OPEN_CALL_KEY: 'Open ticket',
      SEND_SUGGESTION: 'Send suggestion',
      SEND_SUGGESTION_DESCRIPTION_KEY:
        "Do you have any suggestions to improve Autosky platform? Just fill out the form below, and we'll be in touch shortly.",
    },

    // Operators
    ADD_OPERATOR_KEY: 'Add operator to group',
    EDIT_OPERATOR_KEY: 'Edit operator',
    REMOVE_OPERATOR_KEY: 'Delete operator',
    RESET_PASSWORD_MSG_KEY: 'An e-mail will be send to address {{email}}',
    SUCCESS_RESET_PASSWORD: 'Password reset successfully requested!',
    BLOCK_FALSE_OPERATOR_KEY: 'Block operator',
    BLOCK_TRUE_OPERATOR_KEY: 'Unblock operator',
    NO_OPERATOR_KEY: 'No operators found.',
    OPERATOR_BLOCKED_SUCCESSFULLY_KEY: 'Operator successfully blocked!',
    OPERATOR_UNBLOCKED_SUCCESSFULLY_KEY: 'Operator successfully unblocked!',
    OPERATOR_ADDED_SUCCESSFULLY_KEY: 'Operator successfully added!',
    OPERATOR_UPDATED_SUCCESSFULLY_KEY: 'Operator successfully updated!',
    OPERATOR_REMOVED_SUCCESSFULLY_KEY: 'Operator successfully deleted!',

    RESET_PASSWORD_OPERATOR_KEY: 'Operator password recovery',
    SEND_BY_EMAIL_KEY: 'Send via e-mail',
    EMAIL_SENT_KEY: "E-mail sent to the operator's e-mail address!",
    INSERT_MANUALLY_KEY: 'Manually insert password',

    OPERATORS_PAGE: {
      ADD_OPERATOR_TOOLTIP_KEY:
        'The chosen company will not be reflected in the permission, it is used only for organizational purposes',
      RESET_MFA_OPERATOR_KEY:
        'Do you wish to reset operator {{firstName}} {{lastName}} MFA?',
      LIST_OPERATORS_TITLE_KEY: 'Operators list',
      LIST_OPERATORS_SUBTITLE_KEY: 'List of available operators',
      ADD_OPERATOR_TITLE_KEY: 'Add operator',
      ADD_OPERATOR_SUBTITLE_KEY: 'Fill in the data to start operator inclusion',
      EDIT_OPERATOR_TITLE_KEY: 'Edit operator',
      EDIT_OPERATOR_SUBTITLE_KEY: 'Change this data to edit the operator',

      REMOVE_OPERATOR_TITLE_KEY: 'Delete {{name}}',
      REMOVE_OPERATOR_DESCRIPTION_KEY: "This operator's data will be lost.",

      BLOCK_OPERATOR_TITLE_KEY: 'Do you wish to block this operator?',
      BLOCK_OPERATOR_DESCRIPTION_KEY: 'Operator {{name}} will be blocked.',
      UNBLOCK_OPERATOR_TITLE_KEY: 'Do you wish to unblock this operator?',
      UNBLOCK_OPERATOR_DESCRIPTION_KEY: 'Operator {{name}} will be unblocked.',
      APIS_OPERATOR_NOT_FOUND: 'No API integration data',
      REQUIRES_IP_VALIDATION: 'Requires IP validation',
      EDIT_TOKEN_KEY: 'Edit token',
      ADD_TOKEN_KEY: 'Add token',
      API_INTEGRATION_IPS_KEY: 'API integration',
      FILTER_TO_IPS: 'Filter by IPs',

      REMOVE_TOKEN_TITLE_KEY: 'Delete token',
      REMOVE_TOKEN_DESCRIPTION_KEY:
        'This token {{name}} will be deleted. This action is definitive.',

      TOKEN_UPDATED_SUCCESSFULLY_KEY: 'Token successfully updated!',
      CREATED_AT_KEY: 'Created at',
      CREATED_BY_KEY: 'Created by',
      TIME_AT_KEY: 'at',
      MANAGE_PERMISSIONS_KEY: 'Manage permission groups',
    },

    // Clients
    CLIENT_NAME_KEY: "Client's name",
    ADD_CLIENT_KEY: 'Add client',
    ADD_CLIENT_DESCRIPTION_KEY: 'Fill in the data to include a new client',
    REMOVE_CLIENT_KEY: 'Delete client',
    REMOVE_SESSIONS_KEY: 'Delete sessions',
    REMOVE_SESSIONS_SELECTED_KEY: 'Delete selected sessions',
    VIEW_LOGS_KEY: 'View logs',
    CLIENT_ID_KEY: 'Client ID',
    ADMIN_EMAIL_KEY: "Administrator's e-mail",
    CLIENT_EXTERNAL_CODE_KEY: "Client's external code",
    SORT_ADMIN_EMAIL_KEY: 'Admin e-mail',
    LIMIT_LICENSES_KEY: 'Licenses limit',
    ACTIVE_SESSIONS_KEY: 'Active sessions',
    PERMANENT_KEY: 'Permanent',
    STATUS_REQUESTED_KEY: 'Requested',
    STATUS_FINISHED_KEY: 'Finished',
    STATUS_STARTED_KEY: 'Cloning',
    REMOTE_PROFILE_KEY: 'Remote profile',
    ADDRESS_REMOTE_PROFILE_KEY: 'Remote profile address',
    ACTIVE_REMOTE_PROFILE_KEY: 'Activate remote profile',
    DISABLE_REMOTE_PROFILE_KEY: 'Disable remote profile',
    ACTIVE_DISABLE_PROFILE_MSG_KEY:
      'Do you wish to {{active}} remote profile for user {{name}}?',
    VIRTUALIZER_KEY: 'Virtualizer',
    PROFILE_PATH_KEY: 'Profile path',
    MAIN_PORT_KEY: 'Main port',
    WEB_PORT_KEY: 'Web port',
    RESTRICTIONS_KEY: 'Access restrictions',
    BY_TIME_KEY: 'By time',
    BY_IP_KEY: 'By IP address',
    RELEASED_IP_ADDRESSES_KEY: 'Released IP addresses',
    START_RESTRICTION_AT_KEY: 'Start restriction at',
    ERROR_PERIOD_KEY: 'You must select at least one day',
    END_RESTRICTION_AT_KEY: 'End restriction at',
    CONFIGURE_PASSWORD_KEY: 'Password settings',
    IMPORT_FILE_KEY: 'Import file',
    DELETE_SUCCESS_MESSAGE_KEY: 'Client successfully deleted!',
    LICENSES_PER_CLIENTS: 'Licenses limit per client',
    INVALID_PAYLOAD_APPLICATION_MODE_KEY: '"Mode" field is invalid.',
    NO_CLIENT_KEY: 'No clients found',
    USE_ENVIRONMENT_VIRTUALIZER_KEY:
      'Use the same virtualizer as the environment',
    USE_PARTNER_NEW_FRONT_KEY: 'Use the same interface as the client account',
    USE_ENVIRONMENT_CONNECTION_TYPE_KEY:
      'Use the same connection type as the environment',
    ENVIRONMENT_CONNECTION_TYPE_DISABLED_EXPLANATION_KEY:
      'It is not possible to configure the client connection type while the “Allow connection type per client“ option is disabled in the environment',

    IMPORT_USER_ALERT_KEY:
      "By selecting set password, the system will use the password field in the spreadsheet to set the user's password. If this option is unmarked, the user will only be registered and the registration e-mail will be sent to the registered e-mail address.",

    ADD_USER_KEY: 'Add user',
    ADD_NEW_USER_KEY: 'Add new user',
    USER_ADDED_SUCCESSFULLY_KEY: 'User successfully added!',
    USER_DELETE_SUCCESS_MESSAGE_KEY: 'User successfully deleted!',
    USER_DELETE_PERMANENTLY_SUCCESS_MESSAGE_KEY:
      'User permanently deleted successfully!',
    IMPORT_USERS_KEY: 'Import users',
    IMPORT_USERS_SUCCESS_KEY: 'Users successfully imported!',

    ACTIVATE_SELECTED_KEY: 'Activate selected',
    INACTIVATE_SELECTED_KEY: 'Inactivate selected',
    WANT_ACTIVATE_USERS_KEY: 'Do you want to activate the selected users?',
    WANT_INACTIVATE_USERS_KEY: 'Do you want to deactivate the selected users?',
    ACTIVATE_SELECTED_DESCRIPTION_KEY:
      "Selected users regained access to the client's data with whom they are associated.",
    INACTIVATE_SELECTED_DESCRIPTION_KEY:
      'The selected users will not have access to the information of the client to which they are related.',
    ACTIVE_USER_KEY: 'The user {{id}} will be activated!',
    ACTIVATE_USERS_SUCCESS_KEY: 'Users successfully activated!',

    REMOVE_SELECTED_KEY: 'Delete selected',
    WANT_REMOVE_SELECTED_KEY: 'Do you wish to delete selected users?',
    REMOVE_SELECTED_DESCRIPTION_KEY:
      'This action is irreversible and the data will not be recoverable.',
    REMOVE_SELECTED_SUCCESS_KEY: 'Users successfully deleted!',
    ACTIVE_USER_SELECTED_SUCCESS_KEY: 'Users successfully activated!',
    INACTIVATE_USERS_SUCCESS_KEY: 'Users successfully inactivated!',

    IMPORT_CUSTOM_USERS_KEY: 'Import custom users',
    IMPORT_USUER_CUSTOM_MSG_KEY: 'Users with custom clients',
    CHOOSE_CSV_FILE_KEY:
      'Choose a CSV file to import users. Make sure send the file with UTF-8 encoding.',
    IMPORT_CLIENTS_KEY: 'Import clients',
    IMPORT_CLIENT_SUCCESS_KEY: 'Client successfully imported!',

    SCHEDULED_USER_IMPORT_SUCCESSFULLY:
      'File forwarded to the importation queue. After the importation is completed, a confirmation email will be sent to the administrator.',
    SCHEDULED_CLIENTS_IMPORT_SUCCESSFULLY:
      'File forwarded to the importation queue. After the importation is completed, a confirmation email will be sent to the administrator.',
    INVALID_CSV_FILE: 'Invalid CSV file. Check your CSV file and try again.',

    EXPORT_CSV_KEY: 'Export CSV',
    WANT_EXPORT_CSV_KEY: 'Do you wish to export a CSV file?',
    EXPORT_CSV_DESCRIPTION_KEY: 'Do you wish to export data in a CSV file?',
    EXPORT_CSV_SUCCESS_KEY: 'Data successfully exported!',

    RESEND_PASSWORD_KEY: 'Resend password',
    WANT_RESEND_PASSWORD_KEY: 'Do you wish to resend the password?',
    RESEND_PASSWORD_DESCRIPTION_KEY:
      'The password will be resent to e-mail {{email}}',
    RESEND_PASSWORD_SUCCESS_KEY: 'Password resent successfully!',

    RESEND_PASSWORD_WITH_COPY_KEY: 'Resend password (with copy)',
    WANT_RESEND_PASSWORD_WITH_COPY_KEY:
      'Do you wish to resend the password with copy to the administrator?',
    RESEND_PASSWORD_WANT_COPY_DESCRIPTION_KEY:
      "A password reset email will be sent to {{email}} with copy to the client's administrator",
    RESEND_PASSWORD_TO_FICTITIOUS_EMAIL_KEY:
      "This user has a dummy e-mail. The password will be sent to the their administrator's e-mail ",
    WANT_DISABLE_USER_KEY: 'Do you wish to disable the user?',
    DISABLE_USER_DESCRIPTION_KEY:
      'The user will no longer have access to client data',
    DISABLE_USER_SUCCESS_KEY: 'User successfully deactivated!',

    EDIT_USER_KEY: 'Edit user',
    EDIT_USER_SUCCESS_KEY: 'User successfully edited!',

    WANT_REMOVE_USER_KEY: 'Do you wish to delete the user {{name}}?',
    REMOVE_USER_DESCRIPTION_KEY:
      'This action is irreversible and the data will not be recoverable',
    REMOVE_USER_SUCCESS_KEY: 'User successfully deleted!',

    WANT_REMOVE_SESSION_KEY: 'Do you wish to delete the session?',
    WANT_REMOVE_SESSION_MSG_KEY:
      'Do you wish to delete the session of user {{name}}?',
    REMOVE_SESSION_DESCRIPTION_KEY: 'User session {{name}} will be deleted',
    REMOVE_SESSION_SUCCESS_KEY: 'Session successfully deleted!',
    REMOVE_SESSION_ERROR_KEY:
      'Error while trying to delete this session. Try again later!',

    CLIENTS_PAGE: {
      LOADING_LIST_CLIENTES: 'Loading clients list',
      REMOVE_MULTIPLE_SESSIONS_TITLE_KEY: 'Delete multiple sessions',
      REMOVE_MULTIPLE_SESSIONS_DESCRIPTION_KEY:
        'The selected sessions will be deleted',
      SESSION_REMOVAL_TIMEOUT_KEY: 'Session removal timeout exceeded',
      EXPIRED_SESSION_HISTORY_KEY: 'Session expired',
      CLOSED_SESSION_HISTORY_KEY: 'Closed session',
      REMOVE_SESSION_HISTORY_KEY: 'Deleted instance',
      SESSION_HISTORY_KEY: 'Sessions history',
      NO_SESSION_HISTORY_KEY: 'No sessions history logs',
      ENABLED_MFA_ALL_USERS_TITLE_KEY: 'Enable MFA for all users',
      DISABLED_MFA_ALL_USERS_TITLE_KEY: 'Disable MFA for all users',
      ENABLED_MFA_ALL_USERS_MSG_KEY:
        'MFA will be enabled for all users of client {{name}}',
      DISABLED_MFA_ALL_USERS_MSG_KEY:
        'MFA will be disabled for all users of client {{name}}',
      MFA_USER_RESET_TITLE_KEY: 'Do you wish to reset the MFA?',
      MFA_USER_RESET_MSG_KEY: 'MFA will be reset to user {{name}}!',
      USER_NO_LINKED_INSTANCE_KEY: 'User not linked to an instance',
      NEW_CLONE_CLIENT_KEY: "New client's name",
      CLONE_CLIENT_KEY: 'Clone client',
      LIST_CLIENTS_TITLE_KEY: 'Clients list',
      NO_CLIENTS_KEY: 'No clients found.',
      WANT_REMOVE_CLIENT_KEY: 'Do you wish to delete the client?',
      REMOVE_CLIENT_WARNING_MSG_KEY:
        'Client {{name}} will be deleted and their data will not be recoverable.',
      CREATED_CLIENT: 'Client successfully created!',

      LIST_LOGS_TITLE_KEY: 'Logs',
      LIST_LOGS_SUBTITLE_KEY: 'View environment data from the filters below',
      NO_LOGS_KEY: 'No logs found.',

      LIST_SESSIONS_TITLE_KEY: 'Sessions',
      NO_SESSIONS_KEY: 'No sessions found.',

      RESTRICTIONS_TITLE_KEY: 'Access restrictions',
      RESTRICTIONS_SUBTITLE_KEY: 'Access restrictions',

      LIST_USERS_TITLE_KEY: 'Users',
      LIST_USERS_SUBTITLE_KEY: 'Manage all registered users',
      NO_USERS_KEY: 'No users found.',

      EDIT_CLIENT_KEY: 'Edit client',
      UPDATED_SUCCESSFULLY_KEY: 'Client successfully updated!',

      REMOVE_CLIENT_KEY: 'Delete client',
      REMOVE_CLIENT_DESCRIPTION_KEY: 'Client {{name}} will be deleted.',

      // Form
      ALWAYS_COPY_ADMIN_KEY:
        "Always copy the client's registered Administrator on e-mail communications",
      SORT_ALWAYS_COPY_ADMIN_KEY: 'Always copy administrator',
      BLOCK_MULTIPLE_SESSIONS_KEY:
        'Block multiple sessions from the same user?',
      USE_IOS_DEVICES_KEY: 'Use iOS devices?',

      FIELD_INVALID_IP_ADDRESS_KEY:
        'The field above contains invalid IP addresses',
      ALLOWED_IPS_UPDATED_KEY: 'IP addresses successfully updated!',

      ACCESS_CONTROL_UPDATED_KEY: 'Access control successfully updated!',
    },

    LICENSE_LIMIT: 'License limit exceeded',

    // Groups
    ADD_GROUP_KEY: 'Add group',
    EDIT_GROUP_KEY: 'Edit group',
    EDIT_INFO_KEY: 'Edit data',
    REMOVE_SELECTED_GROUPS_KEY: 'Delete selected groups',
    GROUP_KEY: 'Group name',
    CREATED_BY_KEY: 'Created by',
    CREATED_AT_KEY: 'Creation close',
    UPDATED_AT_KEY: 'Close updated',
    UPDATED_BY_KEY: 'Modified By',
    ACTIVATED_KEY: 'Activated',
    RESTRICTED_OPERATORS_KEY: 'Restricted operators',
    ITEMS_TO_ADD_KEY: 'Items to add',
    NO_ADDED_COMPANY_KEY: 'No company added',
    NO_ADDED_PARTNER_KEY: 'No account added',
    NO_ADDED_ENVIRONMENT_KEY: 'No environment added',
    NO_ADDED_CLIENT_KEY: 'No client added',
    NO_ADDED_OPERATOR_KEY: 'No operator added',
    ACTIVATE_USER: 'Activate user',
    CLIENT_ACCESS_CONTROL: 'Access control for clients',
    CREATE_NEW_USER: 'Create new user',
    DELETE_USER: 'Delete user',
    DELETE_USER_PERMANENTLY: 'Delete user permanently',
    INACTIVATE_USER: 'Deactivate user',
    LIST_AVAILABLE_APPLICATIONS: 'List available applications',
    LIST_SESSION_HISTORY: 'View sessions history',
    RESET_USER_MFA: 'Reset MFA',
    CAN_IMPORT_USERS_IN_ALL_CLIENTS: 'Import users on all clients',
    CLONE_CLIENT: 'Clone client',
    DELETE_APPLICATION: 'Delete application',
    EDIT_APPLICATION: 'Edit application',
    EDIT_CLIENT_SCHEDULED_WARNINGS: 'Edit scheduled alerts for clients',
    INCLUDE_APPLICATION: 'Include application',
    LIST_CLIENT: 'List clients',
    LIST_CLIENT_SCHEDULED_WARNINGS: 'List scheduled alerts for clients',
    LIST_CLIENT_INSTANCE_SESSIONS: 'List sessions',
    DELETE_CLIENT_INSTANCE_SESSIONS: 'End sessions',
    LIST_USERS: 'List users',
    RESET_USER_PASSWORD: "Reset user's password",
    CAN_SIMULATE_APPLICATIONS: 'Application opening test',
    CREATE_NEW_APPLICATION: 'Create application',
    DELETE_CLIENT: 'Delete client',
    EDIT_CLIENT: 'Edit client',
    EDIT_USER_DETAILS: 'Edit user',
    LIST_APPLICATIONS: 'List applications',
    LIST_APPLICATIONS_ENVIRONMENT: 'List applications by environment',
    CREATE_APPLICATIONS_ENVIRONMENT:
      'Add client applications to the environment - Autosky mode',
    CHANGE_APPLICATIONS_NAME_ENVIRONMENT:
      'Rename client applications in the environment - Autosky mode',
    REMOVE_APPLICATIONS_ENVIRONMENT:
      'Remove client applications from the environment - Autosky mode',
    CHANGE_APPLICATIONS_STATE_ENVIRONMENT:
      'Activate/deactivate client applications in the environment - Autosky mode',
    CHANGE_APPLICATIONS_ATTACHMENT_ENVIRONMENT:
      'Link/unlink client applications in the environment - Platform mode',
    LIST_INCLUDED_APPLICATIONS: 'List included applications',
    REMOVE_INCLUDED_APPLICATION: 'Delete applications',
    ATTACH_PREPARATION_SERVER: 'Add preparation server',
    CAN_BLOCK_ENVIRONMENT_INSTANCES: 'Block scaling instance',
    DELETE_USER_THEME_CONFIG: 'Delete custom theme config',
    CAN_LIST_ENV_SCHEDULED_WARNINGS_DETAILS:
      'List details of scheduled maintenance notices',
    CAN_REGISTER_ENVIRONMENT_INSTANCES: 'Register new instance',
    CAN_UNBLOCK_ENVIRONMENT_INSTANCES: 'Unblock scaling instance',
    CREATE_NEW_CLIENT: 'Create client',
    DELETE_MODELS: 'Delete model',
    EDIT_BEHAVIOR: 'Edit behavior settings',
    EDIT_MODELS: 'Edit models',
    LIST_ENVIRONMENT_DASHBOARD: 'Display environment dashboard',
    LIST_ENVIRONMENT_INSTANCES: 'List environment instances',
    LIST_ENVIRONMENT_INCIDENTS: 'Monitoring dashboard',
    LIST_PROVIDER_RESOURCES: 'List provider resources',
    START_PREPARATION_SERVER: 'Start preparation server',
    STOP_SUPPORT_SERVER: 'Shut down support server',
    ATTACH_SUPPORT_SERVER: 'Add support server',
    CAN_CONNECT_INSTANCE: 'Connect as',
    CAN_EDIT_ENV_SCHEDULED_WARNINGS: 'Manage warning schedules',
    CAN_RESTART_ENVIRONMENT_INSTANCES: 'Restart instance',
    CAN_UNREGISTER_ENVIRONMENT_INSTANCES: 'Unlink instances',
    UNREGISTER_INSTANCES: 'Unregister instance',
    DELETE_ENVIRONMENT: 'Delete environment',
    DETACH_PREPARATION_SERVER: 'Unlink preparation server',
    EDIT_ENVIRONMENT: 'Edit environment',
    EDIT_PASSWORD_REQS: 'Manage password policies',
    LIST_ENVIRONMENT_DETAILS: 'List environment details',
    LIST_MODELS: 'List models',
    LIST_SUPPORT_SERVERS: 'List support servers',
    EDIT_SCALING_ADVISOR: 'Edit Scaling Advisor',
    LIST_SCALING_ADVISORS: 'List Scaling Advisors',
    LIST_SCALING_ADVISOR_DETAILS: 'List Scaling Advisor details',
    LIST_SCALING_ADVISOR: 'List Scaling Advisor',
    DELETE_SELF_OPERATOR: 'Delete your own operator',
    CREATE_SELF_API_TOKEN: 'Create your own API token',
    LIST_SELF_OPERATOR_TOKEN: 'List your  own API token',
    LIST_SELF_OPERATOR: 'List your own operator',
    DELETE_SELF_API_TOKEN: 'Delete your own API token',
    EDIT_SELF_OPERATOR_DETAILS: 'Edit your own operator details',
    LIST_SELF_OPERATOR_DETAILS: 'List your own operator details',
    RESET_SELF_OPERATOR_MFA: 'Reset your own MFA',
    EDIT_SELF_API_TOKEN: 'Edit your own API token',
    START_SUPPORT_SERVER: 'Turn support server on',
    CAN_ACTIVATE_ENVIRONMENT_INSTANCES: 'Start scaling instance',
    CAN_IMPORT_CLIENTS: 'Clients importation',
    CAN_TERMINATE_ENVIRONMENT_INSTANCES: 'Terminate scaling instance',
    CREATE_MODELS: 'Create model',
    DELETE_ENVIRONMENT_INSTANCE_SESSIONS: 'End session',
    DETACH_SUPPORT_SERVER: 'Unlink support server',
    EDIT_GOVERNANCE: 'Edit governance',
    LIST_ENVIRONMENT: 'List environments',
    LIST_ENVIRONMENT_INSTANCE_SESSIONS: 'List instances sessions',
    LIST_PREPARATION_SERVERS: 'List preparation servers',
    PUBLISH_IMAGE: 'Publish image',
    PUBLISH_IMAGE_V2: 'Publish image (optimized)',
    PUBLISH_IMAGE_PARTNER_SERVERS:
      'Publish image on servers in account (optimized)',
    STOP_PREPARATION_SERVER: 'Shut down preparation server',
    CREATE_NEW_PARTNER: 'Create account',
    LIST_ALL_COMPANIES: 'View related companies',
    LIST_COMPANY_USERS: 'View company users',
    DELETE_COMPANY: 'Delete company',
    LIST_COMPANY_DASHBOARD: 'Company dashboard',
    EDIT_COMPANY_DETAILS: 'Edit company',
    LIST_COMPANY_DETAILS: 'View company details',
    CAN_TEST_LDAP: 'Test LDAP',
    CAN_CHANGE_EXTERNAL_AD_PASSWORD: 'Change AD administrative user password',
    EDIT_PARTNER_DETAILS: 'Edit account',
    LIST_PARTNER_DETAILS: 'List account details',
    LIST_USER_THEME_CONFIG: 'List frontend customization for account',
    CREATE_USER_THEME_CONFIG: 'Create frontend customization for account',
    EDIT_USER_THEME_CONFIG: 'Edit frontend customization for account',
    DELETE_USER_THEME_IMAGE: 'Delete frontend customization for account',
    PUBLISH_USER_THEME_CONFIG: 'Publish frontend customization for account',
    CREATE_NEW_ENVIRONMENT: 'Create new environment',
    LIST_ALL_PARTNERS: 'List accounts',
    LIST_ALL_USERS: 'List all users',
    USERS_RECOVERY: 'User recovery',
    DELETE_PARTNER: 'Delete account',
    LIST_PARTNER_DASHBOARD: 'Dashboard',
    CREATE_ALL_ROLES: 'Create permission group',
    CREATE_NEW_OPERATOR: 'Create operator',
    DELETE_OPERATOR: 'Delete operator',
    EDIT_OPERATOR_DETAILS: 'Edit operator',
    LIST_ALL_ROLES: 'List permission group',
    CREATE_API_TOKEN: 'Create API token',
    DELETE_ALL_ROLES: 'Delete permission group',
    EDIT_ALL_ROLES: 'Edit permission group',
    CAN_CLONE_ROLE: 'Clone permission group',
    LIST_ALL_OPERATOR_TOKEN: 'List operator tokens',
    LIST_ALL_OPERATORS_AUDIT_LOGS: 'List audit logs',
    EDIT_IFRAME_MAX_LENGTH:
      'Edit maximum connection string size with Autosky Plugin',
    LIST_IFRAME_MAX_LENGTH:
      'See maximum connection string size with Autosky Plugin',
    LIST_OPERATOR_DETAILS: 'List operator details',
    CREATE_NEW_COMPANY: 'Create company',
    DELETE_API_TOKEN: 'Delete API token',
    EDIT_API_TOKEN: 'Edit API token',
    LIST_ALL_OPERATORS: 'List operators',
    RESET_OPERATOR_MFA: 'Reset MFA',
    DOWNLOAD_CSV_TOKEN_KEY: 'Download token CSV',
    CREATED_TOKEN_TITLE_KEY: 'Operator token',
    LIST_ENVIRONMENT_COST: 'List environment cost',
    CAN_VIEW_ENVIRONMENT_LICENSES: 'Display the quantity of licenses',
    MIGRATE_ENVIRONMENT: 'Migrate environment',
    INACTIVATE_USER_RESET_PASSWORD_AT_LOGIN:
      'Inactivate reset password at login',
    ACTIVATE_USER_RESET_PASSWORD_AT_LOGIN: 'Activate reset password at login',
    DISABLE_USER_DEVICES: 'Disable user devices',
    LIST_USER_DEVICES: 'List user devices',
    ENABLE_DEVICE_VALIDATION_BYPASS: 'Enable device validation bypass',
    DISABLE_DEVICE_VALIDATION_BYPASS: 'Disable device validation bypass',

    EDIT_ENV_AUTO_REMOVE_USER_SESSION_MAINTENANCE:
      'Edit user session removal details',
    LIST_ENV_REMOVE_SESSION_DETAILS: 'View user session removal details',
    EDIT_OPERATOR_ROLE: 'Edit operator role',

    ADMIN_KEY: 'Admin',
    SUPERADMIN_KEY: 'SuperAdmin',
    EMAIL_ADMIN_KEY: 'Admin e-mail',

    SEARCH_ENVIRONMENT_KEY: 'Search environment',
    SEARCH_CLIENT_KEY: 'Search client',
    SEARCH_OPERATOR_KEY: 'Search operator',

    PERMISSIONS_KEY: 'Permissions',
    PERMISSION_ROLES_KEY: 'Permission groups',
    DO_NOT_HAVE_PERMISSION_KEY: 'Restricted action',
    DO_NOT_HAVE_PERMISSION_MSG_KEY:
      'You do not have permission to perform this action',
    REMOVE_SELECTED_COMPANIES_KEY: 'Delete selected companies',
    REMOVE_SELECTED_PARTNERS_KEY: 'Delete selected accounts',
    REMOVE_SELECTED_ENVIRONMENTS_KEY: 'Delete selected environments',
    REMOVE_SELECTED_CLIENTS_KEY: 'Delete selected clients',
    REMOVE_SELECTED_OPERATORS_KEY: 'Delete selected operators',
    INFO_AUTOMATICALLY_ADDED_KEY:
      'Attention! The enabled option automatically adds new items to the group',
    NEW_COMPANIES_KEY: 'new companies',
    NEW_PARTNERS_KEY: 'new accounts',
    NEW_ENVIRONMENTS_KEY: 'new environments',
    NEW_CLIENTS_KEY: 'new clients',

    SELECT_ALL_COMPANIES_KEY: 'Select all companies for this group',
    SELECT_ALL_PARTNERS_KEY: 'Select all accounts for this group',
    SELECT_ALL_ENVIRONMENTS_KEY: 'Select all environments for this group',
    SELECT_ALL_CLIENTS_KEY: 'Select all clients for this group',

    MONITOR: {
      INCIDENTS_PANEL_TITLE: 'General monitoring dashboard',
      INCIDENTS_PANEL_FOLLOW_UP: 'Monitoring',
      INCIDENTS_PANEL_SUBTITLE:
        'List of environments with possible problems for analysis',
      PARTNER_NAME: 'Account',
      ENVIRONMENT_NAME: 'Environment',
      PROVIDER: 'Provider',
      SEC_PROCESSED: 'Processing seconds',
      BLOCKED_ENVIRONMENTS_TITLE: 'Blocked environments',
      NO_BLOCKED_ENVIRONMENTS: 'No blocked environments',
      ROBO_TYPE: 'Robot Type',
      STATUS: 'Status',
      INSTANCES: 'Instances',
      TEMPERATURE: 'Temperature',
      CONNECTED: 'Connected',
      LICENSES_TOTAL: 'Licenses total',
      VACANCIES: 'Vacancies',
      ENVIRONMENT_HEALTH_TITLE:
        'Check if there are environments with a possible lack of machine to be analyzed',
      NO_RESULTS_ENVIRONMENT_HEALTH: 'No environments to analyze',
      FLAVOR: 'Flavor',
      ZONE: 'Zone',
      COUNT: 'Count',
      INSTANCES_STATUS_TITLE:
        'Instances with activation issues in the last hour for analysis',
      INSTANCES_WITH_SESSION_TIMEOUT_TITLE:
        'Instances with multiple expired sessions',
      NO_RESULTS_INSTANCES: 'No results',
      CARD_ENVIRONMENT_HEALTH: 'Environments for analysis',
      CARD_BLOCKED_ENVIRONMENTS: 'Locked environments',
      CARD_INSTANCES: 'Instances for analysis',
      RELOAD: 'Reload',

      ENVIRONMENTS_TOTAL: 'Environments total',
      INSTANCES_TOTAL: 'Instances total',
      SESSIONS_TOTAL: 'Sessions total',
      BLOCKED_QUEUES: 'Blocked queues',
      ENVIRONMENTS_WITH_FAILED_ZERO_TRUST: 'Zero Trust failed environments',
      BLOCKED_QUEUES_LIST_TITLE: 'List of blocked queues',
      BLOCKED_QUEUES_DESCRIPTION: 'Blocked queues:',
      ANY_QUEUE_BLOCKED: 'All queues are operational',

      ANALYZE_STATUS_KEY: 'Analyze',
      NORMAL_STATUS_KEY: 'Normal',
      TOTAL_FAILED_SESSIONS_KEY: 'Failed sessions',
      TOTAL_FAILED_SESSIONS_PERCENTAGE_KEY: 'Failed percentage',
    },

    GROUPS_PAGE: {
      REMOVE_WARNING_MSG_KEY:
        '{{name}} will be deleted and the data will not be recoverable.',
      ACTION_IS_IRREVERSIBLE_KEY:
        'This action is irreversible, the data will not be recoverable',

      LIST_GROUPS_TITLE_KEY: 'Permission groups',
      LIST_GROUPS_SUBTITLE_KEY: 'List of permission groups',
      LIST_GROUPS_CONTENT_TITLE_KEY: 'Your groups',
      LIST_GROUPS_CONTENT_SUBTITLE_KEY:
        'Add groups to manage their permissions',
      WANT_REMOVE_GROUP_KEY: 'Do you wish to delete the group?',
      WANT_REMOVE_SELECTED_GROUPS_KEY:
        'Do you wish to delete the selected groups?',
      NO_GROUPS_KEY: 'No groups found.',
      ADDED_GROUP_KEY: 'Group successfully added!',
      REMOVED_GROUP_KEY: 'Group successfully deleted!',
      UPDATED_GROUP_KEY: 'Group updated successfully!',

      REMOVED_ITEMS_KEY: 'Items successfully deleted!',

      LIST_COMPANIES_TITLE_KEY: 'List of companies',
      LIST_COMPANIES_SUBTITLE_KEY: 'Manage your companies',
      ADD_COMPANIES_KEY: 'Add companies',
      ADD_COMPANIES_SUBTITLE_KEY: 'Select and click add',
      WANT_REMOVE_COMPANY_KEY: 'Do you wish to delete the company?',
      WANT_REMOVE_SELECTED_COMPANIES_KEY:
        'Do you wish to delete the selected companies?',
      LIST_COMPANY_PERMISSIONS_KEY: 'Manage company permissions',
      ADDED_COMPANIES_KEY: 'Companies successfully added!',
      REMOVED_COMPANIES_KEY: 'Companies successfully deleted!',
      UPDATED_COMPANIES_KEY: 'Companies successfully updated!',

      LIST_PARTNERS_TITLE_KEY: 'List of accounts',
      LIST_PARTNERS_SUBTITLE_KEY: 'Manage your accounts',
      ADD_PARTNERS_KEY: 'Add accounts',
      ADD_PARTNERS_SUBTITLE_KEY: 'Select and click add',
      WANT_REMOVE_PARTNER_KEY: 'Do you wish to delete the account?',
      WANT_REMOVE_SELECTED_PARTNERS_KEY:
        'Do you wish to delete the selected accounts?',
      LIST_PARTNER_PERMISSIONS_KEY: 'Manage account permissions',
      ADDED_PARTNERS_KEY: 'Accounts successfully added!',
      REMOVED_PARTNERS_KEY: 'Accounts successfully deleted!',
      UPDATED_PARTNERS_KEY: 'Accounts successfully updated!',

      LIST_ENVIRONMENTS_TITLE_KEY: 'List of environments',
      LIST_ENVIRONMENTS_SUBTITLE_KEY: 'Manage your environments',
      ADD_ENVIRONMENTS_KEY: 'Add environments',
      ADD_ENVIRONMENTS_SUBTITLE_KEY: 'Select and click add',
      WANT_REMOVE_ENVIRONMENT_KEY: 'Do you wish to delete the environment?',
      WANT_REMOVE_SELECTED_ENVIRONMENTS_KEY:
        'Do you wish to delete the selected environments?',
      LIST_ENVIRONMENT_PERMISSIONS_KEY: 'Manage environment permissions',
      ADDED_ENVIRONMENTS_KEY: 'Environments added successfully!',
      REMOVED_ENVIRONMENTS_KEY: 'Environments successfully deleted!',
      UPDATED_ENVIRONMENTS_KEY: 'Environments successfully updated!',

      LIST_CLIENTS_TITLE_KEY: 'List of clients',
      LIST_CLIENTS_SUBTITLE_KEY: 'Manage your clients',
      ADD_CLIENTS_KEY: 'Add clients',
      ADD_CLIENTS_SUBTITLE_KEY: 'Select and click add',
      WANT_REMOVE_CLIENT_KEY: 'Do you wish to delete the client?',
      WANT_REMOVE_SELECTED_CLIENTS_KEY:
        'Do you wish to delete the selected clients?',
      LIST_CLIENT_PERMISSIONS_KEY: 'Manage clients permissions',
      ADDED_CLIENTS_KEY: 'Clients successfully added!',
      REMOVED_CLIENTS_KEY: 'Clients successfully deleted!',
      UPDATED_CLIENTS_KEY: 'Clients successfully updated!',

      LIST_OPERATORS_TITLE_KEY: 'List of operators',
      LIST_OPERATORS_SUBTITLE_KEY: 'Manage your operators',
      ADD_OPERATORS_KEY: 'Add operators',
      ADD_OPERATORS_SUBTITLE_KEY: 'Select and click add',
      WANT_REMOVE_OPERATOR_KEY: 'Do you wish to delete the operator?',
      WANT_REMOVE_SELECTED_OPERATORS_KEY:
        'Do you wish to delete the selected operators?',
      LIST_OPERATOR_PERMISSIONS_KEY: 'Manage operator permissions',
      ADDED_OPERATORS_KEY: 'Operators successfully added!',
      REMOVED_OPERATORS_KEY: 'Operators successfully deleted!',
      UPDATED_OPERATORS_KEY: 'Operators successfully updated!',
      SELECT_ALL_KEY: 'Select all',
      FRONTEND_CUSTOMIZATION_KEY: 'Front end customization',
      PREPARATION_SERVERS_KEY: 'Preparation servers',
      SUPPORT_SERVERS_KEY: 'Support servers',
      ALERTS_KEY: 'Alerts',
      MONITORS_KEY: 'Monitors',
      ASSOCIATE_KEY: 'Associate',
      NOT_ASSOCIATE_KEY: 'Not associated',

      CLONE_GROUP_KEY: 'Clone group',
      CLONE_GROUP_NAME_KEY: 'New group name',
      CLONE_GROUP_TO_CLONE_KEY: 'Group to be cloned',
      GROUP_CLONE_MESSAGE_KEY: 'The group was successfully cloned',
    },
    LIST_ALL_MONITORS: 'List all monitors',
    CAN_APPLY_SCALING_ADVISOR: 'Apply Scaling Advisor',
    CAN_IGNORE_SCALING_ADVISOR: 'Ignore Scaling Advisor',
    CAN_REVERT_SCALING_ADVISOR: 'Revert Scaling Advisor',

    PENDING_ADVISORS_KEY: 'Pending advisors',
    SUGGESTED_ADVISORS_KEY: 'Suggested advisors',
    APPLIED_ADVISORS_KEY: 'Applied advisors',
    NEW_PENDING_ADVISORS_KEY: 'New pending advisors',
    HISTORY_APPLIED_ADVISORS_KEY: 'Applied Advisors history',
    HISTORY_NOT_APPLIED_ADVISORS_KEY: 'Not applied advisors history',
    NO_ADVISOR_KEY: 'No advisors found.',
    EMPTY_INSTANCES_SUNDAY_KEY: 'Sunday',
    EMPTY_INSTANCES_SATURDAY_KEY: 'Saturday',
    EMPTY_INSTANCES_WEEKDAY_NIGHT_KEY: 'Weekday (night)',
    EMPTY_INSTANCES_WEEKDAY_KEY: 'Weekday',
    EMPTY_INSTANCES_ANY_DAY_KEY: 'Fortnightly',
    PENDING_KEY: 'Pending',
    IGNORED_KEY: 'Ignored',
    APPLIED_KEY: 'Applied',
    REVERTED_KEY: 'Reverted',
    NOT_APPLIED_KEY: 'Not applied',
    DEPRECIATED_KEY: 'Depreciated',
    EXPIRED_KEY: 'Expired',
    SUGGESTED_KEY: 'Suggested',
    DEACTIVATED_KEY: 'Deactivated',
    ON_DEMAND_KEY: 'On demand',
    SUPPORT_SERVERS_KEY: 'Support servers',
    ENVIRONMENT_STATUS_KEY: 'ENvironment status',
    ENVIRONMENTS_STATUS_KEY: 'Environments status',
    APPLIED_BY_KEY: 'Applied by',
    APPLIED_AT_KEY: 'Applied at',
    IGNORED_BY_KEY: 'Ignored by',
    IGNORED_AT_KEY: 'Ignored at',
    REVERTED_BY_KEY: 'Reverted by',
    REVERTED_AT_KEY: 'Reverted at',

    ADVISOR_PAGE: {
      LIST_ADVISORS_TITLE_KEY: 'List of advisors',
      LIST_ADVISORS_SUBTITLE_KEY: 'Manage your advisors',

      DASHBOARD_TITLE_KEY: 'Environment advisors',
      DASHBOARD_SUBTITLE_KEY: 'Manage environments advisors in a single place',

      ENVIRONMENTS_WITH_PENDING_ADVISORS_KEY:
        'Environments with pending advisors',
      TOTAL_ADVISORS_SUGGESTED_KEY: 'Total of advisors',
      TOTAL_ADVISORS_APPLIED_KEY: 'Total of applied advisors (30 days)',
      ESTIMATED_SAVINGS_FROM_SUGGESTED_KEY:
        'Estimated savings from suggested advisors',

      WANT_APPLY_ADVISOR_KEY: 'Do you wish to apply the advisor?',
      CONFIRM_APPLY_ADVISOR_KEY: 'Confirm below to apply the selected advisor.',
      WANT_IGNORE_ADVISOR_KEY: 'Do you want to ignore the advisor?',
      CONFIRM_IGNORE_ADVISOR_KEY: 'Enter below the reason:',
      WANT_REVERT_ADVISOR_KEY: 'Do you want to reverse the advisor?',
      CONFIRM_REVERT_ADVISOR_KEY:
        'Confirm below to revert the selected advisor.',
      ADVISOR_TYPE_DETAILS_KEY: 'Advisor type',
      OPERATION_MODE_DETAILS_KEY: "Environment's operation mode",
      PERIOD_KEY: 'Periods',
      MANUAL_KEY: 'Manual',
      MICRO_KEY: 'Micro',
      SPOT_PERIOD_KEY: 'Periods (Spot)',
      OPTIMIZATION_DETAILS_KEY: 'Optimization details',
      ESTIMATED_COST_SAVINGS_KEY: 'Estimated savings',
      ADVISOR_TYPE_EXPLANATION_BUTTON_KEY: 'Understand the types of advisors',
      ADVISOR_TYPE_EXPLANATION_KEY:
        'Check if there are instances running without user sessions during the following periods for each type of advisor',
      ADVISOR_WEEKDAY_KEY: 'Weekly advisor:',
      ADVISOR_WEEKDAY_EXPLANATION_KEY:
        'During the night on the last 15 working days (Monday to Friday), from 22:00 to 06:00.',
      ADVISOR_SATURDAY_KEY: 'Saturday advisor:',
      ADVISOR_SATURDAY_EXPLANATION_KEY:
        'During the last 4 Saturdays, from 06:00 to 06:00 on Sunday.',
      ADVISOR_SUNDAY_KEY: 'Sunday advisor:',
      ADVISOR_SUNDAY_EXPLANATION_KEY:
        'During the last 4 Sundays, from 06:00 to 06:00 on Monday.',
      ADVISOR_ANYDAY_KEY: 'Fortnightly advisor:',
      ADVISOR_ANYDAY_EXPLANATION_KEY:
        'During the last 15 days, from 00:00 to 23:59.',
      ADVISOR_COST_EXPLANATION_KEY:
        'Cost associated with not implementing pending advisors',
      ADVISOR_MONTHLY_SAVINGS_KEY: 'Estimated monthly savings',
      ENVIRONMENTS_COST_TITLE_KEY: 'Total cost of environments',
      MONTHLY_ENVIRONMENTS_COST_TITLE_KEY: 'Accumulated cost of environments',
    },

    // API Advisor
    ADVISOR_APPLIED: 'Advisor successfully applied!',
    ADVISOR_IGNORED: 'Advisor successfully ignored!',
    ADVISOR_REVERTED: 'Advisor successfully reverted!',
    SCALING_ADVISOR_APPLY_INCONSISTENT_PERIODS:
      'This environment has inconsistent periods in the database',
    SCALING_ADVISOR_APPLY_INVALID_STATUS:
      'Advisor invalid status, unable to apply advisor. Status must be "pending".',
    SCALING_ADVISOR_APPLY_UNKNOWN_ENVIRONMENT:
      'Unknown environment for applying Scaling Advisor',
    SCALING_ADVISOR_APPLY_INVALID_ENVIRONMENT_OPERATION_MODE:
      'Invalid environment operation mode for applying Scaling Advisor',
    SCALING_ADVISOR_APPLY_UNKNOWN_BEHAVIOR_CALENDAR:
      'Unknown behavior calendar for applying Scaling Advisor',

    // API account
    CANNOT_DELETE_PARTNER_WITH_ENVIRONMENT_ASSOCIATED:
      'It is not possible to delete an account that is associated to an environment',

    // API companies
    CANNOT_DELETE_COMPANY_WITH_PARTNER_ASSOCIATED:
      'It is not possible to delete a company that is associated to an account',
    ADD_COMPANY_SUCCESS_KEY: 'Company successfully added!',
    REMOVE_COMPANY_SUCCESS_KEY: 'Company successfully deleted!',

    // API clients
    OPERATOR_PASSWORD_TOO_WEAK: 'The password chosen is weak',
    OPERATOR_ALREADY_EXISTS: 'Operator already exists',
    REMOVE_MULTIPLE_SESSIONS_KEY: 'Selected sessions were deleted!',
    ENABLE_OR_DISABLE_SUCCESS_KEY: 'Remote profile successfully {{activate}}!',
    MFA_OPERATOR_ENABLE_KEY: 'The MFA has been successfully activated!',
    MFA_OPERATOR_DISABLE_KEY: 'The MFA has been successfully deactivated!',
    MFA_OPERATOR_RESET: 'MFA was successfully redefined!',
    CANNOT_EDIT_USER_FIELDS: 'User already registered!',
    FICTITIOUS_USER_ADMINS_EMAILED:
      "Password reset e-mail was sent to client's administrators because user has a dummy e-mail!",
    INVALID_USER: 'Invalid user',
    ENVIRONMENT_WITHOUT_VALID_VIRTUALIZER:
      'Environment does not have a valid virtualizer',
    MISSING_FILTER_PARAMETER: 'Missing filter parameter',
    TEST_CONNECT_SUCCES_KEY: 'Connection test successfully executed!',
    ERROR_ON_VALIDATE_USER:
      "Error on user validation. Please contact the account's administrator",
    ENVIRONMENT_WITHOUT_VALID_INSTANCE:
      "Environment does not have a preparation server, or preparation server is non operational. Unable to simulate the application. Verify the environment's preparation servers",
    USER_NOT_FOUND:
      'User not found, please check if the e-mail address provided is correct',
    USER_DISABLED: 'This user is disabled',
    LICENSES_LIMIT_KEY: "Client's licenses limit has been exceeded",
    CLIENT_CLONE_MESSAGE_KEY: 'Requested client has been successfully cloned',
    PARTNER_CLONE_MESSAGE_KEY: 'The account was successfully cloned',
    CHANGE_AD_PASSWORD_MESSAGE_KEY:
      'AD user password has been changed successfully',
    CLIENT_REMOVED_KEY: 'Client has been successfully deleted!',
    WRONG_PARAMETERS: 'Request error. Please contact the administrator.',
    CLIENT_WITH_USER_CANNOT_BE_DELETED:
      "It is not possible to delete a client with users associated with it. Please, delete the client's users before requesting its deletion.",
    AD_GROUP_NOT_CREATED_KEY:
      'Could not create an Active Directory (AD) group for this client',
    INVALID_PAYLOAD_APPLICATION_MODE:
      'This client application type is configured as "simple" mode and can only accept name and state arguments. If you need to use advanced settings, first change the Client\'s Environment application mode to "advanced".',
    CLIENT_REALM_ID_ALREADY_EXISTS:
      'Domain ID is already associated with a client',

    // API Authenticate
    PASSWORD_CHANGE_KEY:
      'Password changed successfully! You will be redirected to the login page…',
    INVALID_TOKEN_KEY: 'Invalid or expired token',
    EMAIL_RECOVER_KEY:
      'If your e-mail is registered in our database, you will receive an e-mail to recover your password.',

    // API environment
    TOGGLE_BLOCK_UNBLOCK_INSTANCE_SUCCESS_KEY:
      'Instances were successfully blocked / unblocked!',
    INSTANCE_IS_NOT_RUNNING: 'The instance it is not being executed!',
    TERMINATE_MULTIPLE_INSTANCES_KEY:
      'The selected instances were successfully terminated!',
    BLOCK_MULTIPLE_INSTANCES_KEY:
      'The selected instances were successfully blocked!',
    UNBLOCK_MULTIPLE_INSTANCES_KEY:
      'The selected instances were successfully unblocked!',
    SUCCESS_REMOVE_MULTIPLE_MODELS_KEY:
      'Selected models were successfully deleted!',
    ENVIRONMENT_WITHOUT_GOVERNANCE:
      'Environment does not have any governance data registered',
    TURNED_SERVER_MSG_KEY: 'Server successfully converted!',
    ENABLE_MFA_TO_ALL_USERS_SUCCESS_KEY:
      'The MFA has been successfully activated for all users!',
    DISABLE_MFA_TO_ALL_USERS_SUCCESS_KEY:
      'The MFA has been successfully disabled for all users!',
    FORBIDDEN_PROVIDER: 'Provider not allowed to perform this action',
    SET_NEW_STOP_TIME_PREPARATION_SERVER: 'Stop new time successfully defined!',
    CANCELED_SCHEDULED_STOP_PREPARATION_SERVER:
      'Cancel preparation server scheduled stop',
    PREPARATION_SERVER_WITHOUT_STOP_TIME:
      'Preparation server does not have a defined scheduled stop',
    CANNOT_DELETE_ENVIRONMENT_WITH_CLIENTS_ASSOCIATED:
      "It is not possible to delete an environment that has clients associated with it. Please, delete the environment's clients before requesting its deletion",
    ENVIRONMENT_ALREADY_WITH_PREPARATION_SERVER:
      'Environment already has a preparation server',
    CREATED_ENVIRONMENT: 'Environment successfully created!',
    PROVIDER_RESOURCE_NOT_AVAILABLE_IN_PROVIDER:
      'Provider features are not available in the provider of this environment',
    OPERATION_UNSUPPORTED: 'Operation not supported',
    INSTANCE_OPERATION_ERROR: 'Instance operation error',
    INIT_INSTANCE_MSG_SINGULAR_KEY: 'Starting {{numInstances}} instance...',
    INIT_INSTANCE_MSG_PLURAL_KEY: 'Starting {{numInstances}} instances...',
    CREATED_PREPARATION_SERVER: 'Preparation server successfully created!',
    CREATED_SUPPORT_SERVER: 'Support server successfully created!',
    ATTACHED_SERVER: 'Server successfully attached!',
    DETACHED_SERVER: 'Server successfully detached!',
    ENVIRONMENTS_NOT_FOUND: 'Environment not found for this operator',
    INVALID_TIME_RANGE: 'End date must be greater than start date',
    INVALID_PERIOD_ERROR:
      'Invalid period, enter a period with less than 6 hours.',
    ELASTICSEARCH_CONNECTION_ERROR: 'Error connecting to Elasticsearch.',

    INSTANCE_ACTIVATE_REQUESTED:
      'Instance activation request successfully sent!',
    INSTANCE_ACTIVATE_NOT_ALLOWED:
      'Error while activating instance. Try again later!',

    INSTANCE_ACTIVATE_ENVIRONMENT_BLOCKED:
      'Environment is busy with another task',
    UNREGISTER_INSTANCE_REQUESTED: 'Instance successfully unlinked!',
    UNLINK_ERROR_KEY: 'Error unlinking an instance. Try again later!',
    SENT_WRONG_PARAMETERS:
      'Incorrect data. Please, revisit the fields and try again!',

    INSTANCE_NOT_FOUND: 'Instance not found',
    ENVIRONMENT_NOT_FOUND: 'Environment not found',

    INSTANCE_REBOOT_REQUESTED: 'Instance restart successfully requested!',
    INSTANCE_REBOOT_NOT_ALLOWED:
      'Environment does not allow this method of instance restarting',
    DISPLAY_ENV_WARNING: 'Display maintenance notice successfully {{active}}!',
    MANUAL_ENV_WARNING:
      'Manual maintenance warning exhibition successfully {{active}}!',
    SCHEDULE_ENV_WARNING:
      'Scheduled maintenance warning message successfully {{active}}!',
    CANCELED_SCHEDULED_STOP: 'Scheduled stop successfully canceled!',
    SET_NEW_STOP_TIME: 'Scheduled stop new time successfully defined!',

    SECURITY_DEFAULTS_ERROR_KEY:
      'Error while registering security standards. Revisit the fields and try again later!',
    NEW_GOVERNANCE_ERROR_KEY:
      'Error while registering governance data. Please, revisit the fields and try again later!',
    GOVERNANCE_DEFAULTS_ERROR_KEY:
      'Error while editing governance. Try again later!',

    SERVER_START_REQUESTED: 'Successfully requested server start!',
    SERVER_STOP_REQUESTED: 'Successfully requested server stop!',

    SERVER_RESTART_REQUESTED: 'Successfully requested server restart!',
    EXTENDED_PREPARATION_SERVER: 'Stop time successfully extended!',
    SERVER_NOT_FOUND:
      'Server not found. Sync the data with the provider to ensure data integrity and timeliness.',
    SERVER_NOT_FOUND_ON_PROVIDER:
      'Server not found on the provider. Unlink the server or create it on the provider.',
    SERVERS_NOT_FOUND_ON_PROVIDER:
      'Server(s) not found on the provider. Unlink the server or create it on the provider.',
    SERVER_IS_NOT_STOPPED: 'Server is not stopped.',
    SERVER_IS_NOT_RUNNING: 'Server is not running.',
    SERVER_PROVIDER_TAG_CONFLICT:
      'The "{{tag}}" tag of the server on the provider is incorrect or does not exist.',
    SERVER_TYPE_NOT_ALLOWED:
      'You do not have permission to perform this action on this type of provider (support or preparation), or this action cannot be executed.',
    SERVER_BELONGS_TO_OTHER_ENVIRONMENT:
      'This server is already attached to another environment ({{environment_uuid}}). Detach it before proceeding.',
    MODEL_NOT_FOUND_AT_SERVER_START:
      'Publish an image before starting the server.',
    INVALID_SERVER_STOP_TIME:
      'Stop time must be greater than the current time.',
    INVALID_PROVIDER_FOR_MODEL_TYPE_PUBLICATION:
      'Invalid provider for model type publication.',
    CUSTOM_IMAGE_NOT_FOUND: 'Custom image not found',
    INVALID_ENVIRONMENT_MODEL: 'Duplicated model is not valid',
    CANNOT_DELETE_ENVIRONMENT_WITH_INSTANCES_ASSOCIATED:
      "It is not possible to delete an environment that has instances associated with it. Please, terminate the environment's instances before requesting its deletion.",
    INVALID_OPERATOR_PASSWORD: 'The operator password is invalid',
    OPERATOR_WITHOUT_PERMISSION:
      'Your operator is not part of any permission group. Please contact the account administrator.',

    API_TOKEN_CREATED: 'API token created successfully: {{token}}',
    TOKEN_REMOVE_SUCCESS_KEY: 'Token successfully deleted!',
    INVALID_PARTNER: 'Invalid account',
    INVALID_IPS_ADDRESS: 'Invalid IP address',
    OPERATOR_PASSWORD_DOES_NOT_MATCH: 'The operator password does not match',
    CLIENT_APPLICATIONS_TYPE_IS_NOT_PLATFORM:
      'Client application type is not platform',
    // API group
    AD_GROUP_NOT_CREATED: 'Could not add group in AD',
    SALT: {
      SALT_TOGGLE_KEY: 'Ignore Salt',
      FALSE_ACTIVATE_SALT_KEY: 'Enable Salt on users',
      WARNING_FALSE_ACTIVATE_SALT_KEY:
        "By enabling Salt, users' passwords will receive an add-on that increases the level of security by mitigating the risk of intrusions.",
      TRUE_ACTIVATE_SALT_KEY: 'Disable Salt on users',
      WARNING_TRUE_ACTIVATE_SALT_KEY:
        'By disabling Salt, Salt will no longer be considered during access authentications on instances by users, increasing the risk of intrusion.',
      REASON_SALT_KEY: 'Reason',
      SHORT_WARNING_TRUE_ACTIVATE_SALT_KEY:
        'By disabling Salt, Salt will no longer be considered during access authentications on instances.',
      REASON_TO_SKIP_KEY: 'Reason to ignore Salt',
    },
    INVALID_PASSWORD: 'Invalid password',
    ACCESS_KEY: 'Access',

    // AdminView
    SEARCH_ALL_KEY: 'Search',
    LIST_ALL_KEY: 'List all',

    ENVIRONMENT_DASHBOARD: {
      LAST_1D: 'Last 24 hours',
      LAST_2D: 'Last 48 hours',
      LAST_7D: 'Last 7 days',
      LAST_15D: 'Last 15 days',
      LAST_30D: 'Last 30 days',
      LAST_60D: 'Last 60 days',
      LAST_90D: 'Last 90 days',
      LAST_180D: 'Last 180 days',

      SESSIONS_AVG_KEY: 'Sessions (average)',
      VACANCIES_AVG_KEY: 'Vacancies (average)',
      SESSIONS_MAX_KEY: 'Sessions',
      VACANCIES_MAX_KEY: 'Vacancies',

      ENVIRONMENT_USE_KEY: "Environment's use details",

      ENVIRONMENT_COST_TITLE_KEY: 'Environment cost',
      ENVIRONMENT_COST_DETAILS_KEY: 'Environment cost details',
      ENVIRONMENT_COST_TOTAL_KEY: 'Total cost',

      SESSION_HISTORY_TITLE_KEY: 'Session history',
    },
    ERROR_AD_GROUP_NOT_DELETED:
      'Error deleting group related to Active Directory. Please contact the administrator.',
    USERS_PAGE: {
      LIST_ALL_USERS_KEY: 'Users list',
      LIST_ALL_USERS_SUBTITLE_KEY: 'All users in all available clients',
      USERS_MANAGEMENT_TITLE_KEY: 'Users Management',
      USERS_MANAGEMENT_SUBTITLE_KEY:
        'Manage inactive users or recover deleted ones',
      SELECTED_USERS_KEY: 'Selected users',
      NO_USERS_KEY: 'No users found',
      MANAGE_USERS_KEY: 'Manage users',
      DELETE_ALL_BUTTON_KEY: 'Delete user in all clients',
      DELETE_BUTTON_KEY: 'Delete user in this client',
      DELETE_ALL_MODAL_TITLE_KEY: 'Delete user in all clients?',
      DELETE_ALL_MODAL_CONTENT_KEY:
        'This user will be deleted from all clients on which you have management permission.',
      DELETE_MULTIPLE_USERS_ACTION_KEY: 'Delete selected users',
      DELETE_MULTIPLE_USERS_PERMANENTLY_ACTION_KEY:
        'Permanently delete the selected ones',
      DELETE_MULTIPLE_USERS_MODAL_TITLE_KEY: 'User deletion in clients',
      DELETE_MULTIPLE_USERS_MODAL_CONTENT_KEY:
        'Do you want to delete the {{ count }} selected users in clients?',
      DELETION_REQUESTED_KEY: 'The deletions were successfully requested.',
      LIST_USER_RECOVERIES_KEY: 'List user recoveries',
      DELETED_USERS_TITLE_KEY: 'Deleted user recoveries',
      DELETED_USERS_SUBTITLE_KEY: 'List of deleted user in clients',
      SELECTED_REGISTERS_KEY: 'Selected registers',
      RECOVER_USER_ACTION_KEY: 'Recover user in client',
      RECOVER_USER_MODAL_TITLE_KEY: 'User recovery in client',
      RECOVER_USER_MODAL_CONTENT_KEY:
        'Do you want to recover the selected user in the client?',
      RECOVER_MULTIPLE_USERS_ACTION_KEY: 'Recover selected ones',
      RECOVER_MULTIPLE_USERS_MODAL_TITLE_KEY: 'Recovery of users in clients',
      RECOVER_MULTIPLE_USERS_MODAL_CONTENT_KEY:
        'Do you want to recover the {{ count }} selected users in the clients?',
      RECOVER_USER_BY_REQUEST_ACTION_KEY: 'Recover all users from the request',
      RECOVER_USER_BY_REQUEST_MODAL_TITLE_KEY:
        'Recovery of deleted users in the request',
      RECOVER_USER_BY_REQUEST_MODAL_CONTENT_KEY:
        'The request {{ requestUuid }} has {{ count }} recoveries available. Do you want to continue?',
      RECOVERY_REQUESTED_KEY: 'The recoveries were successfully requested.',
      REMOVE_USER_PERMANENTLY_KEY: 'Delete user permanently',
      REMOVE_USER_PERMANENTLY_MODAL_TITLE_KEY: 'Permanent user deletion',
      REMOVE_USER_PERMANENTLY_DESCRIPTION_KEY:
        'This action is irreversible and the data will not be recoverable',
      REMOVE_MULTIPLE_USERS_PERMANENTLY_DESCRIPTION_KEY:
        'You are about to permanently delete {{ counter }} unique users associated with the selected records. Do you want to continue?',
    },

    LIST_ALL_MENU: {
      LIST_ALL_ENVIRONMENTS_KEY: 'List environments',
      LIST_ALL_COMPANIES_KEY: 'List companies',
      LIST_ALL_PARTNERS_KEY: 'List accounts',
      LIST_ALL_CLIENTS_KEY: 'List clients',
      LIST_ALL_USERS_KEY: 'List users',
    },

    ACTIVE_SSO_DESCRIPTION: 'Login by SSO (Single Sign On)',
    SSO_KEY_LONG: 'Single Sign On',

    SSO: {
      FEDERATION_TYPE: 'Federation type',
      CLIENT_REALM_ID: 'Client domain ID',

      SAML_URL_SECTION_TITLE:
        'SAML - Site redirection settings for external login (URLs)',
      IDP_ENTITY_IDP: 'Entity ID of the (IdP)',
      SAML_IDP_SINGLE_SIGN_ON_URL: 'Login URL of the (IdP)',
      SAML_IDP_SINGLE_LOGOUT_URL: 'Logout URL from (IdP)',
      SAML_X509_CERTIFIED: 'Public certificate x509 from (IdP)',

      SAML_ACCESS_TITLE: 'SAML - Access restriction settings',
      RESTRICT_ACCESS_BY_GROUPS:
        'Restrict access to only users of a specific group?',
      ALLOW_USERS_FROM_GROUP: 'UUID of the allowed user group',

      SAML_CLAIM_TYPES_TITLE: 'SAML - User attribute settings (Claim types)',
      SAML_IDP_CLAIM_NAME_ID: 'URL of the [Name ID] attribute (IdP)',
      SAML_IDP_CLAIM_NAME_GIVEN_NAME: 'URL of the [Given name] attribute (IdP)',
      SAML_IDP_CLAIM_SURNAME: 'URL of the [Surname] attribute (IdP)',
      SAML_IDP_CLAIM_EMAIL_ADDRESS: 'URL of the [Email] attribute (IdP)',
      SAML_IDP_CLAIM_GROUPS: 'URL of the [Groups] attribute (IdP)',
    },

    WEIGHT_KEY: 'Weight',

    // USER THEME ERRORS

    CANNOT_DELETE_PARTNER_WITH_PARTNER_ENVIRONMENT_ASSOCIATED:
      'Cannot delete a partner with environment associated',
    USER_THEME_CONFIG_NOT_FOUND: 'User theme configuration not found',
    SUBDOMAIN_NOT_AVAILABLE: 'Subdomain not available',
    SUBDOMAIN_DNS_NOT_CREATED: 'Subdomain DNS not created',
    SUBDOMAIN_ALTERNATE_DOMAIN_NOT_CREATED:
      'Subdomain alternate domain not created',
    SUBDOMAIN_DNS_NOT_REMOVED: 'Subdomain DNS not removed',
    SUBDOMAIN_ALTERNATE_DOMAIN_NOT_REMOVED:
      'Subdomain alternate domain not removed',
    EMAIL_KEY_WARNING_APPLICATION: 'Emails for conclusion warn',
    INSTANCES_HISTORY_GRAPH_KEY: 'Instances history',
    CREATED_CLIENTS_BY_PERIOD_KEY: 'Growth during the period: {{percentage}}',
    CREATED_CLIENTS_KEY: 'Created clients:',
    CREATED_USERS_KEY: 'Created users:',
    HISTORY_SOP_KEY: 'History',
    INVALID_CAPTCHA_TOKEN: 'Login error. Please try again',
    INVALID_PERIODS: 'Invalid period. Please try again',
    ACCOUNT_INFORMATION_KEY: 'Account information',

    NO_PERMISSIONS_IN_GROUP_KEY:
      'This template is not authorized to manage permissions',

    ACTIVATE_MFA_KEY: 'Activate MFA',
    MFA_ACTIVATED_SUCCESSFULLY_KEY: 'MFA activated!',
    MFA_INACTIVATED_SUCCESSFULLY_KEY: 'MFA inactivated!',
    ACTIVATE_MFA_MODAL_MESSAGE_KEY:
      "Activate this operator's MFA {{firstName}} {{lastName}}?",

    REMOVE_USER_SESSION_KEY: 'Remove user sessions',

    MINIMUM_SESSION_AGE_KEY: 'Minimum session age (hours)',
    RUN_TIME_KEY: 'Run time',

    AUDIT_SESSION: {
      AUDIT_KEY: 'Auditing',
      OS_KEY: 'OS',
      BROWSER_KEY: 'Browser',
      UPDATED_BY_KEY: 'Updated by',
      TIME_AT_KEY: 'at',
      AT_KEY: 'at',
      ON_KEY: 'on',
    },
    MANAGE_PERMISSIONS_OPERATOR_KEY:
      'Select a role to be able to select the corresponding permission group',

    OPERATOR_HAS_UPPER_ROLE_PERMISSION:
      'This operator is present in a group with a higher permission template than the selected role. Remove the selected group first.',

    SELECT_PARTNER_DASHBOARD: 'Select an account to view the dashboard data',

    CLIENT_DATA_KEY: "Client's data",
    CLIENT_DATA_SUMMARY_KEY: 'Summary',
    GENERATE_PDF: 'Generate PDF',
    EXPORT_PDF_KEY: 'Export PDF',

    LOGS_PAGE: {
      LIST_LOGS_KEY: 'Audit',
      LIST_LOGS_TITLE_KEY: 'Audit',
      LIST_LOGS_SUBTITLE_KEY: 'Details of all actions at resources',
      NO_LOGS_KEY: 'No log was found',
      RESOURCE_KEY: 'Resource',
      RESOURCE_TYPE_KEY: 'Resource type',
      FILTERS_KEY: 'Filters',
      DETAILS_KEY: 'Details',
      MODAL_DETAILS_TITLE_KEY: 'Log details',
      CHANGES_KEY: 'Changes',
      CHANGED_FIELD_KEY: 'Changed field',
      PUBLISHED_SETTINGS_KEY: 'Published settings',
      OLD_VALUE_KEY: 'Old value',
      NEW_VALUE_KEY: 'New value',
      ACTIVE_KEY: 'Enabled',
      INACTIVE_KEY: 'Disabled',
      VALUE_KEY: 'Value',
      LIST_LOGS_ENVIRONMENT_KEY: 'Details of actions in the environment',
      LIST_LOGS_CLIENTS_KEY: 'Details of actions in the client',
      EVERY_USER_ALREADY_USING_REASON_KEY: 'All users are accessing Portal 2.0',

      RESOURCES: {
        CLIENT_KEY: 'Client',
        COMPANY_KEY: 'Company',
        ENVIRONMENT_KEY: 'Environment',
        OPERATOR_KEY: 'Operator',
        PARTNER_KEY: 'Account',
        USER_KEY: 'User',
        MODEL_KEY: 'Model',
        ENVIRONMENT_APPLICATION_KEY: 'Environment application',
        CLIENT_APPLICATION_KEY: "Client's applications",
        USER_SESSION_KEY: "User's sessions",
        PARTNER_USER_THEME_CONFIG_KEY: 'Partner user theme',
        OPERATOR_ROLE_KEY: 'Group',
        OPERATOR_ROLE_OBJECTS_KEY: 'Group context',
        OPERATOR_ROLE_PERMISSION_KEY: 'Group permission',
      },

      ACTIONS: {
        CREATE_RESOURCE_KEY: 'Create',
        UPDATE_RESOURCE_KEY: 'Update',
        DELETE_RESOURCE_KEY: 'Delete',
        PUBLISH_RESOURCE_KEY: 'Publish',
        MIGRATE_RESOURCE_KEY: 'Migrate environment',
      },

      FIELDS: {
        CODES_ADDED_KEY: 'Permission added',
        CODES_REMOVED_KEY: 'Permission removed',
        COMPANY_UUID_KEY: 'Company ID',
        CLOUD_PROVIDERS_KEY: 'Cloud provider',
        PLUGIN_KEY: 'Use custom plugin?',
        FRONTEND_KEY: 'Use new interface?',
        ALLOW_SSO_CONFIGURATION_KEY: 'Allow SSO configuration',
        SCALE_INSTANCES_KEY: 'Model',
        TRUSTED_USERS_KEY: 'Administrative users',
        ZERO_TRUST_KEY: 'Zero Trust',
        EXTERNAL_CLIENT_CODE_KEY: 'External client code',
        COPY_ADMIN_KEY:
          'Always copy the registered administrator to the client in email communications',
        AUDITING_KEY: 'Block multiple instances of the same user?',
        AD_PASSWORD_SALT_KEY: 'Ignore Salt',
        USE_PROFILE_KEY: 'Remote Profile',
        BLOCKED_KEY: 'Block operator',
        UPDATED_DATE_KEY: 'Last update date',
        MFA_REQUIRED_KEY: 'Enable MFA',
        FAVICON_IMAGE_KEY: 'Favicon',
        MESSAGES_IMAGE_KEY: 'Message',
        USE_BROWSER_LANGUAGE_KEY: 'Use browser language',
        REGISTRATION_SOURCE_KEY: 'Registration through',
        REGISTRATION_MODE_KEY: 'Registration mode',
        UPDATED_BY_OPERATOR_KEY: 'Updated by',
        OPERATOR_UUID_KEY: 'Operator UUID',
        CLIENT_UUID_KEY: 'Client ID',
        PARTNER_UUID_KEY: 'Account ID',
        ENVIRONMENT_UUID_KEY: 'Environment ID',
        LOGO_IMAGE_KEY: 'Account logo',
        SECONDARY_COLOR_KEY: 'Secondary color',
        SECONDARY_DARK_COLOR_KEY: 'Secondary dark color',
        SECONDARY_LIGHT_COLOR_KEY: 'Secondary light color',
        BACKGROUND_IMAGE_KEY: 'Login banner',
        MAINTENANCE_IMAGE_KEY: 'Maintenance image',
        PRIMARY_DARK_COLOR_KEY: 'Primary dark color',
        PRIMARY_LIGHT_COLOR_KEY: 'Primary light color',
        SECONDARY_CONTRAST_TEXT_COLOR_KEY: 'Environment title secondary color',
      },
    },

    ACTIVE_DNS_WARN_KEY:
      'The DNS option is enabled and the selected virtualizer is {{virtualizer}}. Do you want to continue?',
    PERMISSION_KEY: 'Permission',
    CANT_DELETE_MODEL_KEY:
      'It is not possible to delete the primary model. Change it in the environment settings.',
    MFA_RESET_SUCCESS_KEY: 'MFA successfully reset!',

    COSTS_PAGE: {
      DASHBOARD_TITLE_KEY: 'Cost dashboard',
      ENVIRONMENTS_COST_TITLE_KEY: 'Environments cost',
      FLAVORS_COST_TITLE_KEY: 'Flavors cost',
      NO_RESULTS: 'No results',
      COST_KEY: 'Cost',
      COSTS_KEY: 'Costs',
      COST_PERCENTAGE_KEY: 'Cost percentage',
      FLAVOR_DETAILS_KEY: 'Flavor details',
      SELECTED_FLAVOR_KEY: 'Selected flavor',
    },
    INSTANCE_SECONDS_KEY: '{{seconds}} seconds',
    INSTANCE_DATE_STATUS_KEY: 'Instance time data',
    DATE_TIME_START_KEY: 'Initialization date',
    DATE_TIME_OPERATIONAL_KEY: 'Operationalization date',
    TIME_TO_START_OPERATIONAL_KEY: 'Time to operationalization',
    TIME_OPERATIONAL_KEY: 'Operational time',

    INSTANCE_DAY_KEY: 'day',
    INSTANCE_HOUR_KEY: 'hour',
    INSTANCE_MINUTE_KEY: 'minute',
    INSTANCE_SECOND_KEY: 'second',
    SELECT_KEY: 'Select',

    APPLY_DATE_FILTERS_KEY: 'Apply date filter',

    APPLICATIONS_CLIENTS_COUNT_KEY: 'Number of clients',
    APPLICATIONS_CLIENTS_MODAL_TITLE_KEY: 'List of clients of {{app_name}}',
    APPLICATIONS_NAME_KEY: 'Application',
    PDF_GENERATED_AT_KEY: 'PDF generated at',
    PDF_GENERATED_SUCCESSFULLY_KEY: 'PDF generated successfully!',
    RENAME_KEY: 'Rename',
    RENAME_APP_KEY: 'Rename application {{app_name}}',
    CURRENT_NAME_KEY: 'Current name',
    NEW_NAME_KEY: 'New name',
    RENAME_APP_SUCCESSFULLY_KEY: 'Application renamed successfully!',
    ENVIRONMENT_APPS_LISTING_KEY: 'Environment applications',
    ENVIRONMENT_APPS_LISTING_SUBTITLE_KEY:
      'Listing of all applications from all clients in this environment',
    REMOVE_APP_KEY: 'Remove',
    REMOVE_APP_NAME_KEY: 'Remove application {{app_name}}',
    REMOVE_APP_CONFIRMATION_KEY:
      'Are you sure you want to remove the application {{app_name}}?',
    REMOVE_APP_SUCCESSFULLY_KEY: 'Application removed successfully!',
    ACTIVATE_INACTIVATE_KEY: 'Activate/Inactivate',
    INACTIVATE_KEY: 'Inactivate',
    ACTIVATE_IN_ALL_CLIENTS_KEY: 'Activate application on all clients?',
    INACTIVATE_IN_ALL_CLIENTS_KEY: 'Inactivate application on all clients?',
    ACTIVATED_SUCCESSFULLY_KEY: 'Activation successful!',
    INACTIVATED_SUCCESSFULLY_KEY: 'Inactivation successful!',
    APPLICATIONS_CLIENTS_CHANGE_STATE_MODAL_TITLE_KEY:
      'List of clients of {{app_name}} to change state',
    INCLUDE_CLIENT_KEY: 'Include client',
    INCLUDE_CLIENT_ACTIVE_KEY: 'Include active',
    INCLUDE_CLIENT_INACTIVE_KEY: 'Include inactive',
    INCLUDE_IN_ALL_CLIENTS_KEY: 'Include application on all clients',
    INCLUDE_SUCCESSFULLY_KEY: 'Included successfully!',
    INCLUDE_KEY: 'Include',
    APPLICATIONS_CLIENTS_INCLUDE_MODAL_TITLE_KEY:
      'List of clients available to include in {{app_name}}',
    SUBDOMAIN_REGEX_RULE_KEY:
      'The subdomain accepts only lowercase letters, numbers, and hyphens, and must start with a letter, end with a letter or number, and not contain consecutive hyphens.',
    DOMAIN_REGEX_RULE_KEY:
      'The domain accepts only lowercase letters, numbers, hyphens, and dots, and must start with a letter, end with a letter or number, not contain consecutive hyphens, and have at least two characters after the last dot.',
    APPLICATIONS_CLIENTS_REMOVE_CONFIRMATION_TITLE_KEY:
      'Confirm removal of {{app_name}}',
    APPLICATIONS_CLIENTS_REMOVE_CONFIRMATION_KEY:
      'Are you sure you want to remove the {{app_name}} application?',
    CONFIRM_REMOVE_KEY: 'Confirm removal',
    APPLICATIONS_CLIENTS_RENAME_CONFIRMATION_TITLE_KEY:
      'Confirm renaming of {{app_name}}',
    APPLICATIONS_CLIENTS_RENAME_CONFIRMATION_KEY:
      'Are you sure you want to rename the application {{app_name}} to {{new_app_name}}?',
    CONFIRM_RENAME_KEY: 'Confirm rename',
    APPLICATIONS_CLIENTS_ACTIVE_CONFIRMATION_TITLE_KEY:
      'Confirm activation on {{app_name}}',
    APPLICATIONS_CLIENTS_INACTIVE_CONFIRMATION_TITLE_KEY:
      'Confirm inactivation in {{app_name}}',
    APPLICATIONS_CLIENTS_ACTIVE_CONFIRMATION_KEY:
      'Are you sure you want to activate {{app_name}} for these clients?',
    APPLICATIONS_CLIENTS_INACTIVE_CONFIRMATION_KEY:
      'Are you sure you want to inactivate {{app_name}} for these clients?',
    CONFIRM_ACTIVE_KEY: 'Confirm activation',
    CONFIRM_INACTIVE_KEY: 'Confirm inactivation',
    APPLICATIONS_CLIENTS_INCLUDE_CONFIRMATION_TITLE_KEY:
      'Confirm inclusion in {{app_name}}',
    APPLICATIONS_CLIENTS_INCLUDE_CONFIRMATION_KEY:
      'Are you sure you want to include these clients in the {{app_name}} application?',
    CONFIRM_INCLUDE_KEY: 'Confirm inclusion',
    INCLUDE_NEW_APP_KEY: 'Include new application',
    APP_TO_BE_INCLUDED_KEY: 'Name of the application to be included',
    CONFIRM_INCLUSION_OF_TITLE_KEY: 'Confirm inclusion of {{app_name}}',
    CONFIRM_INCLUSION_OF_KEY:
      'Are you sure you want to include the application {{app_name}}?',
    ATTACHED_KEY: 'Linked',
    DETACHED_KEY: 'Unlinked',
    ATTACH_SUCCESSFULLY_KEY: 'Linked successfully!',
    DETACH_SUCCESSFULLY_KEY: 'Unlinked successfully!',

    ENVIRONMENT_ADMIN_TITLE_KEY: 'Environment administration',
    CURRENT_ACCOUNT_KEY: 'Origin account:',
    NEW_ACCOUNT_KEY: 'Destination account:',
    MIGRATE_ENVIRONMENT_BUTTON_KEY: 'Change environment account',
    MIGRATE_ENVIRONMENT_KEY: 'Environment migration',
    MIGRATION_OF_ENVIRONMENT_KEY:
      'Migration of environment {{environment_name}}',
    MIGRATION_MODAL_TEXT_KEY:
      'Are you sure you want to migrate the environment: ',
    MIGRATION_ORIGIN_KEY: 'Origin',
    MIGRATION_DESTINATION_KEY: 'Destination',
    MIGRATION_PARTNER_KEY: 'Account:',
    MIGRATION_COMPANY_KEY: 'Company:',
    MIGRATION_TO_CONFIRM_KEY:
      'To confirm the migration, enter the reason for the action in the field below:',
    CONFIRM_MIGRATION_KEY: 'Confirm migration',
    MIGRATION_HISTORY_SUBTITLE_KEY: 'Environment migration history',
    MIGRATION_DATE_KEY: 'Migration Date',
    ORIGIN_COMPANY_KEY: 'Origin Company',
    DESTINATION_COMPANY_KEY: 'Destination Company',
    ORIGIN_PARTNER_KEY: 'Origin Account',
    DESTINATION_PARTNER_KEY: 'Destination Account',
    MIGRATE_ENVIRONMENT_BUTTON_BELLOW_KEY:
      'Click the button below to configure the migration of this environment',
    UNEQUAL_PARTNER_SETTINGS:
      'The settings of the target account do not match those of the current account',
    PROVIDER_AWS_SETTINGS_KEY:
      'Rule 1: The AWS Cloud Provider Settings: Role arn, AWS Owner ID, External ID.',
    PROVIDER_OCI_SETTINGS_KEY:
      'Rule 2: The OCI Cloud Provider Settings: Compartment ID.',
    ACTIVE_DIRECTORY_SETTINGS_KEY:
      'Rule 3: The Account LDAP type and LDAP Settings (Active Directory): LDAP Server, Admin bind pass, Admin DN, LDAP Server Backup, Base DN, Domain.',
    SALT_SETTINGS_KEY: 'Rule 4: The Salt setting: Enable Salt on users.',
    SSO_SETTINGS_KEY: 'Rule 5: The SSO setting: Allow to configure SSO.',
    NEW_FRONT_SETTINGS_KEY:
      'Rule 6: The Use new interface setting: Use new front.',
    ENVIRONMENT_SUCCESSFULLY_MIGRATED_KEY: 'Environment successfully migrated!',
    MIGRATION_REASON_KEY: 'Reason for migration',
    WARN_MIGRATION_RULES_KEY:
      'The following settings, present on the account edit screen, need to be identical between the source and target account:',
    RULE_MIGRATION_ONE_KEY:
      'The AWS Cloud Provider Settings: Role arn, AWS Owner ID, External ID.',
    RULE_MIGRATION_TWO_KEY: 'The OCI Cloud Provider Settings: Compartment ID.',
    RULE_MIGRATION_THREE_KEY:
      'The Account LDAP type and LDAP Settings (Active Directory): LDAP Server, Admin bind pass, Admin DN, LDAP Server Backup, Base DN, Domain.',
    RULE_MIGRATION_FOUR_KEY: 'The Salt setting: Enable Salt on users.',
    RULE_MIGRATION_FIVE_KEY: 'The SSO setting: Allows you to configure SSO.',
    RULE_MIGRATION_SIX_KEY:
      'The configuration of Use new interface: Use new front.',
    RULE_ONE_KEY: 'Rule 1: ',
    RULE_TWO_KEY: 'Rule 2: ',
    RULE_THREE_KEY: 'Rule 3: ',
    RULE_FOUR_KEY: 'Rule 4: ',
    RULE_FIVE_KEY: 'Rule 5: ',
    RULE_SIX_KEY: 'Rule 6: ',
    ERROR_MIGRATION_RULES_KEY:
      'It was not possible to migrate this environment to the selected account due to the following settings differing from the current account:',
    ERROR_MIGRATION_RULES_SOLUTION_KEY:
      'Please configure the target account to meet the same settings as the current account, and try again.',
    CHOOSE_ANOTHER_PARTNER: 'Choose another account',
    DISMISS_KEY: 'Discard',
    ORIGIN_AND_DESTINATION_PARTNER_CANT_BE_EQUAL:
      'The origin and destination accounts cannot be the same',
    CURRENT_PARTNER_CONFIG_KEY: 'Current account settings',

    DYNAMIC_FILTER: {
      CLEAN_FILTERS_KEY: 'Clear filters',
      CLEAN_ALL_KEY: 'Clear all',
      SELECT_ALL_KEY: 'Select all',
      FILTER_BUTTON_KEY: 'Dynamic filters',
      USER_UUID_KEY: 'User ID',
      AD_USERNAME_KEY: 'AD user',
      SALT_CONFIGURED_KEY: 'Salt configured',
      YES_KEY: 'Yes',
      NO_KEY: 'No',
      PARTNER_UUID_KEY: 'Account ID',
      PARTNER_NAME_KEY: 'Account name',
      MFA_CONFIGURED_KEY: 'MFA configured',
      FIRST_NAME_KEY: 'First name',
      LAST_NAME_KEY: 'Last name',
      ENVIRONMENT_NAME_KEY: 'Environment name',
      ENVIRONMENT_UUID_KEY: 'Environment ID',
      EMAIL_KEY: 'Email',
      COMPANY_UUID_KEY: 'Company ID',
      COMPANY_NAME_KEY: 'Company name',
      CLIENT_UUID_KEY: 'Customer ID',
      CLIENT_NAME_KEY: 'Customer name',
      STATUS_KEY: 'Status',
      ACTIVE_KEY: 'Active',
      INACTIVE_KEY: 'Inactive',
      ALLOW_SSO_CONFIG_KEY: 'Allow SSO config',
      CUSTOM_FRONTEND_KEY: 'Has custom frontend',
      LDAP_SERVER_KEY: 'LDAP Server',
      LDAP_TYPE_KEY: 'LDAP type',
      OCI_COMPARTMENT_ID_KEY: 'OCI - Compartment ID',
      PARTNER_NEW_FRONT_ENABLED_KEY: 'New front enabled',
      ROLE_AWS_KEY: 'AWS - Role ARN',
      INTERNAL_KEY: 'Internal',
      EXTERNAL_KEY: 'External',
      MANAGED_KEY: 'Managed',
      PARTNER_ALIAS_KEY: 'Alias',
      COMPANY_TYPE_KEY: 'Company type',
      COMPANY_STATUS_KEY: 'Company status',
      RESPONSIBLE_EMAIL_KEY: 'Responsible email',
      RESPONSIBLE_NAME_KEY: 'Responsible name',
      RESPONSIBLE_PHONE_KEY: 'Responsible phone',
      TRADING_NAME_KEY: 'Trading name',
      ZOHO_ID_KEY: 'ID Zoho',
      CLIENT_KEY: 'Client',
      PARTNER_KEY: 'Account',
      EXTERNAL_CLIENT_CODE_KEY: 'External client code',
      IDENTIFICATION_KEY: 'Client ID',
      APPLICATIONS_REGISTRATION_MODE_KEY: 'Applications registration mode',
      BACKUP_MODEL_ID_KEY: 'Backup modal ID',
      BEHAVIOR_TYPE_KEY: 'Behavior type',
      BLOCK_MULTIPLE_SESSION_KEY: 'Block multiple sessions',
      CONNECTION_TYPE_KEY: 'Connection type',
      IN_MAINTENANCE_KEY: 'In maintenance',
      LICENSE_LIMIT_KEY: 'License limit',
      LICENSE_LIMIT_PER_CLIENT_KEY: 'Has license limit per client',
      MAIN_MODEL_ID_KEY: 'Main model ID',
      NUM_CLIENTS_KEY: 'Number of clients',
      NUM_USERS_KEY: 'Number of users',
      PROVIDER_TYPE_KEY: 'Provider type',
      PUBLICATION_TYPE_KEY: 'Publication type',
      REGION_KEY: 'Region',
      USE_DNS_KEY: 'Use DNS for remote connection',
      VIRTUALIZER_KEY: 'Virtualizer',
      ZERO_TRUST_ENABLED_KEY: 'Zero Trust',
      SIMPLE_KEY: 'Simple',
      ADVANCED_KEY: 'Advanced',
      MANUAL_KEY: 'Manual',
      PERIOD_KEY: 'Period',
      MICRO_KEY: 'Micro',
      SPOT_PERIOD_KEY: 'Period (Spot)',
      HAAS_KEY: 'HaaS',
      CCC_KEY: 'CCC',
      PUBLIC_KEY: 'Public',
      PRIVATE_KEY: 'Private',
      AWS_KEY: 'AWS',
      OCI_KEY: 'OCI',
      MULTICLOUD_KEY: 'Multicloud',
      CUSTOM_IMAGE_KEY: 'Custom image',
      BOOT_VOLUME_KEY: 'Boot volume',
      BOOT_VOLUME_BACKUP_KEY: 'Boot volume backup',
      CONNECT_KEY: 'ConnectSky',
      CONNECT_DIRECT_KEY: 'ConnectSky (Direct Connect)',
      RDP_KEY: 'Microsoft Remote Desktop (File)',
      RDP_DIRECT_KEY: 'Microsoft Remote Desktop (Direct Connect)',
      RDP_APP_KEY: 'Microsoft Remote Desktop (RemoteApp)',
      TSPLUS_KEY: 'TSPlus (WebBrowser HTML5)',
      TSPLUS_REMOTE_APP_KEY: 'TSPlus (RemoteApp)',
      TSPLUS_ALL_KEY: 'TSPlus (WebBrowser HTML and RemoteApp)',
      SERVER_TYPE_KEY: 'Server type',
      INSTANCE_STATE_KEY: 'Server status',
      INSTANCE_ID_KEY: 'Instance ID',
      IMAGE_PUBLICATION_STATUS_KEY: 'Image status',
      FLAVOR_KEY: 'Flavor',
      NAME_KEY: 'Name',
      OPERATING_TIME_KEY: 'Operationalization time of instances',
      MONITORING_TYPE_KEY: 'Type of monitoring',
      CLIENT_USE_NEW_FRONT_KEY: 'Use new interface',
      NO_ACCESS_KEY: 'No access',
      GREATER_THAN_OR_EQUAL_TO_30_DAYS_KEY: 'Greater than or equal to 1 month',
      GREATER_THAN_OR_EQUAL_TO_60_DAYS_KEY: 'Greater than or equal to 2 months',
      GREATER_THAN_OR_EQUAL_TO_90_DAYS_KEY: 'Greater than or equal to 3 months',
      GREATER_THAN_OR_EQUAL_TO_180_DAYS_KEY:
        'Greater than or equal to 6 months',
    },
    LIST_PARTNER_SERVERS: 'List account servers',
    START_PARTNER_SERVERS: 'Start account servers',
    STOP_PARTNER_SERVERS: 'Stop account servers',
    PUBLISH_NEW_IMAGE_PARTNER_SERVERS:
      'Publish image on the servers in the account',
    LIST_IMAGE_PUBLICATION_SCHEDULE: 'List image publication schedules',
    CREATE_IMAGE_PUBLICATION_SCHEDULE: 'Create image publication schedule',
    CANCEL_IMAGE_PUBLICATION_SCHEDULE: 'Cancel image publication schedule',
    START_SERVERS_KEY: 'Start servers',
    START_SERVERS_CONFIRM_KEY: 'Do you want to start selected servers?',
    STOP_SERVERS_KEY: 'Stop servers',
    STOP_SERVERS_CONFIRM_KEY: 'Do you want to stop selected servers?',
    LIST_ALL_PARTNER_SERVERS_KEY:
      "Listing of all the account's staging servers",
    SERVERS_START_REQUESTED: 'Server start requested successfully!',
    SERVERS_STOP_REQUESTED: 'Server stop requested successfully!',
    LIST_DASHBOARD_PERFORMANCE: 'View performance dashboard',
    CAN_MANAGE_ENVIRONMENT_STATUS: 'Manage environment status',
    PERFORMANCE_PAGE: {
      PERFORMANCE_KEY: 'Performance',
      PERFORMANCE_TITLE_KEY: 'Performance data for this environment',
      CPU_USE_KEY: 'CPU usage',
      MEMORY_USE_KEY: 'Memory usage',
      AVG_KEY: 'Average',
      MAX_KEY: 'Maximum',
      OPERATIONAL_TIME_DETAILS_KEY: 'Instance operationalization time details',
      CPU_USE_DETAILS_KEY: 'CPU usage details',
      MEMORY_USE_DETAILS_KEY: 'Memory usage details',
      COSTS_DETAILS_KEY: 'Cost details',
      ENVIRONMENT_COSTS_DETAILS_KEY: 'Environment cost details',
      CPU_MEMORY_USE_KEY: 'CPU and memory usage',
      SESSIONS_VACANCIES_OPERATIONAL_KEY:
        'Sessions, vacancies and operational time',
      SESSIONS_AND_VACANCIES_KEY: 'Sessions and vacancies',
      SESSIONS_AND_VACANCIES_DETAILS_KEY: 'Sessions and vacancies details',
      FILTERS_KEY: 'Filters',
    },
    ACCESS_ENVIRONMENT_KEY: 'Access environment',
    CAN_EDIT_ENVIRONMENT_MONITORING_SETTINGS: 'Edit environment monitoring',

    MONITORING_PAGE: {
      SUBTITLE_KEY:
        'Activate the option below to manage environment monitoring',
      SWITCH_TEXT_KEY: 'Enable environment monitoring',
      EMAILS_TO_ALERT_KEY: 'Emails to receive daily summary',
      OPERATING_TIME_KEY: 'Operationalization time of instances',
      OPERATING_TIME_IN_MINUTES_KEY:
        'Maximum operationalization time (in minutes):',
      HISTORY_SUBTITLE_KEY: 'History of monitoring alerts',
      TYPE_KEY: 'Type',
      DATE_TIME_KEY: 'Date and Time',
      INSTANCES_KEY: 'Instances',
      VACANCIES_KEY: 'Vacancies',
      LICENSES_KEY: 'Licenses',
      SESSIONS_KEY: 'Sessions',
      DETAILS_KEY: 'Details',
      MONITORING_SUCCESSFULLY_SET_KEY:
        'Environment monitoring successfully configured!',
      CONFIGURED_OPERATING_TIME_KEY: 'Configured operating time',
      AVERAGE_OPERATING_TIME_KEY: 'Operating time',
      ALERTED_INSTANCES_KEY: 'Alerted instances',
      MINUTES_KEY: 'minutes',
      AVERAGE_OPERATING_TIME_IN_MINUTES_KEY:
        'Average operating time (in minutes):',
    },
    INVALID_SCHEDULE_DATETIME:
      'The date and time of the image publication schedule must be greater than the current date and time.',
    SERVER_HAS_SCHEDULE_PUBLICATION_KEY:
      'This server has a scheduled publication',
    SCHEDULE_PUBLICATION_MODAL_TITLE_KEY: 'Standard publication schedule',
    IDENTIFIER_KEY: 'Identifier',
    REQUESTER_KEY: 'Requester',
    SCHEDULE_DATETIME_KEY: 'Scheduling date and time',
    TIMEZONE_KEY: 'Time zone',
    EMAILS_TO_NOTIFY_CONCLUSION_KEY: 'Emails to notify publication completion',
    DATETIME_TO_SCHEDULE_KEY: 'Time for scheduling',
    CANCEL_PUBLICATION_SCHEDULE_TITLE_KEY:
      'Cancel image publication scheduling',
    CONFIRM_PUBLICATION_SCHEDULE_CONTENT_KEY:
      'Are you sure you want to confirm the schedule for {{datetime}}?',
    CONFIRM_SCHEDULE_KEY: 'Confirm appointment',
    CONFIRM_PUBLICATION_SCHEDULE_TITLE_KEY:
      'Confirm image publication schedule',
    CANCEL_PUBLICATION_SCHEDULE_CONTENT_KEY:
      'Are you sure you want to cancel the {{datetime}} schedule?',
    CANCEL_SCHEDULE_KEY: 'Cancel schedule',
    NO_SCHEDULE_FOUND: 'No appointment found',
    PUBLICATION_SCHEDULE_CANCEL_SUCCESSFULLY_KEY:
      'Publication schedule canceled successfully!',
    PUBLICATION_SCHEDULE_SUCCESSFULLY_KEY:
      'Publication scheduled successfully!',
    BULK_CREATE_KEY: 'Bulk creation',
    BULK_REMOVE_KEY: 'Bulk removal',
    TIME_SET_KEY: 'Time',
    APP_UUID_KEY: 'Application ID',
    APP_NAME_KEY: 'Application name',
    BULK_UPDATE_KEY: 'Bulk edit',
    CAN_EDIT_CLIENTS_IN_BULK: 'Manage clients in bulk',
    REPLACE_KEY: 'Replace',
    OR_KEY: 'Or',
    BULK_CLIENTS: {
      CLIENTS_KEY: 'Clients',
      CLIENTS_TITLE_KEY: 'Environment clients',
      CLIENTS_SUBTITLE_KEY:
        'Manage environment clients by configuring resources in bulk for all environment clients or selecting individually',
      NO_RESOURCE_FOUND_KEY: 'No resources found',
      ENVIRONMENT_KEY: 'Environment',
      EDIT_KEY: 'Edit',
      DETAILS_KEY: 'Details',
      EMAIL_ADMIN_KEY: 'Email Admin',
      COPY_EMAIL_ADMIN_KEY: 'Copy Admin by email',
      BLOCK_MULTIPLE_SESSIONS_KEY: 'Block multiple sessions',
      IOS_DEVICES_KEY: 'Use iOS device',
      ACTIVATE_MFA_KEY: 'Activate MFA',
      LIMIT_LICENSES_KEY: 'Limit licenses',
      LIMIT_CONFIG_KEY: 'Configure license limit',
      ENABLE_DISABLE_KEY: 'Enable/Disable',
      VIRTUALIZER_KEY: 'Virtualizer',
      CONNECTION_TYPE_KEY: 'Connection type',
      CHANGE_CONNECTION_TYPE_KEY: 'Configure connection type',
      CONFIG_CONNECTION_TYPE_KEY: 'Configure connection type status',
      PORT_ONE_KEY: 'Port 01 (Primary)',
      PORT_TWO_KEY: 'Port 02 (Secondary)',
      QUALITY_KEY: 'Quality',
      ACTIVE_KEY: 'Active',
      TYPE_KEY: 'Type',
      PUBLIC_KEY: 'Public',
      PRIVATE_KEY: 'Private',
      QUANTITY_KEY: 'Quantity',
      LIMIT_LICENSES_STATUS_KEY: 'License limit status',
      ACTIVATE_IN_ALL_CLIENTS_KEY: 'Enable license limit on all clients?',
      INACTIVATE_IN_ALL_CLIENTS_KEY: 'Disable license limit on all clients?',
      CONFIRM_ACTIVATE_IN_CLIENTS_KEY:
        'Are you sure you want to configure the license limit on these clients?',
      CONFIRM_INACTIVATE_IN_CLIENTS_KEY:
        'Are you sure you want to disable the license limit on these clients?',
      CONFIRM_ACTIVATE_KEY: 'Confirm license limit configuration',
      CONFIRM_INACTIVATE_KEY: 'Confirm license limit inactivation',
      CONFIRM_ACTIVATE_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Are you sure you want to activate the license limit on all clients?',
      CONFIRM_INACTIVATE_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Are you sure you want to disable the license limit on all clients?',
      ACTIVATE_LIMIT_TO_CONFIRM_KEY:
        'To confirm activation, enter the reason for the action in the field below:',
      INACTIVATE_LIMIT_TO_CONFIRM_KEY:
        'To confirm inactivation, enter the reason for the action in the field below:',
      EDIT_SUCCESSFULLY_KEY: 'Change made successfully!',
      SET_PUBLIC_IN_ALL_CLIENTS_KEY:
        'Set the connection type to public on all clients?',
      SET_PRIVATE_IN_ALL_CLIENTS_KEY:
        'Set connection type to private on all clients?',
      SET_PRIVATE_KEY: 'Make private',
      SET_PUBLIC_KEY: 'Make public',
      CONFIRM_SET_PUBLIC_KEY: 'Confirm changing connection type to public',
      CONFIRM_SET_PRIVATE_KEY: 'Confirm change connection type to private',
      CONFIRM_SET_CONNECTION_TYPE_KEY: 'Confirm connection type change',
      SET_CONNECTION_TYPE_TO_CONFIRM_KEY:
        'To confirm the change, enter the reason for the action in the field below:',
      CONFIRM_CHANGE_KEY: 'Confirm change',
      CONFIRM_SET_PUBLIC_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Are you sure you want to change the connection type to public on all clients?',
      CONFIRM_SET_PRIVATE_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Are you sure you want to change the connection type to private on all clients?',
      CURRENT_ENVIRONMENT_KEY: 'Current environment',
      DESTINATION_ENVIRONMENT_KEY: 'Destination environment',
      CONFIRM_MIGRATION_BETWEEN_ENVIRONMENTS_KEY:
        'Confirm client migration between environments',
      CLIENTS_TO_MIGRATE_KEY: 'Clients to migrate',
      CONFIRMATION_KEY: 'Confirmation',
      CONFIRM_CLIENTS_MIGRATION_TO_ENVIRONMENT_KEY:
        'Are you sure you want to migrate the following clients to the environment',
      CHOOSE_ENVIRONMENT_KEY: 'Choose an environment',
      CONFIRM_CHANGE_VIRTUALIZER_KEY: 'Confirm virtualizer change',
      CONFIRM_CHANGE_VIRTUALIZER_IN_CLIENTS_KEY:
        'Confirm virtualizer change on these clients?',
      CONFIRM_CHANGE_VIRTUALIZER_IN_ALL_CLIENTS_KEY:
        'Confirm virtualizer change on all clients?',
      CONFIG_VIRTUALIZER_IN_ALL_CLIENTS_KEY:
        'Configure this virtualizer and ports for all clients?',
      ACTIVATE_COPY_ADMIN_IN_ALL_CLIENTS_KEY:
        'Enable Copy Admin by email on all clients?',
      INACTIVATE_COPY_ADMIN_IN_ALL_CLIENTS_KEY:
        'Disable Copy Admin by email on all clients?',
      CONFIRM_ACTIVATE_COPY_ADMIN_IN_CLIENTS_KEY:
        'Are you sure you want to activate Copy Admin by Email on these clients?',
      CONFIRM_INACTIVATE_COPY_ADMIN_IN_CLIENTS_KEY:
        'Are you sure you want to disable Copy Admin by Email on these clients?',
      CONFIRM_ACTIVATE_COPY_ADMIN_KEY: 'Confirm Copy Admin activation by email',
      CONFIRM_INACTIVATE_COPY_ADMIN_KEY:
        'Confirm inactivation of Copy Admin by email',
      CONFIRM_ACTIVATE_COPY_ADMIN_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Are you sure you want to activate Copy Admin by Email on all clients?',
      CONFIRM_INACTIVATE_COPY_ADMIN_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Are you sure you want to disable multi-session blocking on all clients?',
      ACTIVATE_BLOCK_MULTIPLE_SESSIONS_IN_ALL_CLIENTS_KEY:
        'Enable multi-session blocking on all clients?',
      INACTIVATE_BLOCK_MULTIPLE_SESSIONS_IN_ALL_CLIENTS_KEY:
        'Disable multi-session blocking on all clients?',
      CONFIRM_ACTIVATE_BLOCK_MULTIPLE_SESSIONS_IN_CLIENTS_KEY:
        'Are you sure you want to enable multi-session blocking on these clients?',
      CONFIRM_INACTIVATE_BLOCK_MULTIPLE_SESSIONS_IN_CLIENTS_KEY:
        'Are you sure you want to disable multi-session blocking on these clients?',
      CONFIRM_ACTIVATE_BLOCK_MULTIPLE_SESSIONS_KEY:
        'Confirm multi-session lock activation',
      CONFIRM_INACTIVATE_BLOCK_MULTIPLE_SESSIONS_KEY:
        'Confirm multi-session lock inactivation',
      CONFIRM_ACTIVATE_BLOCK_MULTIPLE_SESSIONS_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Are you sure you want to enable multi-session blocking on all clients?',
      CONFIRM_INACTIVATE_BLOCK_MULTIPLE_SESSIONS_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Are you sure you want to disable multi-session blocking on all clients?',
      ACTIVATE_USE_IOS_IN_ALL_CLIENTS_KEY:
        'Enable use of iOS devices on all clients?',
      INACTIVATE_USE_IOS_IN_ALL_CLIENTS_KEY:
        'Disable use of iOS devices on all clients?',
      CONFIRM_ACTIVATE_USE_IOS_IN_CLIENTS_KEY:
        'Are you sure you want to enable the use of iOS devices on these clients?',
      CONFIRM_INACTIVATE_USE_IOS_IN_CLIENTS_KEY:
        'Are you sure you want to disable the use of iOS devices on these clients?',
      CONFIRM_ACTIVATE_USE_IOS_KEY: 'Confirm activation of use of iOS devices',
      CONFIRM_INACTIVATE_USE_IOS_KEY:
        'Confirm inactivation of use of iOS devices',
      CONFIRM_ACTIVATE_USE_IOS_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Are you sure you want to enable the use of iOS devices on all clients?',
      CONFIRM_INACTIVATE_USE_IOS_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Are you sure you want to disable the use of iOS devices on all clients?',
      ACTIVATE_MFA_IN_ALL_CLIENTS_KEY: 'Enable MFA usage on all clients?',
      INACTIVATE_MFA_IN_ALL_CLIENTS_KEY: 'Disable MFA usage on all clients?',
      CONFIRM_ACTIVATE_MFA_IN_CLIENTS_KEY:
        'Are you sure you want to enable the use of MFA on these clients?',
      CONFIRM_INACTIVATE_MFA_IN_CLIENTS_KEY:
        'Are you sure you want to disable the use of MFA on these clients?',
      CONFIRM_ACTIVATE_MFA_KEY: 'Confirm activation of MFA use',
      CONFIRM_INACTIVATE_MFA_KEY: 'Confirm inactivation of MFA use',
      CONFIRM_ACTIVATE_MFA_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Are you sure you want to enable the use of MFA on all clients?',
      CONFIRM_INACTIVATE_MFA_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Are you sure you want to disable the use of MFA on all clients?',
      ACTIVATE_CONNECTION_TYPE_IN_ALL_CLIENTS_KEY:
        'Enable use of connection type on all clients?',
      INACTIVATE_CONNECTION_TYPE_IN_ALL_CLIENTS_KEY:
        'Disable use of connection type on all clients?',
      CONFIRM_ACTIVATE_CONNECTION_TYPE_IN_CLIENTS_KEY:
        'Are you sure you want to configure the use of connection type in these clients?',
      CONFIRM_INACTIVATE_CONNECTION_TYPE_IN_CLIENTS_KEY:
        'Are you sure you want to disable the use of connection type on these clients?',
      CONFIRM_ACTIVATE_CONNECTION_TYPE_KEY:
        'Confirm connection type usage configuration',
      CONFIRM_INACTIVATE_CONNECTION_TYPE_KEY:
        'Confirm connection type usage inactivation',
      CONFIRM_ACTIVATE_CONNECTION_TYPE_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Are you sure you want to enable the use of connection type on all clients?',
      CONFIRM_INACTIVATE_CONNECTION_TYPE_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Are you sure you want to disable the use of connection type on all clients?',
      MIGRATE_CLIENTS_BETWEEN_ENVIRONMENTS_KEY:
        'Migrate clients between environments',
      CONFIRM_CHANGE_EMAIL_ADMIN_KEY: 'Confirm administrator email change',
      CONFIRM_CHANGE_EMAIL_ADMIN_IN_CLIENTS_KEY:
        'Confirm administrator email change on these clients?',
      CONFIRM_CHANGE_EMAIL_ADMIN_IN_ALL_CLIENTS_KEY:
        'Confirm administrator email change on all clients?',
      CONFIG_EMAIL_ADMIN_IN_ALL_CLIENTS_KEY:
        'Set this admin email for all clients?',
      EMAILS_TO_ADD_KEY: 'Emails to add:',
      EMAILS_TO_REPLACE_KEY: 'Emails to replace:',
      ENVIRONMENTS_TOTAL_LICENSES_KEY: 'Total environment licenses',
      CONFIG_LIMIT_LICENSES_PASSWORD_AND_REASON_KEY:
        'To activate editing of the number of licenses in the table, fill in the fields below with the reason for the action and your operator password:',
      SELECT_CLIENTS_TO_MIGRATE_KEY: 'Select clients to migrate:',
      UPDATE_KEY: 'Update data',
      ENVIRONMENT_DEFAULT_KEY: 'Environment default',
      LICENSES_QUANTITY_KEY: 'Number of licenses',
    },
    COMPLETION_DATE_KEY: 'Completion date',
    MAKE_ENVIRONMENT_PRODUCTIVE_KEY: 'Make productive',
    CONFIRM_MAKE_ENVIRONMENT_PRODUCTIVE_KEY:
      'Are you sure you want to set the status of this environment to “Production”?',
    COMPLETION_DATE_STATUS_KEY: 'Status completion date',
    PENDING_COMPLETION_DATE_KEY:
      'This environment has a pending completion date extension request for day: {{completion_date_proposed}}. When accepted, this date will be the new completion date for this status',
    PENDING_COMPLETION_DATE_NO_DATE_KEY:
      'This environment has a pending completion date extension request. When accepted, the requested date will replace the current date',
    EXTEND_REQUEST_KEY: 'Extension request',
    EXTEND_REASON_KEY: 'Reason for extension',
    VALIDATE_PENDENCIES_KEY: 'Evaluate pending issues',
    COMPLETION_DATE_SOLICITATION_KEY: 'Request for new completion date',
    APPROVE_KEY: 'Approve',
    REQUEST_EXTEND_KEY: 'Request extension',
    EXTEND_COMPLETION_DATE_KEY: 'Extend status completion date',
    SELECT_NEW_COMPLETION_DATE_KEY: 'Select new completion date',
    APPROVE_EXTEND_DATE_KEY: 'Approve extension date',
    NEW_COMPLETION_DATE_WILL_BE_KEY:
      'The new completion date for this status will be',
    EXTEND_REQUESTED_BY_KEY: 'This request was made by',
    DAYS_TO_EXPIRE_KEY: 'Days to expire',
    ENVIRONMENTS_STATUS_TO_EXPIRE_KEY:
      'Environments with status to expire in the next 7 days',
    ENVIRONMENTS_STATUS_TO_EXPIRE_SHORT_KEY:
      'Environments with status to expire',
    CAN_EDIT_COMPANY_ALIAS: 'Edit account display name',
    CONFIRM_COMPANY_ALIAS_KEY:
      'Are you sure you want to set the display name {{alias}} for this company?',
    CONFIRM_COMPANY_ALIAS_TITLE_KEY: 'Save company display name',
    ALIAS_CREATED_SUCCESSFULLY_KEY: 'Name changed successfully!',
    ALIAS_NAME_KEY: 'Display name',
    CREATE_ALIAS_NAME_KEY: 'Create display name',
    LEGAL_NAME_KEY: 'Fantasy name',
    COMPANY_NAME_CRM_KEY: 'Company name (CRM)',
    APPROVED_REQUEST_KEY: 'Request approved!',
    CAN_ACCEPT_PENDING_EXTENSION: 'Approve end date extension',
    CLICK_TO_FILTER_ENV_STATUS_KEY:
      'Click to filter environments with this status in the table',
    CLICK_TO_FILTER_PROVIDER_KEY:
      'Click to filter environments with this provider in the table',
    CLICK_TO_FILTER_ENV_DNS_KEY:
      'Click to filter environments with this DNS status in the table',
    CLICK_TO_FILTER_ENV_CONNECTION_TYPE_KEY:
      'Click to filter environments with this connection type in the table',
    CLICK_TO_FILTER_ENV_BEHAVIOR_KEY:
      'Click to filter environments with this behavior in the table',
    CLICK_TO_FILTER_ENV_VIRTUALIZER_KEY:
      'Click to filter environments with this virtualizer in the table',
    CLICK_TO_FILTER_ENV_PRODUCT_KEY:
      'Click to filter the environments for this product in the table',
    CLICK_TO_FILTER_ENV_ZERO_TRUST_KEY:
      'Click to filter the environments of this Zero Trust status in the table',
    CLICK_TO_FILTER_ENV_PRODUCT_TYPE_KEY:
      'Click to filter the environments with this product type in the table',
    CLICK_TO_FILTER_ENV_REGION_KEY:
      'Click to filter the environments of this region in the table',
    ENV_STATUS_GRAPHS_KEY: 'Environment status graphs',
    ENV_MAINTENANCE_GRAPHS_KEY:
      'Maintenance graphs and warning display of environments',
    ENV_REGION_GRAPHS_KEY: 'Environment region graphs',
    ENV_PRODUCT_GRAPHS_KEY: 'Environment product graphs',
    ENV_ZERO_TRUST_GRAPHS_KEY: 'Zero Trust usage charts for environments',
    ENV_BEHAVIOR_GRAPHS_KEY: 'Environment behavior graphs',
    ENV_PRODUCT_TYPE_GRAPHS_KEY: 'Environment product type graphics',
    ENV_VIRTUALIZER_GRAPHS_KEY: 'Environment virtualizer graphs',
    ENV_PROVIDER_GRAPHS_KEY: 'Environment provider graphs',
    ENV_DNS_GRAPHS_KEY: 'Environment DNS graphs',
    ENV_CONNECTION_TYPE_GRAPHS_KEY: 'Environment connection type charts',
    POLAR_GRAPH_KEY: 'Polar Graph',
    DONUT_GRAPH_KEY: 'Donut Chart',
    BAR_GRAPH_KEY: 'Bar Chart',
    CURRENT_TIMEZONE_TIME_KEY: 'Current time of the selected time zone',
    AVAILABLE_LICENSES_REACHED_KEY:
      'The number of available licenses has been exceeded',
    GET_ENVIRONMENT_MAINTENANCE: 'View environment maintenance details',
    EDIT_ENVIRONMENT_MAINTENANCE: 'Configure environment maintenance',
    ENVIRONMENT_MAINTENANCE_HISTORY: 'View environment maintenance history',
    GET_CLIENT_MAINTENANCE: 'View customer maintenance details',
    EDIT_CLIENT_MAINTENANCE: 'Configure customer maintenance',
    CLIENT_MAINTENANCE_HISTORY: 'View customer maintenance history',
    REQUEST_NEW_COMPLETION_DATE_KEY:
      'To request a new completion date, select the date you want in the field below, and state the reason for the request.',
    CURRENT_COMPLETION_DATE_KEY: 'Current completion date',
    NEW_COMPLETION_DATE_KEY: 'New completion date',
    CONFIRM_REQUEST_KEY: 'Confirm request',
    COMPLETION_DATE_PROPOSE_RULE_KEY:
      'The new completion date cannot be less than or equal to the current date.',
    COMPLETION_DATE_EXTEND_REQUESTED_SUCCESSFULLY_KEY:
      'New completion date requested successfully!',
    REFUSE_KEY: 'Refuse',
    REFUSE_EXTEND_DATE_KEY: 'Refuse completion date extension',
    REFUSE_EXTEND_DATE_DETAILS_KEY:
      'The requested completion date ({{completion_date_proposed}}) will be refused, and the current completion date ({{completion_date}}) will be kept.',
    MAINTENANCE_SET_SUCCESSFULLY_KEY: 'Maintenance set up successfully!',
    CONFIRM_MAINTENANCE_CONFIG_KEY:
      'To confirm the maintenance configuration, enter the reason for the action in the field below',
    MAINTENANCE_CONFIG_KEY: 'Maintenance configuration',
    COMPLETION_DATE_EXPIRED_KEY: 'Completion date expired',
    USE_LIMIT_DAILY: 'Use daily publication limit',
    MAINTENANCE_HISTORY_KEY: 'Maintenance history',
    DETAILS_MAINTENANCE_HISTORY_KEY: 'Maintenance history details',
    MAINTENANCE_UPDATED_AT_KEY: "'Updated on' d 'of' MMMM 'of' yyyy 'at' HH:mm",
    MAINTENANCE_CHANGED_BY_KEY: 'By {{first_name}} {{last_name}} ({{email}})',
    MAINTENANCE_REASON_KEY: 'Reason: {{reason}}',
    UPDATED_BY_SCHEDULE_MAINTENANCE_KEY:
      'Automatic change made by scheduled maintenance',
    MODIFIED_BY_CUSTOMER_PORTAL_KEY: 'Change made via the Customer Portal',
    MODIFIED_BY_API_V2_KEY: 'Change made via the Autosky Platform API',
    MODIFIED_BY_SKYINONE_KEY: 'Change made via Admin V1',
    NOT_ENOUGH_MAINTENANCE_HISTORY_DATA_KEY:
      'Not enough maintenance history data',
    FIELD_KEY: 'Field',
    OLD_VALUE_KEY: 'Previous value',
    NEW_VALUE_KEY: 'New value',
    PUBLICATION_WITH_BLOCKING_NOT_ENABLED:
      'Publication while keeping users logged in is not allowed for this environment.',
    PUBLICATION_WITH_BLOCKING_MONTHLY_LIMIT_EXCEEDED:
      'Monthly publication limit reached!',
    PUBLICATION_WITH_BLOCKING_DAILY_LIMIT_EXCEEDED:
      'Daily publications limit reached!',
    EDIT_ENV_AUTO_BLOCK_INSTANCES_MAINTENANCE:
      'Configure daily blocking of instances',
    LIST_ENV_AUTO_BLOCK_INSTANCES_DETAILS: 'View daily instance block details',
    AUTO_BLOCK_INSTANCES_KEY: 'Daily blocking of instances',
    AUTO_BLOCK_INSTANCES_TIME_KEY: 'Lock execution time',
    AVAILABLE_CLIENTS_LIST_KEY: 'List of available clients',
    TEMPLATE_KEY: 'Template',
    CANNOT_CHANGE_MODE_FROM_MICRO_WITH_APPLICATION_SERVER_ATTACHED:
      'Could not change mode from Micro with application server attached',
    DUPLICATED_ROLE_NAME: 'Permission group name already exists',
    REGIONS_KEY: 'Regions',
    MAINTENANCE_AND_WARNING_KEY: 'Maintenance and Warning',
    ZERO_TRUST_ENABLED_KEY: 'Zero Trust enabled',
    ZERO_TRUST_FAILED_KEY: 'Zero Trust failed',
    ZERO_TRUST_GRACE_PERIOD_KEY:
      'Zero Trust awaiting initialization. This process may take up to 5 minutes',
    ZERO_TRUST_STARTING_KEY: 'Zero Trust initializing',
    ZERO_TRUST_WRONG_VERSION_KEY: 'Zero Trust status not available',
    CONFIG_ENV_DASHBOARD_MODAL_KEY: 'Environment dashboard configuration',
    CONFIG_DASHBOARD_KEY: 'Configure dashboard',
    EXPAND_DASHBOARD_KEY: 'Expand dashboard',
    HIDE_DASHBOARD_KEY: 'Hide dashboard',
    HIDE_SESSIONS_GRAPH_KEY: 'Hide sessions graph',
    EXPAND_SESSIONS_GRAPH_KEY: 'Expand sessions graph',
    ENV_DASHBOARD_KEY: 'Environment dashboard',
    CLEAR_SELECTION_KEY: 'Clear selected',
    EXPAND_CARDS_KEY: 'Expand cards',
    MINIMIZE_CARDS_KEY: 'Minimize cards',
    SELECT_CARDS_TITLE_CARDS_KEY:
      'Choose up to 3 cards to be displayed in the environment dashboard',
    DONT_USE_ENV_DASHBOARD_KEY: 'Do not use environment dashboards',
    SUCCESSFULLY_CONFIG_DASHBOARD_KEY: 'Dashboard configured successfully!',
    ZERO_TRUST_DISABLED_KEY: 'Zero Trust disabled',
    NO_DASHBOARD_KEY: 'No dashboard',
    FILTERED_TOTAL_KEY: 'Total with filters',
    MAINTENANCE_STATUS_KEY: 'Maintenance status',
    RESTORE_DEFAULT_GRAPHS_KEY: 'Restore default graphics',
    WANT_DEACTIVATE_ZERO_TRUST_KEY: 'Do you want to deactivate Zero Trust?',
    WANT_ACTIVATE_ZERO_TRUST_KEY: 'Do you want to activate Zero Trust?',
    ACTIVATE_ZERO_TRUST_DESCRIPTION_KEY:
      'When enabling Zero Trust, users connected to the instance may be disconnected.',
    DEACTIVATE_ZERO_TRUST_DESCRIPTION_KEY:
      'The Zero Trust update may take up to 5 minutes to take effect. During this period, users switching devices or accessing the instance may be blocked. Do you want to continue?',
    REMOVED_IPS_ZERO_TRUST_EXPLANATION_KEY:
      'IPs removed from the allow list will only be effectively deleted after a 30-day period.',
    ALLOWED_SKYONE_IPS_ZERO_TRUST_KEY: 'Skyone IPs are allowed by default.',
    CONFIG_CLIENTS_DASHBOARD_MODAL_KEY: 'Clients dashboard configuration',
    CLIENTS_DASHBOARD_KEY: 'Clients dashboard',
    CLICK_TO_FILTER_CLIENTS_STATUS_KEY:
      'Click to filter the clients with this status in the table',
    CLICK_TO_FILTER_CLIENTS_VIRTUALIZER_KEY:
      'Click to filter the clients with this virtualizer in the table',
    CLICK_TO_FILTER_CLIENTS_CONNECTION_TYPE_KEY:
      'Click to filter the clients with this connection type in the table',
    CLIENTS_BLOCK_MULTIPLE_SESSION_GRAPHS_KEY:
      'Graphs of clients blocking multiple sessions',
    CLIENTS_CONNECTION_TYPE_GRAPHS_KEY: 'Client connection type graphs',
    CLIENTS_MFA_GRAPHS_KEY: 'Client MFA graphs',
    CLIENTS_USE_PROFILE_GRAPHS_KEY: 'Clients remote profile graphs',
    CLIENTS_VIRTUALIZER_GRAPHS_KEY: 'Client virtualizer charts',
    DONT_USE_CLIENTS_DASHBOARD_KEY: 'Do not use clients dashboard',
    MANAGE_ENV_LICENSE_LIMIT_KEY:
      'Allow management of client licenses by environment',
    MANAGE_CHANGE_PASSWORD_KEY: 'Allow password change for external AD',
    LICENSE_MANAGEMENT_KEY: 'Licenses management',
    PASSWORD_MANAGEMENT_KEY: 'Password management',
    ACTIVE_DUO_DESCRIPTION_KEY: 'DUO authentication',
    DUO_CLIENT_ID: 'Client ID',
    DUO_CLIENT_SECRET: 'Client Secret',
    HOST_KEY: 'Host',
    BYPASS_IF_UNAVAILABLE_KEY: 'Allow login in case of unavailability',
    BYPASS_IF_UNAVAILABLE_DESCRIPTION_KEY:
      'By enabling this option, if the DUO service becomes unavailable, user login will be performed normally',
    OBSERVATIONS_KEY: 'Observations',
    AUTOSKY_ROUTINE: 'Autosky routine',
    FILTERS_APPLIED_KEY: 'Filters applied',
    CONFIG_PARTNERS_DASHBOARD_MODAL_KEY: 'Account dashboard configuration',
    PARTNERS_DASHBOARD_KEY: 'Account dashboard',
    DONT_USE_PARTNERS_DASHBOARD_KEY: 'Do not use account dashboard',
    CLICK_TO_FILTER_PARTNERS_STATUS_KEY:
      'Click to filter accounts with this status in the table',
    CLICK_TO_FILTER_PARTNERS_CONFIG_KEY:
      'Click to filter the accounts with this configuration in the table',
    CLICK_TO_FILTER_PARTNERS_PROVIDER_KEY:
      'Click to filter the accounts with this provider in the table',
    CLICK_TO_FILTER_PARTNERS_LDAP_KEY:
      'Click to filter the accounts with this LDAP in the table',
    PARTNERS_LDAP_GRAPHS_KEY: 'LDAP type charts of the accounts',
    PARTNERS_SSO_GRAPHS_KEY: 'Account SSO configuration graphs',
    PARTNERS_PROVIDER_TYPE_GRAPHS_KEY: 'Accounts provider type graphs',
    PARTNERS_NEW_FRONT_GRAPHS_KEY: 'Account Portal 2.0 usage graphs',
    CONFIG_USERS_DASHBOARD_MODAL_KEY: 'User dashboard configuration',
    USERS_DASHBOARD_KEY: 'User dashboard',
    DONT_USE_USERS_DASHBOARD_KEY: 'Do not use user dashboard',
    CLICK_TO_FILTER_USERS_STATUS_KEY:
      'Click to filter users with this status in the table',
    CLICK_TO_FILTER_USERS_CONFIG_KEY:
      'Click to filter users with this configuration in the table',
    USERS_MFA_GRAPHS_KEY: 'Users MFA configuration graphs',
    USERS_SALT_GRAPHS_KEY: 'Users Salt configuration graphs',
    USERS_ACTIVE_GRAPHS_KEY: 'User status charts',
    CHOOSE_DEFAULT_IMAGE_KEY: 'Choose default banner image',
    USE_NEW_PORTAL_KEY: 'Uses Portal 2.0',
    CLIENTS_TOTAL_KEY: 'Total clients',
    USERS_TOTAL_KEY: 'Total users',
    PARTNERS_TOTAL_KEY: 'Total partners',
    TEST_ZERO_TRUST_KEY: 'Validate Zero Trust',
    VALIDATE_INSTANCE_ZERO_TRUST: 'Validate Zero Trust per instance',
    ZERO_TRUST_CONFIG_AT_ENV_KEY: 'Zero Trust environment enabled',
    ZERO_TRUST_CONFIG_WHITELIST_CLEANUP_INTERVAL_KEY:
      'Whitelist cleanup interval (in days)',
    INTEGRATION_TEST_KEY: 'IP release test on the instance',
    PROVIDER_RULE_KEY:
      'Confirmation of the security rule for Zero Trust in the provider',
    PLATFORM_VERSION_KEY: 'Platform version confirmation',
    MINIMUM_VERSION_KEY: 'Recommended minimum version',
    CURRENT_VERSION_KEY: 'Current version',
    VALID_KEY: 'Valid',
    INVALID_KEY: 'Invalid',
    INCONSISTENT_ZERO_TRUST_KEY: 'Zero Trust with inconsistency',
    VALID_ZERO_TRUST_KEY: 'Valid Zero Trust',
    INVALID_ZERO_TRUST_KEY: 'Zero Trust invalid',
    INFO_NOT_AVAILABLE_KEY: 'Information not available',
    VALIDATE_AGAIN_KEY: 'Validate again',
    CLICK_ON_INSTANCE_KEY: 'Click on an instance to see more details',
    PLATFORM_VERSION_NUMBER_KEY: 'Platform version',
    EXPAND_ACTIONS_KEY: 'Expand actions',
    CLICK_HERE_TO_DETAILS_KEY: 'Click here to see more details',
    REQUEST_ID_KEY: 'Request ID',
    RECOVERY_ID_KEY: 'Recovery ID',
    CAN_EXPORT_PARTNER_SUMMARY_LIST: 'Export list of accounts in CSV or PDF',
    CAN_EXPORT_ENVIRONMENT_SUMMARY_LIST:
      'Export environment listing in CSV or PDF',
    CAN_EXPORT_CLIENT_SUMMARY_LIST: 'Export client listing in CSV or PDF',
    CAN_EXPORT_USER_SUMMARY_LIST: 'Export user list in CSV or PDF',
    PUBLISHING_STARTED_SUCCESSFULLY_KEY: 'Publication started successfully!',
    OPTIMIZED_KEY: 'Optimized',
    PUBLICATIONS_PAGE_TITLE_KEY: 'Publishing and scheduling new versions',
    SELECT_PUBLICATION_MODE_KEY: 'Select the desired publication mode below',
    EMAILS_TO_NOTIFY_KEY: 'Emails to be notified',
    BLOCK_INSTANCES_KEY: 'Block instances',
    BLOCK_USERS_KEY: 'End sessions',
    STOP_SERVER_KEY: 'Stop preparation server when creating image',
    NEW_KEY: 'NEW',
    HOW_TO_OPTIMIZE_KEY: 'How does optimized publishing work?',
    RULE_TO_PUBLISH_KEY:
      'To perform a new publication, there must be a staging server',
    OPTIMIZED_PUBLICATION_DEFINITION_KEY:
      'The optimized publication mode unifies existing publication modes into a single approach. Standard publications, keeping users connected or requesting users to reconnect, can be carried out in optimized mode as follows',
    HOW_TO_OPTIMIZE_DEFAULT_KEY:
      'The default publishing mode is equivalent to not checking the options to lock instances or end sessions.',
    HOW_TO_OPTIMIZE_KEEP_KEY:
      'The publishing mode that keeps users logged in is equivalent to checking the option to lock instances but not to terminate sessions.',
    HOW_TO_OPTIMIZE_RECONNECTION_KEY:
      'Publishing mode that prompts users to reconnect is equivalent to checking the options to lock instances and end sessions. It is not possible to end sessions without locking the instances',
    HOW_TO_OPTIMIZE_STOP_SERVER_KEY:
      'This option allows you to set whether, when creating the image, the staging server needs to be stopped. If unchecked, the server will continue to be available during creation',
    SEE_EXAMPLE_KEY: 'See example',
    OPTIMIZED_PUBLICATION_KEY: 'Optimized publication',
    OPTIMIZED_PUBLICATION_CONFIRM_KEY:
      'Do you want to confirm the publication of a new image in optimized mode?',
    DEFAULT_PUBLICATION_KEY: 'Default publication',
    DEFAULT_PUBLICATION_CONFIRM_KEY:
      'Do you want to confirm the publication of a new image in default mode?',
    KEEP_PUBLICATION_KEY: 'Publishing while users are logged in',
    KEEP_PUBLICATION_CONFIRM_KEY:
      'Do you want to confirm publication of a new image in keeping users logged in mode?',
    RECONNECTION_PUBLICATION_KEY:
      'Publication requesting reconnection of users',
    RECONNECTION_PUBLICATION_CONFIRM_KEY:
      'Do you want to confirm the publication of a new image in the mode requesting reconnection of users?',
    SCHEDULE_KEY: 'Schedule',
    UNAVAILABLE_VERSION_KEY: 'Version unavailable',
    SEE_GENERATED_MODELS_KEY: 'View generated models',
    LOGS_PUBLICATION_SUBSCRIPTION_KEY: 'Logs and details of publications made',
    SCHEDULES_KEY: 'Schedules',
    SCHEDULES_LISTING_KEY: 'Listing of scheduled publications',
    PUBLISH_NEW_IMAGE_OPTIMIZED_KEY: 'Publish new version (Optimized)',
    HISTORY_LOGS_PUBLISH_OPTIMIZED_KEY: 'Publication history and tracking',
    HISTORY_LOGS_PUBLISH_OPTIMIZED_DESCRIPTION_KEY:
      'Publications made and in progress',
    AVERAGE_STEP_TIME_KEY: 'Average time of each step',
    AVERAGE_TOTAL_TIME_KEY: 'Total process average',
    STAGE_FAILED_KEY: 'Failed',
    IN_PROGRESS_KEY: 'In progress...',
    PUBLICATION_DETAILS_KEY: 'Publication details',
    SUCCESSFUL_PUBLICATION_KEY: 'Publication completed successfully!',
    FAILED_PUBLICATION_KEY: 'Publication failed',
    WARNING_PUBLICATION_KEY: 'Inconsistencies when publishing',
    MADE_BY_KEY: 'Made by',
    START_END_KEY: 'Start/End',
    MODEL_VERSION_KEY: 'Model version',
    DURATION_KEY: 'Duration',
    PUBLICATION_IN_PROGRESS_KEY:
      'Publication in progress. Please wait for finalization before publishing another version.',
    PUBLISH_SUCCESS_KEY: 'Success',
    PUBLISH_FAILED_KEY: 'Failure',
    PUBLISH_TIMEOUT_KEY: 'Timeout',
    PUBLISH_WARNING_KEY: 'Inconsistency',
    PUBLISH_RUNNING_KEY: 'In progress',
    PUBLISH_SKIPPED_KEY: 'Not applicable',
    PUBLICATION_STEP_DETAILS_KEY: 'Step details',
    WAIT_PROGRESS_PUBLISH_KEY:
      'Stage in progress. Wait for completion to see more details',
    GENERATED_MODEL_KEY: 'Model version',
    UNAVAILABLE_MODEL_KEY: 'Model unavailable',
    BLOCK_INSTANCES_TOOLTIP_KEY:
      'After completing the creation of the templates, instances with the updated versions will be started, and instances using the previous versions will be blocked.',
    BLOCK_USERS_TOOLTIP_KEY:
      'After the instances with the updated versions are started, sends a disconnection message to the users connected to the instances using the previous versions.',
    PUBLISH_IN_BULK_SUCCESS_KEY:
      "Publication started successfully! You can track the progress and history of each server's publication by clicking on 'Publication history and tracking' in the server's actions.",
    NOT_ENOUGH_DATA_PUBLISH_LOGS_KEY:
      'Not enough data. Perform an optimized publish for more details',
    MULTIPLE_EXPIRED_SESSIONS: 'Multiple expired sessions',
    USER_ALREADY_HAS_EXTERNAL_AD: 'User already has an external AD account',
    LIST_WEB_APPLICATIONS: 'List web applications',
    CREATE_NEW_WEB_APPLICATION: 'Add web applications',
    EDIT_WEB_APPLICATION: 'Edit web applications',
    DELETE_WEB_APPLICATION: 'Remove web applications',
    CAN_VIEW_ALL_RESOURCES: 'General list of resources',
    CAN_BLOCK_ACTIONS_PREPARATION_SERVER: 'Block preparation server actions',
    CAN_UNBLOCK_ACTIONS_PREPARATION_SERVER:
      'Unblock actions from the preparation server',
    CAN_BLOCK_ACTIONS_PARTNER_SERVERS:
      'Block preparation server actions at partners',
    CAN_UNBLOCK_ACTIONS_PARTNER_SERVERS:
      'Unblock actions from the preparation server at partners',
    BLOCK_SERVER_ACTIONS_SUCCESSFULLY_KEY:
      'Server actions successfully blocked!',
    BLOCK_ACTIONS_SERVER_KEY: 'Block server actions',
    BLOCKING_TIME_SERVER_KEY: 'Server actions blocking time',
    BLOCKING_REASON_KEY: 'Reason for blocking',
    BLOCKING_ACTIONS_KEY: 'Block actions',
    BLOCKING_SERVER_ACTIONS_DESCRIPTION_KEY:
      'Blocking server actions prevents users from performing the following operations: linking, unlinking, connecting, stopping, publishing new images and connecting, for the period selected below.',
    BLOCKED_PUBLICATIONS_DESCRIPTION_KEY:
      'The publication of new releases is temporarily blocked due to the blocking of actions on the server performed by {{name}} on {{time}}.',
    BLOCKED_PUBLICATIONS_RELEASE_KEY:
      'The publication will be available at {{unblockDate}} or if the actions are unblocked.',
    BLOCKED_ACTIONS_ALERT_DESCRIPTION_KEY:
      'Actions on the server are temporarily blocked due to the blocking of actions on the server performed by {{name}} on {{time}}.',
    BLOCKED_ACTIONS_RELEASE_KEY:
      'Actions will be available at {{unblockDate}} or if actions are unblocked.',
    SERVER_MAINTENANCE_ACTIONS_RELEASE_KEY:
      'This server is under maintenance until {{unblockDate}}. It is not possible to perform actions on the server or publish new images during this period.',
    UNBLOCK_ACTIONS_SERVER_KEY: 'Unlock server actions',
    UNBLOCKING_ACTIONS_KEY: 'Unblock actions',
    UNBLOCKING_SERVER_ACTIONS_DESCRIPTION_KEY:
      'Do you wish to unblock server actions?',
    UNBLOCKING_SERVER_ACTIONS_RESPONSIBLE_KEY:
      'The blocking of actions was performed by {{name}} at {{time}} and will be terminated at {{unblockDate}}',
    UNBLOCK_SERVER_ACTIONS_SUCCESSFULLY_KEY:
      'Server actions successfully unblocked!',
    UNBLOCKING_REASON_KEY: 'Reason for unblocking',
    BLOCK_ACTIONS_TOOLTIP_SERVER_KEY:
      'Actions released. Click to block server actions',
    UNBLOCK_ACTIONS_TOOLTIP_SERVER_KEY:
      'Actions blocked. Click to unblock server actions',
    BLOCKED_ACTIONS_PARTNER_KEY: 'Blocked actions',
    MODAL_ACTIONS_BLOCKED_KEY:
      'The action will not be executed on servers with blocked actions (indicated by the lock icon next to the actions button). To execute on these servers, unlock individually or use the bulk unlock option in the general actions.',
    DISABLE_RECAPTCHA_TOGGLE_KEY: 'Temporarily disable reCAPTCHA in Portal 2.0',
    LAST_RECAPTCHA_INACTIVE_KEY: 'Inactivation performed by: ',
    BY_AT_KEY: '{{name}} on {{date}}.',
    INACTIVATING_REASON_KEY: 'Inactivation reason',
    INACTIVATING_REASON_DETAIL_KEY: 'Inactivation reason: ',
    INACTIVATE_RECAPTCHA_KEY: 'Inactivation of reCAPTCHA',
    INACTIVATE_RECAPTCHA_DESCRIPTION_KEY:
      'reCAPTCHA will be inactivated on the “Forgot my password”, “Register your password” and “Change my password” pages for 30 days after the inactivation date.',
    EDIT_BLOCK_INSTANCES_WITH_SESSIONS_TIMEOUT:
      'Configure block monitoring for instances with multiple expired sessions',
    BLOCK_INSTANCES_WITH_SESSIONS_TIMEOUT_KEY:
      'Block instances with multiple expired sessions',
    BLOCK_INSTANCES_WITH_SESSIONS_TIMEOUT_ALERT_KEY:
      'Blocking of instances is not performed in environments of the behavior modes: MANUAL and MICRO.',
    BLOCKED_BY_MONITORING_KEY: 'Blocked by monitoring',
    STATUS_ZERO_TRUST_KEY: 'Zero Trust status',
    SPENT_SECONDS_TO_OPERATIONAL_ALERT_KEY:
      'Time until operational or until alert',
    EXPIRED_SESSIONS_KEY: 'Expired sessions',
    CONTINUE_KEY: 'Continue',
    VERIFICATION_CODE_KEY: 'Verification code',
    HELP_VERIFICATION_CODE_ONE_KEY:
      "The security code sent in your email is designed to guarantee the security of the actions taken. To confirm the action, you must enter the code in the 'Verification code' field. If you haven't received the email, you can try resending it by clicking on the resend option below the code field, 60 seconds after the last request.",
    HELP_VERIFICATION_CODE_TWO_KEY:
      'If you are not receiving the code, check your spam or junk mail box. Also confirm the email address registered in your account by clicking on your name in the menu at the top right > Profile > Email field.',
    MORE_INFO_KEY: 'Learn more',
    WAIT_KEY: 'Wait...',
    VERIFICATION_CODE_RETRY_SECONDS_KEY:
      "If you didn't receive the code in your email, you can try again in {{seconds}} seconds.",
    VERIFICATION_CODE_RETRY_SECOND_KEY:
      "If you didn't receive the code in your email, you can try again in {{seconds}} seconds.",
    VERIFICATION_CODE_RETRY_KEY:
      "If you didn't receive the code, you can resend the email.",
    VERIFICATION_CODE_DESCRIPTION_KEY:
      'A verification code has been sent to your email. Please enter it below to confirm the action:',
    INVALID_RESTRICTED_ACTION_TOKEN: 'Incorrect verification code',
    RELEASE_RECAPTCHA_KEY:
      'The reCAPTCHA will be reactivated automatically on {{date}}.',
    REACTIVATION_KEY: 'Reactivation: ',
    LDAP_TEST_RESULT: {
      AUTHENTICATE_ADMIN: 'Administrator authentication',
      CREATE_GROUP: 'Group creation',
      CREATE_USER: 'User creation',
      ACTIVATE_USER: 'User activation',
      RESET_USER_PASSWORD: 'User password reset',
      AUTHENTICATE_USER: 'User authentication',
      CHANGE_USER_PASSWORD: 'User password change',
      REMOVE_USER_FROM_GROUP: 'User removal from group',
      DELETE_USER: 'User deletion',
      DELETE_GROUP: 'Group deletion',
    },
    CONNECTED_SUCCESSFULLY_KEY: 'Test performed successfully!',
    CONNECTION_FAILED_KEY: 'Test failed',
    CUSTOM_APP_COLOR_DETAILS_KEY: 'Web application details',
    CUSTOM_DETAILS_COLOR_DETAILS_KEY: 'Details on login page',
    LIST_LICENSE_GROUPS: 'List license groups',
    CREATE_LICENSE_GROUP: 'Create license group',
    EDIT_LICENSE_GROUP: 'Edit license group',
    DELETE_LICENSE_GROUP: 'Delete license group',
    EDIT_LICENSE_GROUP_CLIENTS: 'Edit license group clients',
    LICENSE_GROUP_KEY: 'License group',
    LICENSE_GROUP_SUBTITLE_KEY: 'Listing and management of license groups',
    CREATE_LICENSE_GROUP_KEY: 'Create license group',
    GROUP_CREATED_SUCCESSFULLY_KEY: 'Group created successfully!',
    GROUP_DELETED_SUCCESSFULLY_KEY: 'Group deleted successfully!',
    DELETE_LICENSE_GROUP_KEY: 'Delete license group',
    DELETE_LICENSE_GROUP_CONFIRM_KEY:
      'Are you sure you want to delete this license group?',
    ADD_CLIENTS_TO_GROUP_KEY: 'Add clients to the group',
    ADD_CLIENTS_TO_GROUP_DESCRIPTION_KEY:
      'Select the clients you want to add to this license group',
    LICENSE_LIMIT_NOT_AVAILABLE: 'Number of licenses not available',
    ENVIRONMENT_NOT_ALLOW_PER_CLIENT_LICENSES:
      'This environment does not allow licenses per client',
    CLIENTS_ADDED_SUCCESSFULLY_KEY: 'Clients added successfully!',
    CLIENTS_UPDATED_SUCCESSFULLY_KEY: 'Clients edited successfully!',
    GROUP_DETAILS_KEY: 'Group details',
    LICENSES_QUANTITY_KEY: 'Number of licenses',
    CLIENTS_QUANTITY_KEY: 'Number of clients',
    EDIT_GROUP_INFO_KEY: 'Edit name and licenses',
    EDIT_CLIENTS_KEY: 'Edit clients',
    GROUP_UPDATED_SUCCESSFULLY_KEY: 'Group edited successfully!',
    UPDATE_LICENSE_GROUP_KEY: 'Edit license group',
    EDIT_CLIENTS_IN_GROUP_KEY: 'Edit clients in the group',
    EDIT_CLIENTS_DESCRIPTION_KEY:
      'Select the clients you want to add to the group, or deselect the ones you want to remove',
    ACCESS_GROUP_KEY: 'Access group',
    LICENSE_LIMIT_GROUP_KEY: 'Number of licenses in the group',
    THIS_CLIENT_IS_IN_GROUP_KEY: 'This client is part of the license group',
    CLIENT_IN_GROUP_TOOLTIP_KEY:
      'To configure licenses per client, you must remove this client from the license group',
    ZERO_TRUST_CARD_INFO_TEXT_KEY:
      'Only environments with a public connection are counted.',
    ZERO_TRUST_CONFIG_INFO_TEXT_KEY:
      'Only environments with a public connection are eligible.',
    NOT_IDENTIFIED_KEY: 'Not identified',
    ENVIRONMENT_NOT_ELIGIBLE_FOR_TEST_KEY:
      'Environment not eligible for this test',
    AVAILABLE_LICENSES_ENVIRONMENT_KEY: 'Licenses available in the environment',
    AVAILABLE_LICENSES_GROUP_KEY: 'Licenses available for this group',
    REMOVED_PERMANENTLY_KEY: 'Removed permanently',
    CONDITION_OPERATORS: {
      ICONTAINS_KEY: '~ (contains)',
      ICONTAINS_NOT_KEY: '!~ (does not contains)',
      IS_KEY: '= (is equal)',
      IS_NOT_KEY: '!= (is not equal)',
    },
    FILTERS_KEY: 'Filters',
    SEARCH_FILTERS_KEY: 'Search filters',
    NO_OPTIONS_KEY: 'No options',
    CLIENT_ALREADY_IN_LICENSE_GROUP_KEY:
      'You have selected a client that is already in a license group. When you confirm, the selected client will be removed from the previous group and added to this group',
    MALFORMED_X509_PUBLIC_CERTIFICATE: 'Invalid IdP x509 certificate',
    TITLE_FONTS_LOGIN_KEY: 'Texts and fonts login',
    TITLE_FONTS_MFA_KEY: 'Texts and fonts MFA',
    LOGIN_PAGE_TITLE_TEXT_PTBR_KEY: 'Title of the login page in Portuguese',
    LOGIN_PAGE_SUBTITLE_TEXT_PTBR_KEY:
      'Subtitle of the login page in Portuguese',
    MFA_PAGE_TITLE_TEXT_PTBR_KEY: 'Title of the MFA page in Portuguese',
    MFA_PAGE_SUBTITLE_TEXT_PTBR_KEY: 'Subtitle of the MFA page in Portuguese',
    MFA_FONT_SIZE_KEY: 'Font size of the MFA title',
    DESCRIPTION_MFA_FONT_SIZE_KEY: 'Font size of the MFA description',
    LOGIN_PAGE_TITLE_TEXT_EN_KEY: 'Title of the login page in English',
    LOGIN_PAGE_SUBTITLE_TEXT_EN_KEY: 'Subtitle of the login page in English',
    MFA_PAGE_TITLE_TEXT_EN_KEY: 'Title of the MFA page in English',
    MFA_PAGE_SUBTITLE_TEXT_EN_KEY: 'Subtitle of the MFA page in English',
    LOGIN_PAGE_TITLE_TEXT_ES_KEY: 'Title of the login page in Spanish',
    LOGIN_PAGE_SUBTITLE_TEXT_ES_KEY: 'Subtitle of the login page in Spanish',
    MFA_PAGE_TITLE_TEXT_ES_KEY: 'Title of the MFA page in Spanish',
    MFA_PAGE_SUBTITLE_TEXT_ES_KEY: 'Subtitle of the MFA page in Spanish',
    USER_NOT_SOFT_DELETED:
      'It is not possible to delete this user as it is linked to other clients.',
    APPLICATION_SERVER_KEY: 'Application server',
    SEE_MORE_KEY: '+ See more',
    SEE_LESS_KEY: '- See less',
    BENCHMARK_INSTANCES_KEY: 'Instance metrics',
    BENCHMARK_INTERVAL_KEY: 'Interval between metrics (in minutes):',
    BENCHMARK_DURATION_KEY: 'Duration of each metric (in seconds):',
    SECONDS_KEY: 'Seconds',
    BENCHMARK_DURATION_TOOLTIP_KEY:
      'Time, in seconds, that the verification routine will use to collect the information.',
    BENCHMARK_INTERVAL_TOOLTIP_KEY:
      'Interval, in minutes, that the system will wait before executing the instance processing capacity verification routine.',
    BENCHMARK_NULL_KEY: 'Status of metrics not available',
    MATRIX_KEY: 'Matrix:',
    LOW_PERFORMANCE_MATRIX_KEY: 'Up to 7.000 - Low Performance',
    MODERATE_PERFORMANCE_MATRIX_KEY: '7.001 to 11.000 - Moderate Performance',
    MODERATE_TO_HIGH_PERFORMANCE_MATRIX_KEY:
      '11.001 to 12. 500 - Moderate/High Performance',
    HIGH_PERFORMANCE_MATRIX_KEY: '12.501 to 30.000 - High Performance',
    LOW_PERFORMANCE_KEY: 'Low',
    MODERATE_PERFORMANCE_KEY: 'Moderate',
    MODERATE_TO_HIGH_PERFORMANCE_KEY: 'Moderate/High',
    HIGH_PERFORMANCE_KEY: 'High',
    BENCHMARK_INSTANCE_KEY: 'Instance metric',
    OPERATIONS_KEY: 'Operations',
    BENCHMARK_CONFIG_KEY: 'Performance analysis metric',
    INTERVAL_IN_MINUTES_KEY: 'Interval: {{interval}} minutes',
    PROCESS_TIME_KEY: 'Processing time: {{seconds}} seconds',
    BENCHMARK_DATE_AT_KEY: 'Metric performed at: {{date}}',
    PLATFORM_OLD_VERSION_KEY:
      'Platform version not compatible for metrics collection (>= 4.1.1.6)',
    SHOULD_APPLY_ADVISOR_AUTOMATICALLY_KEY: 'Apply advisor automatically',
    HIGH_RISK_ENVIRONMENT_KEY: 'High risk or special circumstances environment',
    HIGH_RISK_ENVIRONMENT_ALERT_KEY:
      'By enabling this option, the environment will be classified as high risk, which will prevent the automatic creation and application of advisors.',
    SHOULD_APPLY_ADVISOR_AUTOMATICALLY_DESCRIPTION_KEY:
      "Enables the automatic application of advisors according to users' use of the environment, with a focus on optimization and cost reduction.",
    SHOULD_APPLY_ADVISOR_AUTOMATICALLY_ALERT_KEY:
      'High-risk advisors require manual confirmation and will not be applied automatically.',
    HIGH_RISK_ENVIRONMENT_DESCRIPTION_KEY:
      'Enable this option to prevent advisors from being applied automatically.',
    SUGGEST_APPLY_ADVISOR_AUTOMATICALLY_TITLE_KEY:
      'Enable automatic application of advisors',
    SUGGEST_APPLY_ADVISOR_AUTOMATICALLY_DESCRIPTION_KEY:
      'Would you like to activate the automatic application of low and medium risk optimizations in this environment?',
    ADVISORS_CONFIGURATIONS_KEY: 'Advisors configurations',
    RISK_KEY: 'Risk',
    LOW_IMPACT_KEY: 'Low',
    MEDIUM_IMPACT_KEY: 'Medium',
    HIGH_IMPACT_KEY: 'High',
    DYNAMIC_ADVISOR_WEEKDAY_START_KEY: 'Weekly advisor start',
    DYNAMIC_ADVISOR_WEEKDAY_END_KEY: 'Weekly advisor end',
    MONTH_KEY: 'Month',
    ANNUAL_KEY: 'Annual',
    AUTOSKY_SYSTEM_KEY: 'Autosky system',
    SCALING_ADVISOR_REVERT_HISTORY_NOT_FOUND:
      'Advisor has no history stored to revert to',
    ADVISORS_HISTORY_KEY: 'Advisors history',
    ADVISORS_KEY: 'Advisors',
    CHECK_PASSWORD_HISTORY_KEY: 'Validate password history',
    CHECK_PASSWORD_COMPLEXITY_KEY: 'Validate password complexity',
    SECURE_DEVICE_VALIDATION_KEY: 'Secure device validation',
    ENABLE_DEVICE_VALIDATION_KEY: 'Enable device validation',
    DEVICE_VALIDATION_TOOLTIP_KEY:
      'Enables secure Token-based device authentication.',
    ADMIN_PIN_KEY: 'Admin Token',
    COPY_PIN_KEY: 'Copy Token',
    REGENERATE_PIN_KEY: 'Regenerate Token',
    GET_ADMINISTRATIVE_PIN: 'Get administrative Token',
    RESET_ADMINISTRATIVE_PIN: 'Regenerate administrative Token',
    DEVICE_VALIDATION_ENABLED_MESSAGE:
      'Secure device validation is active in this environment',
    DEVICE_VALIDATION_DISABLED_MESSAGE:
      'Secure device validation is inactive in this environment',
    SECURE_DEVICE_VALIDATION_AT_ENVIRONMENT_KEY:
      'Secure device validation at environment',
    PIN_COPIED_KEY: 'Token copied!',
    PIN_RESET_KEY: 'Token reset!',
    FORCE_RESET_PASSWORD_NEXT_LOGIN_KEY:
      'Force reset password in the next login',
    FORCE_RESET_PASSWORD_NEXT_LOGIN_DESCRIPTION_KEY:
      'User {{name}} will be required to reset their password on the next login',
    FORCE_RESET_PASSWORD_NEXT_LOGIN_SELECTED_KEY:
      'Force reset password in the next login',
    WANT_FORCE_RESET_PASSWORD_NEXT_LOGIN_SELECTED_KEY:
      'Do you wish to force password reset for selected users?',
    FORCE_RESET_PASSWORD_NEXT_LOGIN_SELECTED_DESCRIPTION_KEY:
      'Selected users will be required to reset their passwords on the next login',
    REMOVE_FORCE_RESET_PASSWORD_SELECTED_KEY: 'Remove force reset password',
    WANT_REMOVE_FORCE_RESET_PASSWORD_SELECTED_KEY:
      'Do you wish to remove force password reset for selected users?',
    REMOVE_FORCE_RESET_PASSWORD_SELECTED_DESCRIPTION_KEY:
      'Selected users will no longer be required to reset their passwords on the next login',
    REMOVE_FORCE_RESET_PASSWORD_NEXT_LOGIN_KEY:
      'Remove force reset password in the next login',
    REMOVE_FORCE_RESET_PASSWORD_NEXT_LOGIN_DESCRIPTION_KEY:
      'User {{name}} will no longer be required to reset their password on the next login',

    ACTIVE_FORCE_RESET_PASSWORD_SUCCESS_KEY:
      'The selected users are now required to change their password on the next login',
    INACTIVE_FORCE_RESET_PASSWORD_SUCCESS_KEY:
      'The selected users are no longer required to change their password on the next login',
    PASSWORD_CHANGE_REQUIRED_KEY:
      'The user must change their password on the next login',

    TRUSTED_DEVICES_KEY: 'Trusted devices',
    ENABLE_DEVICE_VALIDATION_BYPASS_KEY: 'Skip device validation',
    DISABLE_DEVICE_VALIDATION_BYPASS_KEY: 'Require device validation',
    ENABLE_DEVICE_VALIDATION_BYPASS_SUCCESS_KEY:
      'Device validation successfully skipped',
    DISABLE_DEVICE_VALIDATION_BYPASS_SUCCESS_KEY:
      'Device validation successfully required',
    ENABLE_DEVICE_VALIDATION_BYPASS_MODAL_TITLE_KEY:
      'Skip device validation for this user?',
    DISABLE_DEVICE_VALIDATION_BYPASS_MODAL_TITLE_KEY:
      'Require device validation for this user?',
    ENABLE_DEVICE_VALIDATION_BYPASS_MODAL_CONTENT_KEY:
      "By confirming, the user's device will not be validated at login.",
    DISABLE_DEVICE_VALIDATION_BYPASS_MODAL_CONTENT_KEY:
      'This user will be required to validate their device again upon login.',
    DEVICE_HASH_KEY: 'Hash',
    DEVICE_TYPE_KEY: 'Type',
    OPERATING_SYSTEM_KEY: 'Operating System',
    BROWSER_KEY: 'Browser',
    DISABLED_DEVICE_KEY: 'Disabled device',
    DELETE_TRUSTED_DEVICE_KEY: 'Disable device',
    CONFIRM_DELETE_TRUSTED_DEVICE_KEY: 'Do you want to disable the device?',
    CONFIRM_DELETE_TRUSTED_DEVICE_MESSAGE_KEY:
      'Are you sure you want to disable this trusted device? The user will need to re-authenticate on this device.',
    TRUSTED_DEVICE_DELETED_SUCCESSFULLY_KEY: 'Device disabled successfully!',
    ERROR_DELETING_TRUSTED_DEVICE_KEY:
      'Error disabling device. Please try again.',
    NO_TRUSTED_DEVICES_KEY: 'No devices found.',
    LAST_VALIDATED_IP_KEY: 'Last validated IP',
    EMAIL_PIN_VALIDATION_KEY: 'Email Token',
    ADM_PIN_VALIDATION_KEY: 'Administrator Token',
    ZERO_TRUST_ALLOWLIST_VALIDATION_KEY: 'Zero Trust allowlist',
    IP_HISTORY_VALIDATION_KEY: 'IP history',
    MFA_ACTIVE_TOOLTIP: 'MFA active',
    MFA_INACTIVE_TOOLTIP: 'MFA inactive',
    MFA_CONFIGURED_TOOLTIP: 'MFA configured',
    MFA_NOT_CONFIGURED_TOOLTIP: 'MFA not configured',
    SAFE_DEVICE_ENABLED_TOOLTIP: 'Has verified device',
    SAFE_DEVICE_DISABLED_TOOLTIP: 'No verified device',
    DEVICE_VALIDATION_BYPASS_ENABLED:
      'Device validation is being bypassed for this user.',
    PASSWORD_RESET_VALIDATION_KEY: 'Password registration',
    AUTO_REGISTER_NEXT_DEVICE_VALIDATION_KEY: 'Auto registration',
    SECURE_DEVICE_VALIDATION_TOOLTIP:
      'Enable this option to require secure device validation using the Administrative Token. This adds an extra layer of security to environment access.',
    CAN_ENABLE_SERVER_MONITORING_MANAGEMENT:
      'Enable server monitoring management',
    CAN_DISABLE_SERVER_MONITORING_MANAGEMENT:
      'Disable server monitoring management',
    ENABLE_SERVER_MONITORING_MANAGEMENT_INFO_TEXT_KEY:
      'Enables 24x7 monitoring management. When the server is turned on or off, monitoring will adjust automatically.',
    ENABLE_SERVER_MONITORING_MANAGEMENT_MODAL_TITLE_KEY:
      'Enable 24x7 monitoring management',
    ENABLE_SERVER_MONITORING_MANAGEMENT_MODAL_DESCRIPTION_KEY:
      'Do you want to enable 24x7 monitoring management for this server? When the server is turned on or off, monitoring will adjust automatically.',
    ENABLE_SERVER_MONITORING_MANAGEMENT_SUCCESSFULLY_KEY:
      'Server monitoring management successfully enabled!',
    DISABLE_SERVER_MONITORING_MANAGEMENT_MODAL_TITLE_KEY:
      'Disable 24x7 monitoring management',
    DISABLE_SERVER_MONITORING_MANAGEMENT_MODAL_DESCRIPTION_KEY:
      'Do you want to disable 24x7 monitoring management for this server? Monitoring will no longer adjust automatically when the server is turned on or off.',
    DISABLE_SERVER_MONITORING_MANAGEMENT_SUCCESSFULLY_KEY:
      'Server monitoring management successfully disabled!',
    CAN_VIEW_SERVER_MONITORING_STATUS: 'View server monitoring status',

    SERVER_MONITORING_STATUS: {
      DOWN_KEY: 'Unavailable',
      UP_KEY: 'Online',
      TROUBLE_KEY: 'With issues',
      CRITICAL_KEY: 'Critical issues',
      SUSPENDED_KEY: 'Suspended',
      MAINTENANCE_KEY: 'Under maintenance',
      DISCOVERY_KEY: 'Discovering',
      CONFIGURATION_ERROR_KEY: 'Configuration error',
      WITHOUT_MONITOR_KEY: 'No monitoring',
      UNAVAILABLE_KEY: 'No information',
    },
    STOPPING_KEY: 'Stopping...',
    USERNAME_REQUIRED_FOR_EXTERNAL_AD:
      'The AD Code field is required for external AD accounts.',
    MANAGED_EXTERNALLY:
      'Externally managed user. To change the password, contact your system administrator.',
    SUSPEND_MONITORING_ERROR: 'Error suspending server monitoring.',
    NO_AD_AUTH_TITLE: 'AD at authentication',
    USE_ENVIRONMENT_SETTING_KEY: 'Use environment setting',
    AUTH_WITHOUT_AD_KEY: 'Authentication without AD',
    AUTH_WITH_AD_KEY: 'Authentication with AD',
    AD_AUTH_CONFIG_KEY: 'Authentication configuration',
    PERFORMANCE_ANALYSIS_TITLE_KEY: 'Instance performance analysis',
    PERFORMANCE_ANALYSIS_SUBTITLE_KEY: 'Information is updated every minute',
    SEARCH_PLACEHOLDER_KEY: 'Search',
    CPU_CURRENT_KEY: 'Current CPU',
    CPU_AVERAGE_KEY: 'Average CPU',
    MEMORY_CURRENT_KEY: 'Current memory',
    SESSIONS_CURRENT_KEY: 'Current sessions',
    COLLECTION_TIME_KEY: 'Collection time',
    LIST_PARTNER_INSTANCES: 'List partner account instances',
    SHOW_INSTANCES_LIST_KEY: 'Show account instances list',
    ACTIVE_SALT_KEY: 'User with active salt',
    INACTIVE_SALT_KEY: 'User with inactive salt',
    DEVICE_VALIDATION_KEY: 'Environment with secure device validation',
    USER_MFA_ACTIVE_TOOLTIP: 'User with active MFA',
    USER_MFA_INACTIVE_TOOLTIP: 'User with inactive MFA',
    COPY_INFORMATION_KEY: 'Copy information',
    LIST_CLIENT_CERTIFICATES: 'List digital certificates',
    CAN_MANAGE_CLIENT_CERTIFICATES: 'Manage digital certificates',
    CREATE_DIGITAL_CERTIFICATE_KEY: 'Create certificate',
    EDIT_DIGITAL_CERTIFICATE_KEY: 'Edit certificate',
    DELETE_DIGITAL_CERTIFICATE_KEY: 'Delete certificate',

    DIGITAL_CERTIFICATE_PATH_KEY: 'Certificate path',
    CONFIRM_DELETE_DIGITAL_CERTIFICATE_KEY:
      'Are you sure you want to delete the digital certificate',

    DIGITAL_CERTIFICATE_CREATED_SUCCESSFULLY_KEY:
      'Digital certificate created successfully.',
    DIGITAL_CERTIFICATE_EDITED_SUCCESSFULLY_KEY:
      'Digital certificate updated successfully.',
    DIGITAL_CERTIFICATE_DELETED_SUCCESSFULLY_KEY:
      'Digital certificate deleted successfully.',
    LEAKED_CREDENTIALS_KEY: 'Leaked credentials',
    LIST_LEAKED_CREDENTIALS: 'List users with leaked credentials',
    LEAKED_CREDENTIALS_SUBTITLE_KEY: 'Listing of users with leaked credentials',
    FORCE_RESET_PASSWORD_KEY: 'Force password reset',
    RESET_LEAKED_CREDENTIALS_USER_PASSWORD:
      'Reset password of users with leaked credentials',
    SESSION_REMOVAL_MAX_LIMIT_KEY: 'Maximum session limit',
    SESSION_REMOVAL_MESSAGE_KEY: 'Session removal message',
    IS_SESSION_REMOVAL_ENABLED_KEY: 'Enable session removal',
    REMOVE_SESSIONS_TOOLTIP_KEY:
      'Sets the maximum number of active sessions an instance can have to be considered for removal. Sessions will only be removed from instances that have up to this limit.',
    PASSWORD_RESET_KEY: 'Password reset',
    ADMIN_NOTIFIED_KEY: 'Administrator notified',
    LIST_LEAKED_CREDENTIALS_CLIENTS:
      'List clients of users with leaked credentials',
    SSO_ACTIVE_KEY: 'SSO active',
    CONFIRM_RESET_PASSWORD_KEY:
      'Do you want to force the user to reset their password?',
    FORCE_RESET_SELECTED_KEY: 'Force password reset for selected users',
    SOLICITED_PASSWORD_RESET_KEY: 'Password reset requested!',
    CONFIRM_MULTIPLE_RESET_PASSWORD_KEY:
      'Do you want to force the selected users to reset their password?',
    REMOVE_USER_SESSIONS_KEY: 'Instances and sessions drainage',
    REMOVE_SESSIONS_TIME_KEY: 'Draining schedule',
    EDIT_ENV_SESSION_REMOVAL_INSTANCES:
      'Configure instance and session drainage',
    LIST_ENV_SESSION_REMOVAL_INSTANCES:
      'View instance and session drainage details',
  },
};
